webpackJsonp([0],{

/***/ "+28e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Plan',
  data: function data() {
    return {
      orderID: 0,
      Valid: '',
      selectTime1: '',
      selectTime2: '',
      selectTime3: '',
      selectTime4: '',
      startTime: '',
      endTime: '',
      deviceColumns1: [{ title: this.$t('data.Order.orderNo'), key: 'orderNo' }, { title: this.$t('data.Order.productNo'), key: 'productNo' }, { title: this.$t('data.Order.collectorName'), key: 'collectorName' }, { title: this.$t('data.Order.status'), key: 'status' }, { title: this.$t('data.Order.salesman'), key: 'salesman' }, { title: this.$t('data.Order.customer'), key: 'customer' }, { title: this.$t('data.Order.ordersTime'), key: 'ordersTime' }, { title: this.$t('data.Order.productTime'), key: 'productTime' }, { title: this.$t('data.Order.num'), key: 'num' }, { title: this.$t('data.Order.output'), key: 'output' }, { title: this.$t('data.Order.target'), key: 'target' }, { title: this.$t('data.Order.unit'), key: 'unit' }, { title: this.$t('data.Order.deliveryTime'), key: 'deliveryTime' }],
      deviceColumns2: [{ title: this.$t('data.Order.orderNo'), key: 'orderNo' }, { title: this.$t('data.Order.productNo'), key: 'productNo' }, { title: this.$t('data.Order.collectorName'), key: 'collectorName' }, { title: this.$t('data.Device.date'), key: 'date' },
      // { title: this.$t('data.Order.salesman'), key: 'salesman' },
      // { title: this.$t('data.Order.customer'), key: 'customer' },
      // { title: this.$t('data.Order.ordersTime'), key: 'ordersTime' },
      // { title: this.$t('data.Order.productTime'), key: 'productTime' },
      // { title: this.$t('data.Order.num'), key: 'num' },
      { title: this.$t('data.Order.output'), key: 'output' },
      // { title: this.$t('data.Order.target'), key: 'target' },
      { title: this.$t('data.Order.unit'), key: 'unit'
        // { title: this.$t('data.Order.deliveryTime'), key: 'deliveryTime' }
      }],
      orderList: [],
      orderDatas1: [],
      orderDatas2: [],
      worktime: '',
      loading: false
    };
  },

  methods: {
    getData: function getData(tp) {
      var _this = this;

      this.loading = true;
      if (tp === 1) {
        var time1 = this.selectTime1;
        var time2 = this.selectTime2;
        if (time1 === '' || time2 === '') {
          var title = this.$t('Order.error');
          var content = this.$t('data.Device.please_enter_date');
          this.$Modal.error({
            title: title,
            content: content
          });
          return;
        }
        if (this.selectTime1 !== '' && this.selectTime2 !== '') {
          this.selectTime2 = new Date(new Date(this.selectTime2).getTime() + 1 * 24 * 60 * 60 * 1000);
          this.selectTime2 = this.selectTime2.getFullYear() + '-' + (this.selectTime2.getMonth() + 1) + '-' + this.selectTime2.getDate();
          this.selectTime1 = this.selectTime1 + ' ' + this.worktime;
          this.selectTime2 = this.selectTime2 + ' ' + this.worktime;
        }
        var req = { orderID: this.orderID, startTime: this.selectTime1, endTime: this.selectTime2 };
        this.selectTime1 = time1;
        this.selectTime2 = time2;
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].data.orderData(req).then(function (res) {
          _this.loading = false;
          _this.orderDatas1 = res.datas;
          var d = [];
          var j = 0;
          for (var i = 0; i < _this.orderDatas1.length; i++) {
            _this.orderDatas1[i].target = (_this.orderDatas1[i].num / _this.orderDatas1[i].SumRow * _this.orderDatas1[i].row).toFixed(2);
            if (_this.orderDatas1[i].unit === 1) {
              _this.orderDatas1[i].unit = _this.$t('data.Order.Meter');
            } else if (_this.orderDatas1[i].unit === 2) {
              _this.orderDatas1[i].unit = _this.$t('data.Order.Yard');
              _this.orderDatas1[i].output = _this.orderDatas1[i].output * 1.0936;
              _this.orderDatas1[i].output = _this.orderDatas1[i].output.toFixed(0);
            } else if (_this.orderDatas1[i].unit === 3) {
              _this.orderDatas1[i].unit = _this.$t('data.Order.Gross');
              _this.orderDatas1[i].output = _this.orderDatas1[i].output / (144.0 * 0.9144);
              _this.orderDatas1[i].output = _this.orderDatas1[i].output.toFixed(0);
            }
            if (_this.orderDatas1[i].collectorName === '') {
              _this.orderDatas1[i].status = _this.$t('data.Order.No_scheduling');
            } else if (_this.orderDatas1[i].collectorName !== '' && _this.orderDatas1[i].productTime === '') {
              _this.orderDatas1[i].status = _this.$t('data.Order.Not_production');
            } else if (_this.orderDatas1[i].productTime !== '' && _this.orderDatas1[i].valid === 1) {
              _this.orderDatas1[i].status = _this.$t('data.Order.Producting');
            } else if (_this.orderDatas1[i].productTime !== '' && _this.orderDatas1[i].valid === 0) {
              _this.orderDatas1[i].status = _this.$t('data.Order.Case_closed');
            }
            if (_this.Valid === '1') {
              if (_this.orderDatas1[i].collectorName === '') {
                _this.orderDatas1[i].status = _this.$t('data.Order.No_scheduling');
                d[j] = _this.orderDatas1[i];
                j++;
              }
            } else if (_this.Valid === '2') {
              if (_this.orderDatas1[i].collectorName !== '' && _this.orderDatas1[i].productTime === '') {
                _this.orderDatas1[i].status = _this.$t('data.Order.Not_production');
                d[j] = _this.orderDatas1[i];
                j++;
              }
            } else if (_this.Valid === '3') {
              if (_this.orderDatas1[i].productTime !== '' && _this.orderDatas1[i].valid === 1) {
                _this.orderDatas1[i].status = _this.$t('data.Order.Producting');
                d[j] = _this.orderDatas1[i];
                j++;
              }
            } else if (_this.Valid === '4') {
              if (_this.orderDatas1[i].productTime !== '' && _this.orderDatas1[i].valid === 0) {
                _this.orderDatas1[i].status = _this.$t('data.Order.Case_closed');
                d[j] = _this.orderDatas1[i];
                j++;
              }
            }
          }
          if (_this.Valid === '1' || _this.Valid === '2' || _this.Valid === '3' || _this.Valid === '4') {
            _this.orderDatas1 = d;
          }
        });
      } else {
        var _req = { orderID: this.orderID, startTime: this.startTime + ':00', endTime: this.endTime + ':00', startDate: this.selectTime3, endDate: this.selectTime4 };
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].data.orderDayData(_req).then(function (res) {
          _this.loading = false;
          _this.orderDatas2 = res.datas;
          for (var i = 0; i < _this.orderDatas2.length; i++) {
            if (_this.orderDatas2[i].unit === 1) {
              _this.orderDatas2[i].unit = _this.$t('data.Order.Meter');
              _this.orderDatas2[i].output = _this.orderDatas2[i].output.toFixed(2);
            } else if (_this.orderDatas2[i].unit === 2) {
              _this.orderDatas2[i].unit = _this.$t('data.Order.Yard');
              _this.orderDatas2[i].output = _this.orderDatas2[i].output * 1.0936;
              _this.orderDatas2[i].output = _this.orderDatas2[i].output.toFixed(2);
            } else if (_this.orderDatas2[i].unit === 3) {
              _this.orderDatas2[i].unit = _this.$t('data.Order.Gross');
              _this.orderDatas2[i].output = _this.orderDatas2[i].output / (144.0 * 0.9144);
              _this.orderDatas2[i].output = _this.orderDatas2[i].output.toFixed(2);
            }
          }
        });
      }
    },

    // dateChange (t) {
    //   this.selectTime = t
    // },
    exportData: function exportData(tp) {
      if (tp === 1) {
        this.$refs.table.exportCsv({
          filename: this.$t('data.Order.Order_report'),
          original: false
        });
      } else {
        this.$refs.table1.exportCsv({
          filename: this.$t('data.Order.Order_report'),
          original: false
        });
      }
    },
    entryTimeChange1: function entryTimeChange1(v) {
      this.selectTime1 = v;
    },
    entryTimeChange2: function entryTimeChange2(v) {
      this.selectTime2 = v;
    },
    entryTimeChange3: function entryTimeChange3(v) {
      this.selectTime3 = v;
    },
    entryTimeChange4: function entryTimeChange4(v) {
      this.selectTime4 = v;
    },
    entryTimeChange5: function entryTimeChange5(v) {
      this.startTime = v;
    },
    entryTimeChange6: function entryTimeChange6(v) {
      this.endTime = v;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].order.list().then(function (res) {
      _this2.orderList = res.orderInfos;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workTime.list().then(function (res) {
      _this2.worktime = res.workTimes[0].startTime;
      // console.log(this.worktime)
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next();
  }
});

/***/ }),

/***/ "+fjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Setting',
  data: function data() {
    return {
      username: '',
      qr: '',
      name: '',
      workNo: '',
      department: '0',
      workPosition: '',
      role: '',
      phone: '',
      eMail: '',
      qq: '',
      wechat: '',
      company: '',
      departmenID: '',
      roleID: '',
      id: 0,
      language: ''
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      var account = void 0;
      account = {
        id: this.id,
        username: this.username,
        name: this.name,
        workNo: this.workNo,
        department: Number(this.departmentID),
        role: Number(this.roleID),
        phone: this.phone,
        eMail: this.eMail,
        qq: this.qq,
        wechat: this.wechat,
        language: this.language
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].account.save(account).then(function () {
        _this.$router.push({ 'name': 'Index' });
      });
    },
    Changelanguage: function Changelanguage(v) {
      localStorage.language = v;
      this.$i18n.locale = v;
    }
  },
  mounted: function mounted() {
    // Api.department.list().then(res => {
    //   this.departmentlist = res.departments
    // })
    // Api.role.list().then(res => {
    //   this.rolelist = res.roles
    // })
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      next(function (vm) {
        vm.id = res.user.id;
        vm.username = res.user.username;
        vm.name = res.user.name;
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].account.get(vm.id).then(function (res1) {
          vm.workNo = res1.account.workNo;
          vm.phone = res1.account.phone;
          vm.eMail = res1.account.eMail;
          vm.qq = res1.account.qq;
          vm.wechat = res1.account.wechat;
          vm.roleID = res1.account.role;
          // vm.departmenID = res1.account.department
          __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].role.get(res1.account.role).then(function (res2) {
            vm.role = res2.role.name;
          });
          // Api.department.get(res1.account.department).then(res3 => {
          //   vm.department = res3.department.name
          // })
          __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].system.get(res1.account.company).then(function (res3) {
            vm.company = res3.company.name;
          });
          vm.language = res1.account.language;
          vm.qr = res1.account.username + ',' + res1.account.password + ',' + res1.account.systemcode;
        });
      });
    });
  }
});

/***/ }),

/***/ "+oTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+rlU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_vue__ = __webpack_require__("+28e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4c093b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_order_vue__ = __webpack_require__("EwOO");
function injectStyle (ssrContext) {
  __webpack_require__("XgKt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4c093b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_order_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/4Zz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-page"},[_c('Table',{staticClass:"account-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Sng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var collector = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/collector/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'xt-01', deviceNo: '443234', type: 'xxx', computeType: 'xxxx', length: 30, count: 12, width: 20, deviceCompany: 'HECCI', deviceModel: 'GE-100', buyTime: '2017-08-20', deviceLifeTime: 20},
    //     {id: 1, name: 'xt-02', deviceNo: '234456', type: 'xxx', computeType: 'xxxx', length: 30, count: 12, width: 20, deviceCompany: 'HECCI', deviceModel: 'GE-100', buyTime: '2017-08-20', deviceLifeTime: 20}
    //   ]
    //   resolve(data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collector/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collector/get', { id: id });
  },
  save: function save(c) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collector/save', c);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (collector);

/***/ }),

/***/ "/a//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/e6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEdit_vue__ = __webpack_require__("JnBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f86c8f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AccountEdit_vue__ = __webpack_require__("uoYT");
function injectStyle (ssrContext) {
  __webpack_require__("K9jQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f86c8f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f86c8f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AccountEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0X9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__ = __webpack_require__("uxe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41086b2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__ = __webpack_require__("njEy");
function injectStyle (ssrContext) {
  __webpack_require__("rnhk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41086b2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41086b2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "19nU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");


var permission = {
  state: {
    permissions: {},
    permissionsInited: false
  },
  mutations: {
    SET_PERMISSION: function SET_PERMISSION(state, permissions) {
      state.permissions = permissions;
      state.permissionsInited = true;
    }
  },
  actions: {
    InitPermissions: function InitPermissions(_ref) {
      var commit = _ref.commit;

      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].permission.permissionList().then(function (permissions) {
        commit('SET_PERMISSION', permissions);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ "1PeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('Order.Return_to_Order_list')))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",staticStyle:{"border-bottom-style":"solid"},attrs:{"label-width":100,"inline":"","model":_vm.formValidate,"rules":_vm.ruleValidate}},[_c('Row',[_c('i-Col',{attrs:{"span":"6"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.orderNo'),"prop":"orderNo"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Order.please_enter')},model:{value:(_vm.formValidate.orderNo),callback:function ($$v) {_vm.$set(_vm.formValidate, "orderNo", $$v)},expression:"formValidate.orderNo"}})],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"6"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.ordersTime'),"prop":"ordersTime"}},[_c('DatePicker',{staticClass:"info",attrs:{"type":"date","value":_vm.formValidate.ordersTime,"placeholder":_vm.$t('Order.please_enter_date')},on:{"on-change":_vm.ordersTimeChange}})],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"6"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.customer')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Order.please_enter')},model:{value:(_vm.formValidate.customer),callback:function ($$v) {_vm.$set(_vm.formValidate, "customer", $$v)},expression:"formValidate.customer"}})],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"6"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.salesman')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Order.please_enter')},model:{value:(_vm.formValidate.salesman),callback:function ($$v) {_vm.$set(_vm.formValidate, "salesman", $$v)},expression:"formValidate.salesman"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"right-side side"},[_c('Row',{staticClass:"search-area"},[_c('Input',{attrs:{"type":"text","placeholder":_vm.$t('Order.search')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1)],1),_vm._v(" "),_c('Table',{staticClass:"product-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.products},on:{"on-current-change":_vm.productSelect}})],1),_vm._v(" "),_c('div',{staticClass:"left-side side"},[_c('Card',[_c('Form',{staticClass:"edit-product-form",attrs:{"label-width":60,"inline":""}},[_c('p',[_vm._v(_vm._s(_vm.currentSelect.productNo)+"/"+_vm._s(_vm.currentSelect.name))]),_vm._v(" "),_c('Row',[_c('i-Col',{attrs:{"span":"7"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.num')}},[_c('Input',{staticClass:"info",attrs:{"size":"small","placeholder":_vm.$t('Order.please_enter')},model:{value:(_vm.currentSelect.num),callback:function ($$v) {_vm.$set(_vm.currentSelect, "num", $$v)},expression:"currentSelect.num"}})],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"7"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.unit')}},[_c('Select',{staticClass:"info",attrs:{"size":"small","value":_vm.currentUnit},model:{value:(_vm.currentSelect.currentUnit),callback:function ($$v) {_vm.$set(_vm.currentSelect, "currentUnit", $$v)},expression:"currentSelect.currentUnit"}},[_c('Option',{key:"1",attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('Order.Meter')))]),_vm._v(" "),_c('Option',{key:"2",attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('Order.Yard')))]),_vm._v(" "),_c('Option',{key:"3",attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('Order.Gross')))])],1)],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"9"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.deliveryTime')}},[_c('DatePicker',{staticClass:"info",attrs:{"type":"date","value":_vm.currentDeliveryTime,"placeholder":_vm.$t('Order.please_enter_date')},on:{"on-change":_vm.deliveryTimeChange}})],1)],1)],1),_vm._v(" "),_c('Row',[_c('i-Col',{attrs:{"span":"7"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.attritionRate')}},[_c('Input',{staticClass:"info",attrs:{"size":"small","placeholder":_vm.$t('Order.please_enter')},model:{value:(_vm.currentSelect.attritionRate),callback:function ($$v) {_vm.$set(_vm.currentSelect, "attritionRate", $$v)},expression:"currentSelect.attritionRate"}})],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"7"}},[_c('FormItem',{attrs:{"label":_vm.$t('Order.remark')}},[_c('Input',{staticClass:"info",attrs:{"size":"small","placeholder":_vm.$t('Order.please_enter')},model:{value:(_vm.currentSelect.remark),callback:function ($$v) {_vm.$set(_vm.currentSelect, "remark", $$v)},expression:"currentSelect.remark"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.add()}}},[_vm._v(_vm._s(_vm.$t('Order.add')))])],1)],1)],1),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"inline":""}},[_c('p',{staticClass:"order-product-title"},[_vm._v(_vm._s(_vm.$t('Order.Product_list')))]),_vm._v(" "),_c('Table',{staticClass:"order-product-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.orderProductColumns,"data":_vm.orderProduct}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('Order.save')))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"bottom-side"})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1ffi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("bwdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262ef871_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("w61F");
function injectStyle (ssrContext) {
  __webpack_require__("66+d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262ef871_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1qbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("asca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64625537_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("xelB");
function injectStyle (ssrContext) {
  __webpack_require__("zszO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64625537"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64625537_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2++O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("y13K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5302e8dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Kyfm");
function injectStyle (ssrContext) {
  __webpack_require__("tNSG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5302e8dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5302e8dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "25Pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-page"},_vm._l((_vm.datas),function(order){return _c('Card',{key:order.orderID,staticClass:"order-card"},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_c('Row',[_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('plan.Order.orderNo'))+":"+_vm._s(order.orderNo))]),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('plan.Order.customer'))+":"+_vm._s(order.customer))]),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('plan.Order.ordersTime'))+":"+_vm._s(order.ordersTime))]),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('plan.Order.salesman'))+":"+_vm._s(order.salesman))])],1)],1),_vm._v(" "),_c('Table',{staticClass:"order-table",attrs:{"size":"small","highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":order.orderProducts}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Sxa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NavBar',
  data: function data() {
    return {
      logo: __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default.a
    };
  },

  computed: {
    username: function username() {
      return this.$store.getters.userName;
    }
  },
  methods: {
    logout: function logout() {
      console.log('logout');
      localStorage.removeItem('bearer');
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('RemoveUser');
      this.$router.push({ name: 'Login' });
    },
    changePw: function changePw() {
      this.$router.push({ name: 'ChangePw' });
    }
  }
});

/***/ }),

/***/ "2jAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collector_vue__ = __webpack_require__("a5/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1fbe54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Collector_vue__ = __webpack_require__("W1Nd");
function injectStyle (ssrContext) {
  __webpack_require__("9UWj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f1fbe54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1fbe54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Collector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ju2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Order',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('Maintain.index'), width: 65 }, { title: this.$t('Maintain.DeviceName'), key: 'DeviceName' }, { title: this.$t('Maintain.username'), key: 'username' }, { title: this.$t('Maintain.startTime'), key: 'startTime' }, { title: this.$t('Maintain.endTime'), key: 'endTime' }, { title: this.$t('Maintain.remark'), key: 'remark' }, {
        title: this.$t('Maintain.action'),
        key: 'action',
        width: 125,
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function click() {
                _this.edit(params.index);
              }
            }
          }, _this.$t('Maintain.edit'))]);
        }
      }],
      search1: '',
      search2: '',
      selectTime1: '',
      selectTime2: '',
      datas: [],
      datasList: [],
      devices: [],
      people: [],
      loading: false
    };
  },

  computed: {},
  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : this.datas[index].id;
      this.$router.push({ name: 'MaintainEdit', params: { id: id } });
    },
    handleSearch: function handleSearch() {
      this.loading = true;
      this.datas = [];
      var d1 = [];
      var d2 = [];
      var d3 = [];
      if (this.search1 !== '') {
        for (var i = 0; i < this.datasList.length; i++) {
          if (this.datas[i].DeviceName.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
            d1.push(this.datasList[i]);
          }
        }
      } else {
        d1 = this.datasList;
      }
      if (this.search2 !== '') {
        for (var _i = 0; _i < d1.length; _i++) {
          if (d1[_i].username.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
            d2.push(d1[_i]);
          }
        }
      } else {
        d2 = d1;
      }
      if (this.selectTime1 !== '') {
        var timestamp = new Date(this.selectTime1).getTime();
        for (var _i2 = 0; _i2 < d2.length; _i2++) {
          if (timestamp <= d2[_i2].timestamp) {
            d3.push(d2[_i2]);
          }
        }
      } else {
        d3 = d2;
      }
      if (this.selectTime2 !== '') {
        var _timestamp = new Date(this.selectTime2).getTime();
        for (var _i3 = 0; _i3 < d3.length; _i3++) {
          if (_timestamp >= d3[_i3].timestamp) {
            this.datas.push(d3[_i3]);
          }
        }
      } else {
        this.datas = d3;
      }
      this.loading = false;
    },
    handleReset: function handleReset() {
      this.selectTime1 = '';
      this.selectTime2 = '';
      this.search1 = '';
      this.search2 = '';
      this.datas = this.datasList;
    },
    entryTimeChange1: function entryTimeChange1(v) {
      this.selectTime1 = v;
    },
    entryTimeChange2: function entryTimeChange2(v) {
      this.selectTime2 = v;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collector.list().then(function (res) {
      _this2.devices = res.collectors;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].people.list().then(function (res) {
      _this2.people = res.accounts;
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].maintain.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.maintains;
        vm.datasList = res.maintains;
        for (var i = 0; i < vm.datas.length; i++) {
          var timestamp = new Date(vm.datas[i].startTime).getTime();
          vm.datas[i].timestamp = timestamp;
          vm.datasList[i].timestamp = timestamp;
        }
      });
    });
  }
});

/***/ }),

/***/ "3BQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-page"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('Product.New_Product')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('Product.New_Product')))]):_vm._e(),_vm._v(" "),_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.productNo')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1),_vm._v(" "),_c('Table',{staticClass:"product-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3m27":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "40qf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4dEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");




var Axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: '/v1',
  timeout: 10000
});

Axios.interceptors.request.use(function (config) {
  if (localStorage.bearer) {
    config.headers.Authorization = 'Bearer ' + localStorage.bearer;
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

Axios.interceptors.response.use(function (res) {
  if (res.data.errCode !== 0) {
    if (res.data.errCode === 40001 || res.data.errCode === 40005) {
      localStorage.removeItem('bearer');
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({ path: '/login' });
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
  }
  return res.data;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
});

/* harmony default export */ __webpack_exports__["a"] = (Axios);

// export default {
//   install (Vue) {
//     Object.defineProperty(Vue.prototype, '$http', { value: Axios })
//   }
// }

/***/ }),

/***/ "4lUq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4oGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('Card.Return_to_Card_list')))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":"100"}},[_c('FormItem',{attrs:{"label":_vm.$t('Card.cardNo')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Card.please_enter')},model:{value:(_vm.cardNo),callback:function ($$v) {_vm.cardNo=$$v},expression:"cardNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Card.workTypeName')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.workType},model:{value:(_vm.workType),callback:function ($$v) {_vm.workType=$$v},expression:"workType"}},_vm._l((_vm.workTypeList),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Card.userName')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.userID,"filterable":""},model:{value:(_vm.userID),callback:function ($$v) {_vm.userID=$$v},expression:"userID"}},_vm._l((_vm.userList),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('Card.save')))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4v4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var collector = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/collectorGroup/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'group1', collectors: [1], remark: ''}
    //   ]
    //   resolve(data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collectorGroup/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collectorGroup/get', { id: id });
  },
  save: function save(c) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collectorGroup/save', c);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (collector);

/***/ }),

/***/ "54ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"people-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("People.Return_to_People_list")))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('FormItem',{attrs:{"label":_vm.$t('People.workNo')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('People.please_enter')},model:{value:(_vm.workNo),callback:function ($$v) {_vm.workNo=$$v},expression:"workNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.name')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('People.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.sex')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.sex},model:{value:(_vm.sex),callback:function ($$v) {_vm.sex=$$v},expression:"sex"}},[_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v("男")]),_vm._v(" "),_c('Option',{key:Number(2),attrs:{"value":Number(2)}},[_vm._v("女")])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.phone')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('People.please_enter')},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.entryTime')}},[_c('DatePicker',{staticClass:"info",attrs:{"value":_vm.entryTime,"placeholder":_vm.$t('People.please_enter_date')},on:{"on-change":_vm.entryTimeChange}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.qq')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('People.please_enter')},model:{value:(_vm.qq),callback:function ($$v) {_vm.qq=$$v},expression:"qq"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.wechat')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('People.please_enter')},model:{value:(_vm.wechat),callback:function ($$v) {_vm.wechat=$$v},expression:"wechat"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('People.working')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.working},model:{value:(_vm.working),callback:function ($$v) {_vm.working=$$v},expression:"working"}},[_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t("People.yes")))]),_vm._v(" "),_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t("People.no")))])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("People.save")))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5KMW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5R8L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5XFP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var monitor = {
  collectors: function collectors() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/collectorMonitor/list');
  },
  producting: function producting(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/board/getProducting', id);
  },
  orders: function orders() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/orderMonitor/list');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (monitor);

/***/ }),

/***/ "5XvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var workType = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/workType/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: '调机', outputValid: 0, monopoly: 1, maintain: 0, warn: 0, remark: ''},
    //     {id: 2, name: '穿纱', outputValid: 0, monopoly: 0, maintain: 0, warn: 0, remark: ''},
    //     {id: 3, name: '看机', outputValid: 1, monopoly: 1, maintain: 0, warn: 1, remark: ''},
    //     {id: 4, name: '维修', outputValid: 0, monopoly: 1, maintain: 1, warn: 0, remark: ''}
    //   ]
    //   resolve(data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/workType/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/workType/get', { id: id });
  },
  save: function save(wt) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/workType/save', wt);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (workType);

/***/ }),

/***/ "5eCs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ybE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var department = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/department/list');
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/department/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/department/get', { id: id });
  },
  save: function save(r) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/department/save', r);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (department);

/***/ }),

/***/ "6+8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logo}})])]),_vm._v(" "),_c('div',{staticClass:"sub-menu"},[_c('Dropdown',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',[_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('Icon',{attrs:{"type":"arrow-down-b"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"list"},slot:"list"},[_c('router-link',{attrs:{"to":"/setting/index"}},[_c('DropdownItem',[_vm._v(_vm._s(_vm.$t("Login.Information")))])],1),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.changePw()}}},[_c('DropdownItem',[_vm._v(_vm._s(_vm.$t("Login.changePw")))])],1),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.logout()}}},[_c('DropdownItem',{attrs:{"divided":""}},[_vm._v(_vm._s(_vm.$t("Login.logout")))])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "66+d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6pD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin_js__ = __webpack_require__("4dEq");


var people = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin_js__["a" /* default */].get('/people/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, username: 'admin', name: 'DaviaLi', sex: 1, workType: [1, 2], workNo: '123456', role: 'admin', phone: '12345678901', qq: '12345678', wechat: 'xxxxx', entryTime: '2017-01-01'}
    //   ]
    //   resolve(data)
    // })
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin_js__["a" /* default */].post('/people/get', { id: id });
    // return Promise.resolve({id: 1, username: 'admin', name: 'DaviaLi', sex: 1, workType: [1, 2], workNo: '123456', role: 'admin', phone: '12345678901', qq: '12345678', wechat: 'xxxxx', entryTime: '2017-01-01'})
  },
  save: function save(p) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin_js__["a" /* default */].post('/people/save', p);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (people);

/***/ }),

/***/ "71wU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-page"},[_c('el-table',{staticClass:"account-table",attrs:{"highlight-row":"","stripe":"","border":"","data":_vm.datas}},[_c('el-table-column',{attrs:{"type":"index","label":_vm.$t('device.router.index'),"width":"65px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('monitor.Collector.status1'),"width":"95px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{class:scope.row.online === 1 ? 'dot green' : 'dot gray'})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AnotherName","label":_vm.$t('device.router.AnotherName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('device.router.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"channel","label":_vm.$t('device.router.channel')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"localAddr","label":"Local IP"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","label":_vm.$t('device.router.remark')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('device.router.action'),"width":"100px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.permissions === true)?_c('el-button',{attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){_vm.edit(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('device.router.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"primary","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('device.router.edit')))]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7HmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-page"},[_c('Row',[_c('Col',{staticStyle:{"padding":"0 5px"},attrs:{"span":"13"}},[_c('Row',[_c('i-Col',{attrs:{"span":"5"}},[_c('Input',{staticClass:"search",attrs:{"placeholder":_vm.$t('plan.Production.collectorName')},model:{value:(_vm.search1),callback:function ($$v) {_vm.search1=$$v},expression:"search1"}})],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"8"}},[_c('Input',{staticClass:"search",attrs:{"placeholder":_vm.$t('plan.Production.orderNo')},model:{value:(_vm.search2),callback:function ($$v) {_vm.search2=$$v},expression:"search2"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.planSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.planReset()}},slot:"append"})],1)],1)],1),_vm._v(" "),_c('Table',{staticClass:"collector-table",attrs:{"size":"small","highlight-row":"","stripe":"","border":"","columns":_vm.planColumns,"data":_vm.planDatas}})],1),_vm._v(" "),_c('Col',{staticStyle:{"padding":"0 5px"},attrs:{"span":"11"}},[_c('Row',[_c('Col',{attrs:{"span":"8"}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":80}},[_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.orderNo')}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.please_enter'),"disabled":""},model:{value:(_vm.currentOrder.orderNo),callback:function ($$v) {_vm.$set(_vm.currentOrder, "orderNo", $$v)},expression:"currentOrder.orderNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.num')}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.please_enter'),"disabled":""},model:{value:(_vm.currentOrder.num),callback:function ($$v) {_vm.$set(_vm.currentOrder, "num", $$v)},expression:"currentOrder.num"}})],1)],1)],1),_vm._v(" "),_c('Col',{attrs:{"span":"8"}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":80}},[_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.productNo')}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.please_enter'),"disabled":""},model:{value:(_vm.currentOrder.productNo),callback:function ($$v) {_vm.$set(_vm.currentOrder, "productNo", $$v)},expression:"currentOrder.productNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.deliveryTime')}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.please_enter'),"disabled":""},model:{value:(_vm.currentOrder.deliveryTime),callback:function ($$v) {_vm.$set(_vm.currentOrder, "deliveryTime", $$v)},expression:"currentOrder.deliveryTime"}})],1)],1)],1),_vm._v(" "),_c('Col',{attrs:{"span":"8"}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":80}},[_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.productName')}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.please_enter'),"disabled":""},model:{value:(_vm.currentOrder.name),callback:function ($$v) {_vm.$set(_vm.currentOrder, "name", $$v)},expression:"currentOrder.name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.name')}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.please_enter'),"disabled":""},model:{value:(_vm.currentCollector.name),callback:function ($$v) {_vm.$set(_vm.currentCollector, "name", $$v)},expression:"currentCollector.name"}})],1)],1)],1)],1),_vm._v(" "),_c('Tabs',{staticClass:"custom-tabs",attrs:{"value":_vm.Steps},on:{"on-click":_vm.TabRest}},[_c('TabPane',{attrs:{"label":_vm.$t('plan.Production.chooose_order'),"name":"1"}},[_c('Row',{staticClass:"search-area"},[_c('i-Col',{attrs:{"span":"6"}},[_c('Select',{attrs:{"value":_vm.Valid},model:{value:(_vm.Valid),callback:function ($$v) {_vm.Valid=$$v},expression:"Valid"}},[_c('Option',{key:"1",attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('plan.Production.No_scheduling')))]),_vm._v(" "),_c('Option',{key:"2",attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('plan.Production.Not_production')))]),_vm._v(" "),_c('Option',{key:"3",attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('plan.Production.Producting')))])],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"14"}},[_c('Input',{attrs:{"placeholder":_vm.$t('plan.Production.orderNo')},model:{value:(_vm.searchOrder),callback:function ($$v) {_vm.searchOrder=$$v},expression:"searchOrder"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch(1)}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset(1)}},slot:"append"})],1)],1)],1),_vm._v(" "),_vm._l((_vm.orderDatas),function(order){return _c('Card',{key:order.orderID,staticClass:"order-card"},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_c('Row',[_c('Col',{attrs:{"span":"15"}},[_vm._v(_vm._s(_vm.$t('plan.Production.orderNo'))+": "+_vm._s(order.orderNo))])],1)],1),_vm._v(" "),_c('Table',{staticClass:"order-table",attrs:{"size":"small","show-header":_vm.showheader,"stripe":"","border":"","columns":_vm.orderColumns,"data":order.orderProducts},on:{"on-row-click":_vm.orderSelect}})],1)})],2),_vm._v(" "),_c('TabPane',{attrs:{"label":_vm.$t('plan.Production.choose_device'),"name":"2","disabled":""}},[_c('Row',{staticClass:"search-area"},[_c('Input',{attrs:{"type":"text","placeholder":_vm.$t('plan.Production.searchCollector')},model:{value:(_vm.searchCollector),callback:function ($$v) {_vm.searchCollector=$$v},expression:"searchCollector"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch(2)}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset(2)}},slot:"append"})],1)],1),_vm._v(" "),_c('Table',{staticClass:"collector-table",attrs:{"size":"small","highlight-row":"","stripe":"","border":"","columns":_vm.collectorColumns,"data":_vm.collectorDatas},on:{"on-row-click":_vm.collectorSelect}})],1),_vm._v(" "),_c('TabPane',{attrs:{"label":_vm.$t('plan.Production.choose_plan'),"name":"3","disabled":""}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('FormItem',[_c('RadioGroup',{attrs:{"type":"button"},on:{"on-change":_vm.ProductionSelect},model:{value:(_vm.Radioselection),callback:function ($$v) {_vm.Radioselection=$$v},expression:"Radioselection"}},[_c('Radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.$t('plan.Production.save1')))]),_vm._v(" "),_c('Radio',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('plan.Production.save2')))]),_vm._v(" "),_c('Radio',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.$t('plan.Production.save3')))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.planIndex')}},[(_vm.Radioselection === 1)?_c('Select',{staticClass:"info",attrs:{"value":_vm.planIndex,"disabled":""},model:{value:(_vm.planIndex),callback:function ($$v) {_vm.planIndex=$$v},expression:"planIndex"}}):_vm._e(),_vm._v(" "),(_vm.Radioselection === 2 && _vm.check === true)?_c('Select',{staticClass:"info",attrs:{"value":_vm.planIndex},model:{value:(_vm.planIndex),callback:function ($$v) {_vm.planIndex=$$v},expression:"planIndex"}},_vm._l(([2,3,4,5,6]),function(i){return _c('Option',{key:i,attrs:{"value":i}},[_vm._v(_vm._s(i))])})):_vm._e(),_vm._v(" "),((_vm.Radioselection === 2 && _vm.check === false) || _vm.Radioselection === 3)?_c('Select',{staticClass:"info",attrs:{"value":_vm.planIndex},model:{value:(_vm.planIndex),callback:function ($$v) {_vm.planIndex=$$v},expression:"planIndex"}},_vm._l(([1,2,3,4,5,6]),function(i){return _c('Option',{key:i,attrs:{"value":i}},[_vm._v(_vm._s(i))])})):_vm._e(),_vm._v(" "),(_vm.Radioselection === 0)?_c('Select',{staticClass:"info",attrs:{"value":_vm.planIndex},model:{value:(_vm.planIndex),callback:function ($$v) {_vm.planIndex=$$v},expression:"planIndex"}}):_vm._e()],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('plan.Production.row')}},[_c('Select',{staticClass:"info",attrs:{"placeholder":_vm.$t('plan.Production.please_enter')},model:{value:(_vm.row),callback:function ($$v) {_vm.row=$$v},expression:"row"}},_vm._l((_vm.restRow),function(i){return _c('Option',{key:i,attrs:{"value":i}},[_vm._v(_vm._s(i))])}))],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"success","disabled":""},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('plan.Production.save')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true && _vm.Radioselection === 1)?_c('Button',{attrs:{"type":"success"},on:{"click":function($event){_vm.save(1)}}},[_vm._v(_vm._s(_vm.$t('plan.Production.save')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true && _vm.Radioselection === 2)?_c('Button',{attrs:{"type":"success"},on:{"click":function($event){_vm.save(2)}}},[_vm._v(_vm._s(_vm.$t('plan.Production.save')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true && _vm.Radioselection === 3)?_c('Button',{attrs:{"type":"success"},on:{"click":function($event){_vm.save(3)}}},[_vm._v(_vm._s(_vm.$t('plan.Production.save')))]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.8daa840.png";

/***/ }),

/***/ "8T0R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-page"},[_c('Row',[_c('i-Col',{attrs:{"span":"3","align":"left"}},[_c('Input',{attrs:{"placeholder":_vm.$t('monitor.Order.orderNo')},model:{value:(_vm.search1),callback:function ($$v) {_vm.search1=$$v},expression:"search1"}})],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}},[_c('Input',{attrs:{"placeholder":_vm.$t('monitor.Order.salesman')},model:{value:(_vm.search2),callback:function ($$v) {_vm.search2=$$v},expression:"search2"}})],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}}),_vm._v(" "),_c('DatePicker',{attrs:{"value":_vm.selectTime1,"placeholder":_vm.$t('monitor.Order.please_enter_date1')},on:{"on-change":_vm.entryTimeChange1}}),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}}),_vm._v(" "),_c('DatePicker',{attrs:{"value":_vm.selectTime2,"placeholder":_vm.$t('monitor.Order.please_enter_date2')},on:{"on-change":_vm.entryTimeChange2}}),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}}),_vm._v(" "),_c('Button',{attrs:{"icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}}}),_vm._v(" "),_c('Button',{attrs:{"icon":"refresh"},on:{"click":function($event){_vm.handleReset()}}})],1),_vm._v(" "),(_vm.check === false)?_c('Table',{staticClass:"order-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}}):_vm._e(),_vm._v(" "),(_vm.check === true)?_c('Table',{staticClass:"order-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.temp}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ICA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9UWj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9fEZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("tVhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03df174d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("w0sC");
function injectStyle (ssrContext) {
  __webpack_require__("sk5f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03df174d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03df174d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9oWL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintain-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('Maintain.Return_to_Maintain_list')))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('FormItem',{attrs:{"label":_vm.$t('Maintain.DeviceName')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.device),callback:function ($$v) {_vm.device=$$v},expression:"device"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Maintain.username')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Maintain.startTime')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Maintain.endTime')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Maintain.remark')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Maintain.please_enter')},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('Maintain.save')))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AkUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("aret");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145f342d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("NWon");
function injectStyle (ssrContext) {
  __webpack_require__("TTMZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-145f342d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145f342d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AqYs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.40706b3.svg";

/***/ }),

/***/ "B1Fd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BMVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__("+fjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357db14f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__("aegI");
function injectStyle (ssrContext) {
  __webpack_require__("sOdG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-357db14f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357db14f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CjWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("wvGu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f7d2a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("hmAM");
function injectStyle (ssrContext) {
  __webpack_require__("40qf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f7d2a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CynE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collector-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('device.group.Return_to_group_list')))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('i-Col',{attrs:{"span":"8"}},[_c('FormItem',{attrs:{"label":_vm.$t('device.group.name')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.group.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('FormItem',[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.group.name')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1)],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"8"}},[_c('FormItem',{attrs:{"label":_vm.$t('device.group.remark')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.group.please_enter')},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('FormItem',[_c('a',{staticStyle:{"font-size":"30px","color":"black"}},[_vm._v(_vm._s(_vm.$t('device.group.chosen'))+_vm._s(_vm.sum)+_vm._s(_vm.$t('device.group.devices')))])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('FormItem',[_c('Table',{ref:"selection",staticClass:"collector-table",staticStyle:{"height":"500px"},attrs:{"height":"590","width":"600","border":"","columns":_vm.columns,"data":_vm.collectors},on:{"on-selection-change":_vm.collectorSelect}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('device.group.save')))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D/GT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: Number(this.$route.params.id),
      name: '',
      targetKeys: [],
      listStyle: {
        width: '200px',
        height: '350px',
        'text-align': 'left'
      }
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('system.Role.New_Role') : this.$t('system.Role.edit_Role');
    },
    permissions: function permissions() {
      return this.$store.getters.permissions;
    },
    permissionsData: function permissionsData() {
      var data = [];
      // let per = this.permissions
      var per = [];
      per.super_admin = this.$t('Permission.super_admin');
      per.system = this.$t('Permission.system');
      per.device = this.$t('Permission.device');
      per.card = this.$t('Permission.card');
      per.people = this.$t('Permission.people');
      per.product = this.$t('Permission.product');
      per.order = this.$t('Permission.order');
      per.production_plan = this.$t('Permission.production_plan');
      per.monitor = this.$t('Permission.monitor');
      per.report_export = this.$t('Permission.report_export');
      for (var key in per) {
        data.push({ key: key + '-1', label: per[key] + '-' + this.$t('Permission.R') });
        data.push({ key: key + '-2', label: per[key] + '-' + this.$t('Permission.W') });
      }
      return data;
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var permissions = [];
      var permissionsTemp = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.targetKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var per = _step.value;

          var val = per.split('-');
          if (permissionsTemp[val[0]] === undefined) {
            permissionsTemp[val[0]] = Number(val[1]);
          } else {
            permissionsTemp[val[0]] += Number(val[1]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var key in permissionsTemp) {
        permissions.push({ action: key, value: permissionsTemp[key] });
      }
      __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].role.save({ id: this.id, name: this.name, permissions: permissions }).then(function () {
        _this.$router.push({ 'name': 'Role' });
      });
    },
    handleChange: function handleChange(newTargetKeys) {
      this.targetKeys = newTargetKeys;
    },
    renderFormat: function renderFormat(item) {
      return item.label;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.permissionsInited) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('InitPermissions');
    }
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].role.get(id).then(function (res) {
        var targetKeys = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.role.permissions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var per = _step2.value;

            if (per.value === 3) {
              targetKeys.push(per.action + '-1');
              targetKeys.push(per.action + '-2');
            } else {
              targetKeys.push(per.action + '-' + per.value);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        next(function (vm) {
          vm.name = res.role.name;
          vm.targetKeys = targetKeys;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "DpBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("ZAz4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e3f1c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("71wU");
function injectStyle (ssrContext) {
  __webpack_require__("Mk4P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57e3f1c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e3f1c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EEld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("fJPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e08d3ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("54ld");
function injectStyle (ssrContext) {
  __webpack_require__("5KMW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e08d3ff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e08d3ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EJaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workType',
  data: function data() {
    return {
      // columns: [
      //   // { type: 'index', title: this.$t('system.workType.index') },
      //   { title: this.$t('system.workType.Sorting'), key: 'Sorting', sortable: true, sortType: 'asc' },
      //   { title: this.$t('system.workType.name'), key: 'name' },
      //   { title: this.$t('system.workType.outputValid'),
      //     key: 'outputValid',
      //     render: (h, params) => {
      //       let b = params.row.outputValid === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.monopoly'),
      //     key: 'monopoly',
      //     render: (h, params) => {
      //       let b = params.row.monopoly === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.maintain'),
      //     key: 'maintain',
      //     render: (h, params) => {
      //       let b = params.row.maintain === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.display'),
      //     key: 'display',
      //     render: (h, params) => {
      //       let b = params.row.display === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.malfunction'),
      //     key: 'malfunction',
      //     render: (h, params) => {
      //       let b = params.row.malfunction === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   // { title: this.$t('system.workType.warn'),
      //   //   key: 'warn',
      //   //   render: (h, params) => {
      //   //     let b = params.row.warn === 0 ? this.$t('system.workType.yes') : this.$t('system.workType.no')
      //   //     return h('span', b)
      //   //   }
      //   // },
      //   { title: this.$t('system.workType.remark'), key: 'remark' },
      //   {
      //     title: this.$t('system.workType.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (params.index >= 4 && this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.workType.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.workType.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.workType.delete'))
      //         ])
      //       } else if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.workType.edit'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.workType.edit'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      permissions: false
    };
  },

  methods: {
    edit: function edit(id) {
      // id === -1 ? 0 : id
      this.$router.push({ name: 'WorkTypeEdit', params: { id: id } });
    },
    remove: function remove(id, index) {
      var _this = this;

      if (confirm(this.$t('system.workType.delete_message'))) {
        this.$api.workType.delete(id).then(function () {
          _this.datas.splice(index, 1);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          _this2.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workType.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.workTypes;
        for (var i = 0; i < vm.datas.length; i++) {
          vm.datas[i].outputValidName = vm.datas[i].outputValid === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes');
          vm.datas[i].monopolyName = vm.datas[i].monopoly === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes');
          vm.datas[i].maintainName = vm.datas[i].maintain === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes');
          vm.datas[i].displayName = vm.datas[i].display === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes');
          vm.datas[i].malfunctionName = vm.datas[i].malfunction === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes');
          // console.log(vm.datas[i])
        }
        console.log(vm.datas);
      });
    });
  }
});

/***/ }),

/***/ "EVQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SystemInfo',
  data: function data() {
    return {
      systemVersion: 'v0.11-beta',
      systemDealTime: '',
      systemAuthCode: '',
      permissions: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          _this.permissions = true;
        }
      }
    });
  },

  methods: {
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].systemAuth.update(this.systemAuthCode).then(function (res) {
        var et = new Date(res.expiryTime * 1000);
        _this2.systemDealTime = et.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();
        _this2.$Message.config({
          top: 80,
          duration: 2
        });
        _this2.$Message.success(_this2.$t('system.SystemAuth.save_success'));
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].systemAuth.get().then(function (res) {
      next(function (vm) {
        vm.systemAuthCode = res.systemAuthCode.authCode;
        var et = new Date(res.systemAuthCode.expiryTime * 1000);
        vm.systemDealTime = et.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate();
      });
    });
  }
});

/***/ }),

/***/ "EaHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',{staticClass:"expand-row"},[_c('Col',{attrs:{"span":"8"}},[_c('span',{staticClass:"expand-key"},[_vm._v(_vm._s(_vm.$t("system.Account.telephone")))]),_vm._v(" "),_c('span',{staticClass:"expand-value"},[_vm._v(_vm._s(_vm.row.phone))])]),_vm._v(" "),_c('Col',{attrs:{"span":"8"}},[_c('span',{staticClass:"expand-key"},[_vm._v(_vm._s(_vm.$t("system.Account.email")))]),_vm._v(" "),_c('span',{staticClass:"expand-value"},[_vm._v(_vm._s(_vm.row.eMail))])]),_vm._v(" "),_c('Col',{attrs:{"span":"8"}},[_c('span',{staticClass:"expand-key"},[_vm._v(_vm._s(_vm.$t("system.Account.qq")))]),_vm._v(" "),_c('span',{staticClass:"expand-value"},[_vm._v(_vm._s(_vm.row.qq))])])],1),_vm._v(" "),_c('Row',[_c('Col',{attrs:{"span":"8"}},[_c('span',{staticClass:"expand-key"},[_vm._v(_vm._s(_vm.$t("system.Account.wechat")))]),_vm._v(" "),_c('span',{staticClass:"expand-value"},[_vm._v(_vm._s(_vm.row.wechat))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EbhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("uJSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35771fdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("1PeC");
function injectStyle (ssrContext) {
  __webpack_require__("VUuE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35771fdd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35771fdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Euhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Product',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('Product.index'), width: 70 }, { title: this.$t('Product.productNo'), key: 'productNo' }, { title: this.$t('Product.name'), key: 'name', sortable: true, sortType: 'asc' }, { title: this.$t('Product.latDensity'), key: 'latDensity', sortable: true },
      // { title: '密度', key: 'density' },
      { title: this.$t('Product.kaidu'), key: 'kaidu', sortable: true }, { title: this.$t('Product.width'), key: 'width', sortable: true },
      // { title: '耗损率', key: 'attritionRate' },
      { title: this.$t('Product.specifications'), key: 'specifications' },
      // {
      //   title: '图片',
      //   key: 'image',
      //   render: (h, params) => {
      //     return h('img', {
      //       attrs: {
      //         src: params.row.image
      //       },
      //       style: {
      //         width: '100%',
      //         margin: '2px 0px',
      //         'vertical-align': 'middle'
      //       }
      //     })
      //   }
      // },
      {
        title: this.$t('Product.valid'),
        key: 'valid',
        render: function render(h, params) {
          var s = params.row.valid === 1 ? _this.$t('Product.yes') : _this.$t('Product.no');
          return h('span', s);
        }
      }, {
        title: this.$t('Product.action'),
        key: 'action',
        render: function render(h, params) {
          if (_this.permissions === true) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.edit(params.index);
                }
              }
            }, _this.$t('Product.edit')), h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              on: {
                click: function click() {
                  if (confirm(_this.$t('Product.delete_message'))) {
                    _this.remove(params.index);
                  }
                }
              }
            }, _this.$t('Product.delete'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              }
            }, _this.$t('Product.edit')), h('Button', {
              props: {
                type: 'error',
                size: 'small',
                disabled: true
              }
            }, _this.$t('Product.delete'))]);
          }
        }
      }],
      datas: [],
      productList: [],
      search: '',
      permissions: false
    };
  },

  computed: {},
  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : this.datas[index].id;
      this.$router.push({ name: 'ProductEdit', params: { id: id } });
    },
    remove: function remove(index) {
      var _this2 = this;

      this.$api.product.delete(this.datas[index].id).then(function () {
        _this2.datas.splice(index, 1);
      });
    },
    handleSearch: function handleSearch() {
      this.datas = [];
      for (var i = 0; i < this.productList.length; i++) {
        var p = this.productList[i];
        if (p.productNo.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          this.datas.push(p);
        }
      }
    },
    handleReset: function handleReset() {
      this.datas = this.productList;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'product' && res.user.permissions[i].value === 3) {
          _this3.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].product.list().then(function (res) {
      next(function (vm) {
        var d = [];
        vm.datas = res.products;
        vm.productList = res.products;
        for (var i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].valid === 1 || vm.datas[i].valid === 2) {
            d.push(vm.datas[i]);
          }
        }
        vm.datas = d;
      });
    });
  }
});

/***/ }),

/***/ "EwOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-page"},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{staticClass:"data-pane",attrs:{"label":_vm.$t('data.Order.Order_report')}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"inline":""}},[_c('FormItem',{attrs:{"label":_vm.$t('data.Order.orderNo')}},[_c('Select',{staticClass:"info collectorSelect",attrs:{"value":_vm.orderID,"filterable":""},model:{value:(_vm.orderID),callback:function ($$v) {_vm.orderID=$$v},expression:"orderID"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t('data.Order.please_enter')))]),_vm._v(" "),_vm._l((_vm.orderList),function(item){return _c('Option',{key:item.orderID,attrs:{"value":item.orderID}},[_vm._v(_vm._s(item.orderNo))])})],2)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Order.status')}},[_c('Select',{staticClass:"info collectorSelect",attrs:{"value":_vm.Valid},model:{value:(_vm.Valid),callback:function ($$v) {_vm.Valid=$$v},expression:"Valid"}},[_c('Option',{key:"3",attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('data.Order.Producting')))]),_vm._v(" "),_c('Option',{key:"4",attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.$t('data.Order.Case_closed')))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Order.start_date')}},[_c('DatePicker',{attrs:{"value":_vm.selectTime1,"placeholder":_vm.$t('data.Order.please_enter_date')},on:{"on-change":_vm.entryTimeChange1}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Order.end_date')}},[_c('DatePicker',{attrs:{"value":_vm.selectTime2,"placeholder":_vm.$t('data.Order.please_enter_date')},on:{"on-change":_vm.entryTimeChange2}})],1),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.getData(1)}}},[_vm._v(_vm._s(_vm.$t('data.Order.ok')))]),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.exportData(1)}}},[_c('Icon',{attrs:{"type":"ios-download-outline"}}),_vm._v(_vm._s(_vm.$t('data.Order.out')))],1)],1),_vm._v(" "),_c('Table',{ref:"table",staticClass:"device-data-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.deviceColumns1,"data":_vm.orderDatas1,"loading":_vm.loading}})],1),_vm._v(" "),_c('TabPane',{staticClass:"data-pane",attrs:{"label":_vm.$t('data.Order.history')}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"inline":""}},[_c('FormItem',{attrs:{"label":_vm.$t('data.Order.orderNo')}},[_c('Select',{staticClass:"info collectorSelect",attrs:{"value":_vm.orderID,"filterable":""},model:{value:(_vm.orderID),callback:function ($$v) {_vm.orderID=$$v},expression:"orderID"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t('data.Order.please_enter')))]),_vm._v(" "),_vm._l((_vm.orderList),function(item){return _c('Option',{key:item.orderID,attrs:{"value":item.orderID}},[_vm._v(_vm._s(item.orderNo))])})],2)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Order.start_date')}},[_c('DatePicker',{attrs:{"value":_vm.selectTime3,"placeholder":_vm.$t('data.Order.please_enter_date')},on:{"on-change":_vm.entryTimeChange3}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Order.end_date')}},[_c('DatePicker',{attrs:{"value":_vm.selectTime4,"placeholder":_vm.$t('data.Order.please_enter_date')},on:{"on-change":_vm.entryTimeChange4}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Order.time_range')}},[_c('TimePicker',{attrs:{"format":"HH:mm","value":_vm.startTime},on:{"on-change":_vm.entryTimeChange5}}),_vm._v("\n          -\n          "),_c('TimePicker',{attrs:{"format":"HH:mm","value":_vm.endTime},on:{"on-change":_vm.entryTimeChange6}})],1),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.getData(2)}}},[_vm._v(_vm._s(_vm.$t('data.Order.ok')))]),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.exportData(2)}}},[_c('Icon',{attrs:{"type":"ios-download-outline"}}),_vm._v(_vm._s(_vm.$t('data.Order.out')))],1)],1),_vm._v(" "),_c('Table',{ref:"table1",staticClass:"device-data-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.deviceColumns2,"data":_vm.orderDatas2,"loading":_vm.loading}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FWz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var order = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/orderProduct/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, orderNo: 'o-001', productNo: 'xt-001', number: 30, unit: '米', attritionRate: 0.1, ordersTime: '2017-09-01', deliveryTime: '2017-10-01', customer: '心恬', salesman: 'xxx', valid: 1},
    //     {id: 2, orderNo: 'o-001', productNo: 'xt-002', number: 30, unit: '米', attritionRate: 0.1, ordersTime: '2017-09-01', deliveryTime: '2017-10-01', customer: '心恬', salesman: 'xxx', valid: 1}
    //   ]
    //   resolve(data)
    // })
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/orderProduct/get', { id: id });
  },
  save: function save(order) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/orderProduct/save', order);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/order/delete', { id: id });
  },
  change: function change(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/orderProduct/change', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (order);

/***/ }),

/***/ "Foau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var data = {
  collectorData: function collectorData(tp, req) {
    if (tp === 1) {
      return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/data/collectorOutputData', req);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/data/collectorStatusData', req);
    }
  },
  orderData: function orderData(req) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/data/orderData', req);
  },
  orderDayData: function orderDayData(req) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/data/orderDayData', req);
  },
  DailyData: function DailyData() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/data/DailyData');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),

/***/ "GKtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var card = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/card/list');
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/card/get', { id: id });
  },
  save: function save(card) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/card/save', card);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/card/delete', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (card);

/***/ }),

/***/ "HHWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collector_vue__ = __webpack_require__("PFuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7249a599_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Collector_vue__ = __webpack_require__("Rix0");
function injectStyle (ssrContext) {
  __webpack_require__("kP8J")
  __webpack_require__("n9nU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7249a599"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7249a599_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Collector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hn9d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HqU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WorkTypeEdit',
  data: function data() {
    return {
      id: 0,
      name: '',
      outputValid: 0,
      monopoly: 0,
      maintain: 0,
      warn: 0,
      malfunction: 0,
      display: 0,
      Sorting: 0,
      remark: ''
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('system.workType.New_workType') : this.$t('system.workType.edit_workType');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var workType = {
        id: this.id,
        name: this.name,
        outputValid: this.outputValid,
        monopoly: this.monopoly,
        maintain: this.maintain,
        warn: this.warn,
        remark: this.remark,
        Sorting: Number(this.Sorting),
        display: Number(this.display),
        malfunction: Number(this.malfunction)
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workType.save(workType).then(function () {
        _this.$router.push({ 'name': 'WorkType' });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = to.params.id;
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workType.get(id).then(function (res) {
        next(function (vm) {
          var wt = res.workType;
          vm.id = wt.id;
          vm.name = wt.name;
          vm.outputValid = wt.outputValid;
          vm.monopoly = wt.monopoly;
          vm.maintain = wt.maintain;
          vm.warn = wt.warn;
          vm.remark = wt.remark;
          vm.display = wt.display;
          vm.malfunction = wt.malfunction;
          vm.Sorting = wt.Sorting;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_menu__ = __webpack_require__("egBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_permission__ = __webpack_require__("19nU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    menu: __WEBPACK_IMPORTED_MODULE_2__modules_menu__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_4__modules_permission__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "Ik6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__ = __webpack_require__("NHEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a324c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__ = __webpack_require__("R1Nv");
function injectStyle (ssrContext) {
  __webpack_require__("ZyKG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78a324c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a324c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JJU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("qC4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe89c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("rbi1");
function injectStyle (ssrContext) {
  __webpack_require__("Y+Hs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe89c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JTfD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JnBR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountEdit',
  data: function data() {
    return {
      formValidate: {
        id: 0,
        username: '',
        name: '',
        workNo: '',
        departmentID: '0',
        roleID: '',
        phone: '',
        eMail: '',
        qq: '',
        wechat: '',
        department: [],
        list: [],
        check: false,
        working: 1,
        language: '',
        role: []
      },
      ruleValidate: {
        username: [{ required: true, message: this.$t('system.Account.User_name_message'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('system.Account.Name_message'), trigger: 'blur' }],
        departmentID: [{ required: true, message: this.$t('system.Account.Role_message'), pattern: /.+/, trigger: 'change' }],
        roleID: [{ required: true, message: this.$t('system.Account.Department_message'), pattern: /.+/, trigger: 'change' }]
      }
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('system.Account.New_account') : this.$t('system.Account.edit_account');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var account = void 0;
      this.formValidate.check = false;
      if (this.formValidate.list !== undefined) {
        for (var i = 0; i < this.formValidate.list.length; i++) {
          if (this.formValidate.list[i].username === 'admin') {
            this.formValidate.language = this.formValidate.list[i].language;
          }
          if (this.formValidate.list[i].username === this.formValidate.username && this.formValidate.list[i].id !== this.formValidate.id) {
            this.formValidate.check = true;
          }
        }
      }
      if (this.formValidate.check === true) {
        var title = this.$t('system.Account.error');
        var content = this.$t('system.Account.error_message1');
        this.$Modal.error({
          title: title,
          content: content
        });
      } else if (this.formValidate.username !== '' && this.formValidate.name !== '' && this.formValidate.departmentID !== '' && this.formValidate.roleID !== '') {
        account = {
          id: this.formValidate.id,
          username: this.formValidate.username,
          name: this.formValidate.name,
          workNo: this.formValidate.workNo,
          department: Number(this.formValidate.departmentID),
          role: Number(this.formValidate.roleID),
          phone: this.formValidate.phone,
          eMail: this.formValidate.eMail,
          qq: this.formValidate.qq,
          wechat: this.formValidate.wechat,
          working: Number(this.formValidate.working),
          language: this.formValidate.language
        };
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].account.save(account).then(function () {
          _this.$router.push({ 'name': 'Account' });
        });
      } else {
        var _title = this.$t('system.Account.error');
        var _content = this.$t('system.Account.error_message2');
        this.$Modal.error({
          title: _title,
          content: _content
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].department.list().then(function (res) {
      _this2.formValidate.department = res.departments;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].role.list().then(function (res) {
      _this2.formValidate.role = res.roles;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].account.list().then(function (res) {
      _this2.formValidate.list = res.accounts;
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = to.params.id;
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].account.get(Number(id)).then(function (res) {
        next(function (vm) {
          var a = res.account;
          vm.formValidate.id = a.id;
          vm.formValidate.username = a.username;
          vm.formValidate.name = a.name;
          vm.formValidate.workNo = a.workNo;
          vm.formValidate.departmentID = a.department;
          vm.formValidate.roleID = a.role;
          vm.formValidate.phone = a.phone;
          vm.formValidate.eMail = a.eMail;
          vm.formValidate.qq = a.qq;
          vm.formValidate.wechat = a.wechat;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "Jvsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAuth_vue__ = __webpack_require__("EVQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0971a056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAuth_vue__ = __webpack_require__("cYIU");
function injectStyle (ssrContext) {
  __webpack_require__("LWWJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0971a056"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAuth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0971a056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAuth_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K9jQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KKJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__("2Sxa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569909f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__("6+8N");
function injectStyle (ssrContext) {
  __webpack_require__("+oTU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-569909f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569909f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kktf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US__ = __webpack_require__("hyJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_th__ = __webpack_require__("QG7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_th__);




var thTH = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  'menu': {
    'home': 'ที่หน้าแรก',
    'system': 'การตั้งค่าระบบ',
    'system_management': {
      'Role': 'หน้าที่',
      'Department': 'แผนก',
      'Account': 'บัญชี',
      'WorkTime': 'ช่วงเวลาการทำงาน',
      'WorkType': 'ประเภทงาน',
      'RoleEdit': 'แก้ไขหน้าที่',
      'DepartmentEdit': 'แก้ไขแผนก',
      'AccountEdit': 'แก้ไขข้อมูล',
      'WorkTimeEdit': 'แก้ไขช่วงเวลาการทำงาน',
      'WorkTypeEdit': 'แก้ไขประเภทพนักงาน',
      'systeminfo': 'ข้อมูลระบบ',
      'SystemAuth': 'ให้สิทธิ์การจัดการ'
    },
    'Device': 'การตั้งค่าอุปกรณ์',
    'Device_management': {
      'RouterList': 'เราต์เตอร์',
      'RouterEdit': 'แก้ไขเราต์เตอร์',
      'Collector': 'เครื่องจักร',
      'CollectorEdit': 'แก้ไขเครื่องจักร',
      'CollectorGroup': 'กลุ่มเครื่องจักร',
      'CollectorGroupEdit': 'แก้ไขการจัดกลุ่มเครื่องจักร'
    },
    'Card': 'การตั้งค่าการ์ด',
    'CardEdit': 'แก้ไขการ์ด',
    'People': 'การตั้งค่าบุคคล',
    'PeopleEdit': 'แก้ไขบุคคล',
    'Product': 'การตั้งค่าผลิตภัณฑ์',
    'ProductEdit': 'แก้ไขผลิตภัณฑ์',
    'Order': 'การตั้งค่าการสั่งซื้อ',
    'OrderEdit': 'แก้ไขการสั่งซื้อ',
    'Plan': 'การวางแผนผลิตภัณฑ์',
    'Plan_Management': {
      'Production_plan': 'การวางแผนการสั่งซื้อ',
      'Production_management': 'การจัดเรียงการสั่งซื้อ',
      'Production_order': 'กำหนดการการสั่งซื้อ'
    },
    'Monitor': 'การตรวจสอบแบบเรียลไทม์',
    'Monitor_Monitoring': {
      'Collector': 'สถานะเครื่องจักร',
      'Order': 'สถานะการสั่งซื้อ'
    },
    'Data': 'รายงาน',
    'Data_output': {
      'Order': 'ประวัติการสั่งซื้อ',
      'device': 'ประวัติเครื่องจักร',
      'Worker': 'ประวัติพนักงาน',
      'MaintainList': 'ประวัติการบำรุงรักษา',
      'MaintainEdit': 'แก้ไขการบำรุงรักษา'
    },
    'Setting': 'การตั้งค่าผู้ใช้'
  },
  'system': {
    'Account': {
      'New_account': 'บัญชีใหม่',
      'edit_account': 'แก้ไขข้อมูล',
      'please_enter': 'โปรดใส่ข้อมูล',
      'please_choose': 'โปรดเลือก',
      'Return_to_account_list': 'กลับสู่หน้ารายการบัญชี',
      'User_name': 'ชื่อผู้ใช้',
      'User_name_message': 'โปรดใส่ชื่อผู้ใช้',
      'Name': 'ชื่อ-นามสกุล',
      'Name_message': 'โปรดใส่ชื่อ-นามสกุล',
      'Role': 'หน้าที่',
      'Role_message': 'โปรดเลือกหน้าที่',
      'Worker_number': 'หมายเลขพนักงาน',
      'Department': 'แผนก',
      'Department_message': 'โปรดเลือกแผนก',
      'Telephone': 'โทรศัพท์',
      'Email': 'อีเมล',
      'QQ': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
      'Wechat': 'วีแชท',
      'telephone': 'โทรศัพท์:',
      'email': 'อีเมล:',
      'qq': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
      'wechat': 'วีแชท:',
      'save': 'บันทึก',
      'index': 'หมายเลข',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'reseat': 'ตั้งเครื่องใหม่',
      'error': 'เกิดข้อผิดพลาด',
      'error_message1': '<p>บัญชีซ้ำ</p>',
      'error_message2': '<p>บัญชีซ้ำ</p>',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?'
    },
    'Department': {
      'New_Department': 'แผนกใหม่',
      'edit_Department': 'แก้ไขแผนก',
      'index': 'หมายเลข',
      'Department': 'แผนก',
      'Authorization': 'การให้สิทธิ์',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'Return_to_depatement_list': 'กลับสู่หน้ารายการแผนก',
      'name': 'ชื่อ',
      'Move_left': 'เลื่อนไปทางซ้าย',
      'Move_right': 'เลื่อนไปทางขวา',
      'save': 'บันทึก',
      'All_authorization': 'การให้สิทธิ์ทั้งหมด',
      'Department_authorization': 'สิทธิ์ของแผนก'
    },
    'Role': {
      'New_Role': 'หน้าที่ใหม่',
      'edit_Role': 'แก้ไขหน้าที่',
      'index': 'หมายเลข',
      'Role': 'หน้าที่',
      'Authorization': 'การให้สิทธิ์',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'Return_to_role_list': 'กลับสู่หน้ารายการหน้าที่',
      'name': 'ชื่อ',
      'Move_left': 'เลื่อนไปทางซ้าย',
      'Move_right': 'เลื่อนไปทางขวา',
      'save': 'บันทึก',
      'All_authorization': 'การให้สิทธิ์ทั้งหมด',
      'Role_authorization': 'การให้สิทธิ์หน้าที่'
    },
    'workTime': {
      'New_workTime': 'ช่วงเวลาการทำงานใหม่',
      'edit_workTime': 'แก้ไขช่วงเวลาการทำงาน',
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'please_choose': 'โปรดเลือกเวลา',
      'startTime': 'เวลาเริ่มต้น',
      'endTime': 'เวลาที่สิ้นสุด',
      'Return_to_workTime_list': 'กลับสู่หน้ารายการช่วงเวลาการทำงาน',
      'save': 'บันทึก'
    },
    'workType': {
      'New_workType': 'ประเภทพนักงานใหม่',
      'edit_workType': 'แก้ไขประเภทพนักงาน',
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'Return_to_workType_list': 'กลับสู่หน้ารายการ',
      'save': 'บันทึก',
      'yes': 'ใช่',
      'no': 'ไม่',
      'outputValid': 'คำนวณผลผลิต',
      'monopoly': 'ยึดครองเครื่องจักร',
      'maintain': 'โหมดการบำรุงรักษา',
      'warn': 'ปิดสัญญาณเตือนภัย',
      'Sorting': 'การเรียงลำดับ',
      'display': 'จอแสดงผล',
      'malfunction': 'การคำนวณผิดพลาด',
      'remark': 'หมายเหตุ'
    },
    'SystemAuth': {
      'Information': 'ข้อมูลพื้นฐาน',
      'systemVersion': 'รุ่นของระบบ:',
      'systemDealTime': 'วันหมดอายุ',
      'please_enter': 'โปรดใส่ข้อมูล',
      'save': 'บันทึก',
      'save_success': 'การบันทึกสำเร็จ',
      'systemAuthCode': 'รหัสการให้สิทธิ์'
    },
    'SystemInfo': {
      'Information': 'ข้อมูลพื้นฐาน',
      'Contect': 'ช่องทางการติดต่อ',
      'systemName': 'ชื่อระบบ:',
      'please_enter': 'โปรดใส่ข้อมูล',
      'name': 'ชื่อบริษัท:',
      'contact': 'ชื่อผู้ติดต่อ:',
      'address': 'ที่อยู่บริษัท:',
      'phone': 'เบอร์ติดต่อ:',
      'fax': 'แฟกซ์:',
      'eMail': 'อีเมล:',
      'save': 'บันทึก',
      'save_success': 'การบันทึกสำเร็จ',
      'warnLimitTime': 'ปิดช่วงเวลาสัญญาณเตือนภัย'
    }
  },
  'device': {
    'collector': {
      'New_collector': 'เครื่องจักรใหม่',
      'edit_collector': 'แก้ไขเครื่องจักร',
      'Return_to_collector_list': 'กลับสู่หน้ารายการเครื่องจักร',
      'name': 'ชื่อ',
      'deviceNo': 'สิ่งของ',
      'routerID': 'เราต์เตอร์',
      'type': 'ประเภทเครื่องจักร',
      'computeType': 'วิธีการคำนวณการผลิต',
      'roller': 'ลูกกลิ้ง',
      'weft_density': 'ความหนาแน่นของเส้นด้ายทางขวาง',
      'length': 'เส้นรอบวงลูกกลิ้ง',
      'count': 'หมายเลขสายพาน',
      'width': 'ความกว้างสายพาน',
      'deviceCompany': 'ผู้ผลิต',
      'deviceModel': 'ต้นแบบเครื่องจักร',
      'buyTime': 'เวลาซื้อ',
      'deviceLifeTime': 'อายุการใช้งาน (ปี)',
      'please_enter': 'โปรดใส่ข้อมูล',
      'please_enter_mm': 'โปรดใส่ข้อมูล (หน่วย:มิลลิเมตร)',
      'save': 'บันทึก',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'error': 'เกิดข้อผิดพลาด',
      'error_message1': '<p>ข้อมูลไม่ครบถ้วน</p>',
      'error_message2': 'ต้องเป็นจำนวนเต็ม',
      'remark': 'หมายเหตุ',
      'Message': {
        'name': 'โปรดใส่ชื่อ',
        'deviceNo': 'โปรดใส่หมายเลข',
        'computeType': 'โปรดเลือกวิธีการคำนวณ',
        'routerID': 'โปรดใส่เราต์เตอร์',
        'length': 'โปรดใส่เส้นรอบวงลูกกลิ้ง',
        'count': 'โปรดใส่หมายเลขสายพาน',
        'width': 'โปรดใส่ความกว้าง'
      }
    },
    'group': {
      'New_group': 'กลุ่มเครื่องจักรใหม่',
      'edit_group': 'แก้ไขการจัดกลุ่มเครื่องจักร',
      'Return_to_group_list': 'กลับสู่หน้ารายการกลุ่มเครื่องจักร',
      'please_enter': 'โปรดใส่ข้อมูล',
      'save': 'บันทึก',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'devices': 'ได้เลือกแล้ว',
      'chosen': 'เครื่องจักร',
      'remark': 'หมายเหตุ',
      'width': 'ความกว้าง',
      'router': 'เราต์เตอร์'
    },
    'router': {
      'New_router': 'เราต์เตอร์ใหม่',
      'edit_router': 'แก้ไขเราต์เตอร์',
      'Return_to_router_list': 'กลับสู่หน้ารายการเราต์เตอร์',
      'please_enter': 'โปรดใส่ข้อมูล',
      'index': 'หมายเลข',
      'name': 'รหัสเราต์เตอร์',
      'AnotherName': 'ชื่อเราต์เตอร์',
      'linkType': 'ประเภทเครือข่าย',
      'channel': 'ช่องสัญญาณ',
      'remark': 'หมายเหตุ',
      'save': 'บันทึก',
      'action': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'mod': 'ประเภทเครือข่าย',
      'Lan': 'เครือข่ายภายใน',
      'Internet': 'อินเทอร์เน็ต',
      'time': 'จัดเตรียมใหม่',
      'save_success': 'ระบบและตัวเก็บรวบรวมจัดเรียงใหม่เรียบร้อยแล้ว'
    }
  },
  'Card': {
    'New_Card': 'การ์ดใหม่',
    'edit_Card': 'แก้ไขการ์ด',
    'Return_to_Card_list': 'กลับสู่หน้ารายการบัตร',
    'please_enter': 'โปรดใส่ข้อมูล',
    'index': 'หมายเลข',
    'userName': 'เจ้าของ',
    'cardNo': 'รหัสการ์ด',
    'workTypeName': 'ประเภทงาน',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'delete': 'ลบทิ้ง',
    'delete_message': 'ต้องการลบทิ้งหรือไม่?',
    'save': 'บันทึก',
    'error': 'เกิดข้อผิดพลาด',
    'error_message1': '<p>บัตรซ้ำ</p>',
    'error_message2': '<p>ข้อมูลไม่ครบถ้วน</p>'
  },
  'Product': {
    'New_Product': 'ผลิตภัณฑ์ใหม่',
    'edit_Product': 'แก้ไขผลิตภัณฑ์',
    'Return_to_Product_list': 'กลับสู่หน้ารายการผลิตภัณฑ์',
    'please_enter': 'โปรดใส่ข้อมูล',
    'index': 'หมายเลข',
    'productNo': 'สิ่งของ',
    'name': 'ชื่อ',
    'latDensity': 'ความหนาแน่นของเส้นด้ายทางขวาง',
    'kaidu': 'ความตึง',
    'width': 'ความกว้าง',
    'specifications': 'ข้อจำกัด',
    'valid': 'มีประสิทธิภาพ',
    'yes': 'ใช่',
    'no': 'ไม่',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'delete': 'ลบทิ้ง',
    'delete_message': 'ต้องการลบทิ้งหรือไม่?',
    'save': 'บันทึก',
    'error': 'เกิดข้อผิดพลาด',
    'error_message': '<p>ข้อมูลไม่ครบถ้วน</p>',
    'please_enter_kaidu': 'โปรดใส่ข้อมูล (มากกว่าหรือเท่ากับ 1)',
    'please_enter_mm': 'โปรดใส่ข้อมูล (หน่วย:มิลลิเมตร)',
    'please_enter_latDensity': 'โปรดใส่ข้อมูล (หน่วย:welf/cm)',
    'Message': {
      'productNo': 'โปรดใส่หมายเลขผลิตภัณฑ์',
      'name': 'โปรดใส่ชื่อ',
      'latDensity': 'โปรดเลือกความหนาแน่นของเส้นด้ายทางขวาง',
      'kaidu': 'โปรดใส่ความตึง',
      'width': 'โปรดใส่ความกว้าง'
    }
  },
  'Order': {
    'New_Order': 'คำสั่งซื้อใหม่',
    'edit_Order': 'แก้ไขการสั่งซื้อ',
    'Return_to_Order_list': 'กลับสู่หน้ารายการคำสั่งซื้อ',
    'please_enter': 'โปรดใส่ข้อมูล',
    'please_enter_date': 'โปรดใส่วันที่',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'delete': 'ลบทิ้ง',
    'save': 'บันทึก',
    'error': 'เกิดข้อผิดพลาด',
    'error_message1': '<p>ยังไม่มีการเพิ่มผลิตภัณฑ์ลงในการสั่งซื้อ</p>',
    'error_message2': '<p>ยังไม่ได้กรอกข้อมูลการสั่งซื้อ</p>',
    'error_message3': '<p>ปริมาณยังไม่ครบถ้วน</p>',
    'error_message4': '<p>หน่วยไม่สมบูรณ์</p>',
    'error_message5': '<p>วันที่จัดส่งยังไม่เสร็จสมบูรณ์</p>',
    'error_message6': '<p>請先選擇左側產品</p>',
    'delete_message': 'ต้องการลบทิ้งหรือไม่?',
    'change_message': 'ต้องการเปิดเคสหรือไม่?',
    'orderNo': 'เลขที่การสั่งซื้อ',
    'customer': 'ลูกค้า',
    'ordersTime': 'วันที่สั่งซื้อ',
    'salesman': 'ยอดการขาย',
    'index': 'หมายเลข',
    'productNo': 'หมายเลขการผลิต',
    'num': 'จำนวน',
    'unit': 'หน่วย',
    'attritionRate': 'อัตราความเสียหาย (%)',
    'deliveryTime': 'วันที่จัดส่งใบสั่ง',
    'remark': 'หมายเหตุ',
    'add': 'เพิ่มในการสั่งซื้อ',
    'Product_list': 'รายการผลิตภัณฑ์',
    'search': 'สิ่งของ/ชื่อ',
    'No_scheduling': 'ไม่มีการจัดกำหนดการ',
    'Not_production': 'ไม่นำไปผลิต',
    'Producting': 'ดำเนินการในการผลิต',
    'Case_closed': 'จบงาน',
    'name': 'ชื่อ',
    'Meter': 'เมตร',
    'Yard': 'สนาม',
    'Gross': 'ยอดรวม',
    'status': 'สถานภาพ',
    'Message': {
      'orderNo': 'โปรดใส่หมายเลขผลิตภัณฑ์',
      'ordersTime': 'โปรดใส่วันที่สั่งซื้อ',
      'customer': 'โปรดใส่ชื่อลูกค้า',
      'salesman': 'โปรดใส่ชื่อพนักงานขาย'
    }
  },
  'Login': {
    'username': 'โปรดใส่ชื่อผู้ใช้',
    'password': 'โปรดใส่รหัสผ่านของคุณ',
    'systemCode': 'โปรดใส่รหัสระบบ',
    'language': '請選擇語言',
    'login': 'เข้าสู่ระบบ',
    'system': 'เข้าระบบ',
    'changePw': 'เปลี่ยนรหัสผ่าน',
    'logout': 'ออกจากระบบ',
    'Information': 'การตั้งค่าส่วนบุคคล'
  },
  'ChangePw': {
    'oldPassword': 'ใส่รหัสผ่านอันเก่า:',
    'newPassword': 'ใส่รหัสผ่านอันใหม่',
    'comfirmPassword': 'ยืนยันรหัสผ่านใหม่',
    'save': 'บันทึก',
    'error': 'รหัสผ่านไม่สอดคล้องกัน',
    'success': 'การแก้ไขสำเร็จ',
    'ChangePw': 'เปลี่ยนรหัสผ่าน'
  },
  'monitor': {
    'Collector': {
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'group': 'กลุ่ม',
      'deviceNo': 'สิ่งของ',
      'rpm': 'ความเร็วรอบเครื่องจักร',
      'status': 'สถานะเครื่องจักร',
      'status1': 'สถานะอุปกรณ์',
      'error': 'ข้อมูลผิดพลาด',
      'worker': 'พนักงาน',
      'workType': 'สถานะการ์ด',
      'lastTime': 'เวลา',
      'timeout': 'ออฟไลน์',
      'trial': 'การทดลอง',
      'standby': 'เตรียมพร้อม',
      'run': 'กำลังปฏิบัติหน้าที่อยู่',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'producNo': 'หมายเลขผลิตภัณฑ์',
      'stop': 'เตรียมพร้อม',
      'warp': 'เส้นด้ายทางยาว',
      'weft': 'เส้นด้ายทางขวาง',
      'thread': 'ด้าย',
      'roll': 'ลูกกลิ้ง'
    },
    'Order': {
      'index': 'หมายเลข',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'producNo': 'หมายเลขผลิตภัณฑ์',
      'salesman': 'ยอดการขาย',
      'ordersTime': 'วันที่สั่งซื้อ',
      'output': 'ผลิตผลที่ได้',
      'num': 'ปริมาณการสั่งซื้อ',
      'unit': 'หน่วย',
      'countdata': 'หมายเลขเครื่องจักร',
      'name': 'ชื่อ',
      'rpm': 'ความเร็วรอบเครื่องจักร',
      'worker': 'พนักงาน',
      'workType': 'สถานะการ์ด',
      'DailyOutput': 'ปริมาณที่ผลิตได้วันนี้',
      'deliveryTime': 'วันที่จัดส่งสินค้า',
      'today': 'ปริมาณที่ผลิตได้วันนี้',
      'completed': '已生產完成',
      'fastestdelivery': '預估交期',
      'please_enter_date1': 'วันที่เริ่มต้นของการส่งสินค้า',
      'please_enter_date2': 'วันที่สิ้นสุดของการส่งสินค้า',
      'Meter': 'เมตร',
      'Yard': 'สนาม',
      'Gross': 'ยอดรวม'
    }
  },
  'data': {
    'Device': {
      'name': 'เครื่องจักร',
      'date': 'วันที่',
      'group': 'กลุ่ม',
      'output': 'ผลิตผลที่ได้',
      'unit': 'หน่วย',
      'runTotalTime': 'เวลาทำงานทั้งหมด',
      'stopTime': 'หยุดเวลา',
      'stopTotalTime': 'หยุดเวลาทั้งหมด',
      'error1Time': 'จำนวนครั้งที่ผิดพลาดของเส้นด้ายแนวดิ่ง',
      'error1TotalTime': 'เวลาที่ผิดพลาดของเส้นด้ายแนวดิ่ง',
      'error2Time': 'จำนวนครั้งที่ผิดพลาดของเส้นด้ายทางขวาง',
      'error2TotalTime': 'เวลาที่ผิดพลาดของเส้นด้ายทางขวาง',
      'error3Time': '',
      'error3TotalTime': '',
      'error4Time': '',
      'error4TotalTime': '',
      'S': 'วินาที',
      'M': 'นาที',
      'H': 'ชั่วโมง',
      'D': 'วัน',
      'Meter': 'เมตร',
      'output_report': 'รายงานคำนวณการผลิต',
      'run_report': 'รายงานสถานะการปฏิบัติหน้าที่',
      'please_enter': 'โปรดเลือก',
      'please_enter_date': 'โปรดเลือกวันที่',
      'start_date': 'วันที่เริ่มต้น',
      'end_date': 'วันที่สิ้นสุด',
      'ok': 'บันทึก',
      'out': 'ส่งออก',
      'status': 'สถานะการทำงาน'
    },
    'Order': {
      'orderNo': 'เลขที่การสั่งซื้อ',
      'productNo': 'หมายเลขผลิตภัณฑ์',
      'collectorName': 'เครื่องจักร',
      'salesman': 'ยอดการขาย',
      'customer': 'ลูกค้า',
      'ordersTime': 'วันที่สั่งซื้อ',
      'productTime': 'เวลาการผลิต',
      'output': 'ผลลัพธ์ปัจจุบัน',
      'target': 'เป้าหมายส่งออก',
      'num': 'ปริมาณการสั่งซื้อ',
      'unit': 'หน่วย',
      'deliveryTime': 'วันที่จัดส่งใบสั่ง',
      'Meter': 'เมตร',
      'Yard': 'สนาม',
      'Gross': 'ยอดรวม',
      'Order_report': 'รายงานการสั่งซื้อ',
      'ok': 'บันทึก',
      'out': 'ส่งออก',
      'please_enter': 'โปรดเลือก',
      'please_enter_date': 'โปรดเลือกวันที่',
      'start_date': 'วันที่เริ่มต้น',
      'end_date': 'วันที่สิ้นสุด',
      'time_range': 'Time range',
      'No_scheduling': 'ไม่มีการจัดกำหนดการ',
      'Not_production': 'ไม่นำไปผลิต',
      'Producting': 'ดำเนินการในการผลิต',
      'Case_closed': 'จบงาน',
      'status': 'สถานภาพ',
      'history': 'ประวัติการสั่งซื้อ'
    }
  },
  'setting': {
    'Basic_Information': 'ข้อมูลพื้นฐาน',
    'company_information': 'ข้อมูลบริษัท:',
    'Contact_information': 'ช่องทางการติดต่อ',
    'save': 'บันทึก',
    'please_enter': 'โปรดใส่ข้อมูล',
    'username': 'ชื่อผู้ใช้:',
    'name': 'ชื่อ-นามสกุล:',
    'company': 'บริษัท:',
    'workNo': 'หมายเลขงาน',
    'department': 'แผนก',
    'workPosition': 'ตำแหน่ง:',
    'role': 'หน้าที่:',
    'phone': 'โทรศัพท์:',
    'eMail': 'อีเมล:',
    'qq': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
    'wechat': 'วีแชท:',
    'System_setting': 'การตั้งค่าระบบ',
    'language': 'ภาษา',
    'zhcn': '簡體中文',
    'zhtw': '繁體中文',
    'enUS': 'English',
    'jaJP': '日本語',
    'viVN': 'Việt Nam - Tiếng việt',
    'thTH': 'ไทย - ไทย (แปรตรงตัว)'
  },
  'plan': {
    'Collector': {
      'search': 'ชื่อเครื่องจักร',
      'name': 'เครื่องจักร',
      'one': 'รอบที่ 1',
      'two': 'รอบที่ 2',
      'three': 'รอบที่ 3',
      'four': 'รอบที่ 4',
      'fiv': 'รอบที่ 5',
      'six': 'รอบที่ 6',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'productNo': 'หมายเลขผลิตภัณฑ์',
      'row': 'หมายเลขสายพาน',
      'delete_message': 'คุณแน่ใจหรือไม่ว่าต้องการหยุดการผลิต?',
      'yes': 'เริ่มต้น',
      'no': 'หยุด'
    },
    'Order': {
      'orderNo': 'เลขที่การสั่งซื้อ',
      'customer': 'ลูกค้า',
      'ordersTime': 'วันที่สั่งซื้อ',
      'salesman': 'ยอดการขาย',
      'index': 'หมายเลข',
      'productNo': 'หมายเลขการผลิต',
      'num': 'จำนวน',
      'unit': 'หน่วย',
      'attritionRate': 'อัตราความเสียหาย (%)',
      'output': 'จำนวนที่เสร็จสิ้น',
      'deliveryTime': 'วันที่จัดส่ง',
      'action': 'การดำเนินการ',
      'Meter': 'เมตร',
      'Yard': 'สนาม',
      'Gross': 'ยอดรวม',
      'delete_message': 'คุณแน่ใจหรือไม่ว่าต้องการปิดการสั่งซื้อ?',
      'case1': 'ปิดยอดการขาย',
      'case2': 'จบงาน'
    },
    'Production': {
      'productNo': 'หมายเลขผลิตภัณฑ์',
      'productName': '產品名稱',
      'deliveryTime': 'วันที่จัดส่งใบสั่ง',
      'num': 'จำนวน',
      'name': 'ชื่อเครื่องจักร',
      'count': 'หมายเลขสายพาน',
      'width': 'ความกว้าง',
      'collectorName': 'ชื่อเครื่องจักร',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'planIndex': 'รอบ',
      'row': 'หมายเลขสายพาน',
      'action': 'การดำเนินการ',
      'delete': 'ลบทิ้ง',
      'error': 'เกิดข้อผิดพลาด',
      'error_message': '<p>ยังไม่ได้เลือกประเภท</p>',
      'planClick': 'รายการแผนการผลิต',
      'please_enter': 'โปรดใส่ข้อมูล',
      'deviceNo': 'สิ่งของ',
      'save': 'บันทึก',
      'save1': 'ส่งการสั่งซื้อ',
      'save2': 'ใส่คำสั่งซื้อ',
      'save3': 'ลำดับขนาน',
      'No_scheduling': 'ไม่มีการจัดกำหนดการ',
      'Not_production': 'ไม่นำไปผลิต',
      'Producting': 'ดำเนินการในการผลิต',
      'Case_closed': 'จบงาน',
      'status': 'สถานภาพ',
      'no': 'หยุด',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'searchCollector': 'ชื่อเครื่องจักร',
      'chooose_order': '1.選擇訂單',
      'choose_device': '2.選擇機台',
      'choose_plan': '3.排產計畫',
      'list': 'รายการแผนการผลิต',
      'message': '此產品已經結案'
    }
  },
  'People': {
    'index': 'หมายเลข',
    'name': 'ชื่อ-นามสกุล',
    'workNo': 'หมายเลขพนักงาน',
    'sex': 'เพศ',
    'boy': 'ชาย',
    'girl': 'หญิง',
    'phone': 'โทรศัพท์',
    'entryTime': 'เวลาเข้างาน',
    'wechat': 'วีแชท',
    'qq': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
    'working': 'ในงาน',
    'working1': 'ในงาน',
    'working2': 'การออกไป',
    'yes': 'ใช่',
    'no': 'ไม่',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'edit_People': 'แก้ไขข้อมูลพนักงาน',
    'Return_to_People_list': 'กลับสู่หน้ารายชื่อพนักงาน',
    'please_enter': 'โปรดใส่ข้อมูล',
    'please_enter_date': 'โปรดเลือกวันที่',
    'save': 'บันทึก'
  },
  'Maintain': {
    'index': 'หมายเลข',
    'DeviceName': 'ชื่อเครื่องจักร',
    'username': 'ผู้ปฏิบัติการ',
    'startTime': 'เวลาเริ่มต้น',
    'endTime': 'เวลาที่สิ้นสุด',
    'remark': 'หมายเหตุ',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'edit_Maintain': 'แก้ไขบันทึกการบำรุงรักษา',
    'Return_to_Maintain_list': 'กลับสู่หน้ารายการการบำรุงรักษา',
    'save': 'บันทึก',
    'please_enter': 'โปรดใส่ข้อมูล',
    'please_enter_date1': 'วันที่เริ่มต้นของเวลาเริ่มต้น',
    'please_enter_date2': 'วันที่สิ้นสุดของเวลาเริ่มต้น'
  },
  'Permission': {
    'super_admin': 'การตั้งค่าระบบขั้นสุด',
    'system': 'การตั้งค่าระบบ',
    'device': 'การตั้งค่าอุปกรณ์',
    'card': 'การตั้งค่าการ์ด',
    'people': 'การตั้งค่าบุคคล',
    'product': 'การตั้งค่าผลิตภัณฑ์',
    'order': 'การตั้งค่าการสั่งซื้อ',
    'production_plan': 'การวางแผนผลิตภัณฑ์',
    'monitor': 'การตรวจสอบแบบเรียลไทม์',
    'report_export': 'รายงาน',
    'R': 'อ่าน',
    'W': 'เขียน',
    'RW': 'อ่านและเขียน'
  }
}, __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US___default.a, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_th___default.a);

/* harmony default export */ __webpack_exports__["a"] = (thTH);

/***/ }),

/***/ "KmGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SystemInfo',
  data: function data() {
    return {
      systemName: '',
      name: '',
      contact: '',
      address: '',
      phone: '',
      eMail: '',
      fax: '',
      warnLimitTime: '',
      permissions: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].system.get().then(function (res) {
      var info = res.company;
      _this.systemName = info.systemName;
      _this.name = info.name;
      _this.contact = info.contact;
      _this.address = info.address;
      _this.phone = info.phone;
      _this.eMail = info.eMail;
      _this.fax = info.fax;
      _this.language = info.language;
      _this.warnLimitTime = info.warnLimitTime;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          _this.permissions = true;
        }
      }
    });
  },

  methods: {
    save: function save() {
      var _this2 = this;

      var info = {
        systemName: this.systemName,
        name: this.name,
        contact: this.contact,
        address: this.address,
        phone: this.phone,
        eMail: this.eMail,
        fax: this.fax,
        warnLimitTime: this.warnLimitTime
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].system.save(info).then(function () {
        _this2.$Message.config({
          top: 80,
          duration: 2
        });
        _this2.$Message.success(_this2.$t('system.SystemInfo.save_success'));
      });
    }
  }
});

/***/ }),

/***/ "Kyfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('Product.Return_to_Product_list')))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"model":_vm.formValidate,"rules":_vm.ruleValidate}},[_c('FormItem',{attrs:{"label":_vm.$t('Product.productNo'),"prop":"productNo"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.please_enter')},model:{value:(_vm.formValidate.productNo),callback:function ($$v) {_vm.$set(_vm.formValidate, "productNo", $$v)},expression:"formValidate.productNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Product.name'),"prop":"name"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.please_enter')},model:{value:(_vm.formValidate.name),callback:function ($$v) {_vm.$set(_vm.formValidate, "name", $$v)},expression:"formValidate.name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Product.latDensity'),"prop":"latDensity"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.please_enter_latDensity')},model:{value:(_vm.formValidate.latDensity),callback:function ($$v) {_vm.$set(_vm.formValidate, "latDensity", $$v)},expression:"formValidate.latDensity"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Product.kaidu'),"prop":"kaidu"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.please_enter_kaidu')},model:{value:(_vm.formValidate.kaidu),callback:function ($$v) {_vm.$set(_vm.formValidate, "kaidu", $$v)},expression:"formValidate.kaidu"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Product.width'),"prop":"width"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.please_enter_mm')},model:{value:(_vm.formValidate.width),callback:function ($$v) {_vm.$set(_vm.formValidate, "width", $$v)},expression:"formValidate.width"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Product.specifications')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('Product.please_enter')},model:{value:(_vm.formValidate.specifications),callback:function ($$v) {_vm.$set(_vm.formValidate, "specifications", $$v)},expression:"formValidate.specifications"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('Product.valid')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.formValidate.valid},model:{value:(_vm.formValidate.valid),callback:function ($$v) {_vm.$set(_vm.formValidate, "valid", $$v)},expression:"formValidate.valid"}},[_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t('Product.yes')))]),_vm._v(" "),_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t('Product.no')))])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('Product.save')))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L/Dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collector-page"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('device.group.New_group')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('device.group.New_group')))]):_vm._e(),_vm._v(" "),_c('Table',{staticClass:"collector-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWWJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6bda80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("MZ20");
function injectStyle (ssrContext) {
  __webpack_require__("Hn9d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6bda80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZ20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mk4P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MqqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraRow_vue__ = __webpack_require__("jUdn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bb2cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraRow_vue__ = __webpack_require__("EaHT");
function injectStyle (ssrContext) {
  __webpack_require__("Xfvy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30bb2cac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bb2cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MzWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("fLcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ecdbb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("4oGB");
function injectStyle (ssrContext) {
  __webpack_require__("ib24")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50ecdbb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ecdbb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Role',
  data: function data() {
    return {
      // columns: [
      //   { type: 'index', title: this.$t('system.Role.index') },
      //   { title: this.$t('system.Role.name'), key: 'name' },
      //   { title: this.$t('system.Role.Authorization'), key: 'Authorization' },
      //   // {
      //   //   title: this.$t('system.Role.Authorization'),
      //   //   key: 'permissions',
      //   //   render: (h, params) => {
      //   //     let ps = []
      //   //     for (var v of params.row.permissions) {
      //   //       let per = this.permissions[v.action]
      //   //       if (per !== undefined) {
      //   //         ps.push(per + '-' + Api.permission.permissionValue(v.value))
      //   //       }
      //   //     }
      //   //     return h('span', ps.join())
      //   //   }
      //   // },
      //   {
      //     title: this.$t('system.Role.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissionscheck === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.Role.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.Role.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.Role.delete'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.Role.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small',
      //               disabled: true
      //             }
      //           }, this.$t('system.Role.delete'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      permissionscheck: false
    };
  },

  computed: {
    permissions: function permissions() {
      return this.$store.getters.permissions;
    }
  },
  methods: {
    edit: function edit(id) {
      // let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'RoleEdit', params: { id: id } });
    },
    remove: function remove(id, index) {
      var _this = this;

      this.$api.role.delete(id).then(function () {
        _this.datas.splice(index, 1);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          _this2.permissionscheck = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.permissionsInited) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('InitPermissions');
    }
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].role.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.roles;
        var per = [];
        per.super_admin = vm.$t('Permission.super_admin');
        per.system = vm.$t('Permission.system');
        per.device = vm.$t('Permission.device');
        per.card = vm.$t('Permission.card');
        per.people = vm.$t('Permission.people');
        per.product = vm.$t('Permission.product');
        per.order = vm.$t('Permission.order');
        per.production_plan = vm.$t('Permission.production_plan');
        per.monitor = vm.$t('Permission.monitor');
        per.report_export = vm.$t('Permission.report_export');
        for (var i = 0; i < vm.datas.length; i++) {
          vm.datas[i].Authorization = '';
          var c = false;
          if (vm.datas[i].permissions !== undefined) {
            for (var j = 0; j < vm.datas[i].permissions.length; j++) {
              if (c === true) {
                vm.datas[i].Authorization += ',';
              }
              vm.datas[i].Authorization += per[vm.datas[i].permissions[j].action] + '-';
              if (vm.datas[i].permissions[j].value === 1) {
                vm.datas[i].Authorization += vm.$t('Permission.R');
              } else if (vm.datas[i].permissions[j].value === 2) {
                vm.datas[i].Authorization += vm.$t('Permission.W');
              } else {
                vm.datas[i].Authorization += vm.$t('Permission.RW');
              }
              c = true;
            }
          }
        }
      });
    });
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__ = __webpack_require__("+skl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_user__ = __webpack_require__("vMJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_account__ = __webpack_require__("nv77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_zh_cn__ = __webpack_require__("jApH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lang_en_US__ = __webpack_require__("Zavm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lang_zh_tw__ = __webpack_require__("QzrA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_ja_JP__ = __webpack_require__("R/9V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lang_vi_VN__ = __webpack_require__("TDoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lang_th_TH__ = __webpack_require__("Kktf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_qriously__ = __webpack_require__("f3u+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_qriously___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_qriously__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import 'element-ui/lib/theme-default/menu.css'
// import 'element-ui/lib/theme-default/menu-item.css'
// import 'element-ui/lib/theme-default/submenu.css'









// import { Api1 } from '@/api'









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Menu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Submenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["MenuItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["FormItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Form"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Table"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["TableColumn"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Button"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_qriously___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_iview___default.a, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].locale = function () {};

__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale___default.a.i18n(function (key, value) {
  return _i18n.t(key, value);
});

var _i18n = new __WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]({
  locale: 'en-US',
  messages: {
    'zh-cn': __WEBPACK_IMPORTED_MODULE_12__lang_zh_cn__["a" /* default */],
    'en-US': __WEBPACK_IMPORTED_MODULE_13__lang_en_US__["a" /* default */],
    'zh-tw': __WEBPACK_IMPORTED_MODULE_14__lang_zh_tw__["a" /* default */],
    'ja-JP': __WEBPACK_IMPORTED_MODULE_15__lang_ja_JP__["a" /* default */],
    'vi-VN': __WEBPACK_IMPORTED_MODULE_16__lang_vi_VN__["a" /* default */],
    'th-TH': __WEBPACK_IMPORTED_MODULE_17__lang_th_TH__["a" /* default */]
  }
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.start();
  next();
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].afterEach(function (to, from, next) {
  if (localStorage.language) {
    _i18n.locale = localStorage.language;
  } else {
    __WEBPACK_IMPORTED_MODULE_10__api_user__["a" /* default */].fetchUserInfo().then(function (res) {
      __WEBPACK_IMPORTED_MODULE_11__api_account__["a" /* default */].get(res.user.id).then(function (res) {
        _i18n.locale = res.account.language;
      });
    });
  }
  __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.finish();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  i18n: _i18n,
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "NWon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{hideSidebar:!_vm.menusOpened}},[_c('nav-bar'),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('side-bar',{staticClass:"sidebar-container",attrs:{"menus":_vm.menus,"opened":_vm.menusOpened}}),_vm._v(" "),_c('app-main')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NYpG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NjDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var orderPlan = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/orderPlan/list');
  },
  close: function close(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/orderPlan/close', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (orderPlan);

/***/ }),

/***/ "NjT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192918a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("zBR/");
function injectStyle (ssrContext) {
  __webpack_require__("o8SI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-192918a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192918a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nnqw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loginForm: {
        username: '',
        password: '',
        systemCode: ''
      }
    };
  },

  methods: {
    handleLogin: function handleLogin() {
      var _this = this;

      this.$api.user.login(this.loginForm.username, this.loginForm.password, this.loginForm.systemCode).then(function (res) {
        localStorage.bearer = res.bearer;
        _this.$router.push({ path: '/' });
      }).catch(function (error) {
        _this.$Message.error(error.errMsg);
      });
    },
    Changelanguage: function Changelanguage(v) {
      this.$i18n.locale = v;
    }
  }
});

/***/ }),

/***/ "Ox8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-time-page"},[(_vm.permissions === true && _vm.check === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.workTime.New_workTime")))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true || _vm.check !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.workTime.New_workTime")))]):_vm._e(),_vm._v(" "),_c('el-table',{staticClass:"work-time-table",attrs:{"highlight-row":"","stripe":"","border":"","data":_vm.datas}},[_c('el-table-column',{attrs:{"type":"index","label":_vm.$t('system.workTime.index'),"width":"65px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('system.workTime.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":_vm.$t('system.workTime.startTime')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endTime","label":_vm.$t('system.workTime.endTime')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('system.workTime.operating'),"width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.permissions === true)?_c('el-button',{attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){_vm.edit(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('system.workTime.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true)?_c('el-button',{attrs:{"type":"danger","size":"small"},nativeOn:{"click":function($event){_vm.remove(scope.row.id, scope.$index)}}},[_vm._v(_vm._s(_vm.$t('system.workTime.delete')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"primary","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.workTime.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"danger","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.workTime.delete')))]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PFuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Plan',
  data: function data() {
    return {
      collectorPlanDatas: [],
      search: '',
      list: [],
      permissions: false
    };
  },

  methods: {
    exporePlan: function exporePlan(cindex, index) {
      var content = '<div class="plan-dialog">';
      var p = this.collectorPlanDatas[cindex].plans[index].plans;
      for (var i = 0; i < p.length; i++) {
        content += '<div>';
        content += '<p>' + this.$t('plan.Collector.orderNo') + p[i].orderNo + '</p>';
        content += '<p>' + this.$t('plan.Collector.productNo') + p[i].productNo + '</p>';
        content += '<p>' + this.$t('plan.Collector.row') + p[i].row + '</p>';
        content += '</div>';
      }
      content += '</div>';
      this.$Modal.info({
        title: '',
        content: content
      });
      console.log(index);
    },
    production: function production(cindex) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorPlan.production(this.collectorPlanDatas[cindex].collectorID).then(function () {
        _this.collectorPlanDatas[cindex].producting = 1;
      });
    },
    productionStop: function productionStop(cindex) {
      var _this2 = this;

      if (confirm(this.$t('plan.Collector.delete_message'))) {
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorPlan.productionStop(this.collectorPlanDatas[cindex].collectorID).then(function () {
          _this2.collectorPlanDatas[cindex].producting = 0;
          _this2.collectorPlanDatas[cindex].plans.splice(cindex, 1);
        });
      }
    },
    handleSearch: function handleSearch() {
      this.collectorPlanDatas = [];
      for (var i = 0; i < this.list.length; i++) {
        var p = this.list[i];
        if (p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          this.collectorPlanDatas.push(p);
        }
      }
    },
    handleReset: function handleReset() {
      this.collectorPlanDatas = this.list;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'production_plan' && res.user.permissions[i].value === 3) {
          _this3.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorPlan.list().then(function (res) {
      // let sortBy = function (filed, rev, primer) {
      //   rev = (rev) ? -1 : 1
      //   return function (a, b) {
      //     a = a[filed]
      //     b = b[filed]
      //     if (typeof (primer) !== 'undefined') {
      //       a = primer(a)
      //       b = primer(b)
      //     }
      //     if (a < b) { return rev * -1 }
      //     if (a > b) { return rev * 1 }
      //     return 1
      //   }
      // }
      // res.collectorPlanInfo.sort(sortBy('name', false, parseInt))
      res.collectorPlanInfo.sort(function (a, b) {
        if (a['name'] > b['name']) {
          return 1;
        } else {
          return -1;
        }
      });
      next(function (vm) {
        vm.collectorPlanDatas = res.collectorPlanInfo;
        vm.list = res.collectorPlanInfo;
      });
    });
  }
});

/***/ }),

/***/ "PzfE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QB53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var maintain = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/maintain/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, deviceNo: 'o-001', operator: 'DaviaLi', startTime: '2017-09-01 10:00', endTime: '2017-10-01 11:00', remark: ''},
    //     {id: 2, deviceNo: 'o-001', operator: 'DaviaLi', startTime: '2017-09-01 13:32', endTime: '2017-10-01 14:53', remark: ''}
    //   ]
    //   resolve(data)
    // })
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/maintain/get', { id: id });
  },
  save: function save(m) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/maintain/save', m);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (maintain);

/***/ }),

/***/ "QDL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-type-page"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.workType.New_workType")))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.workType.New_workType")))]):_vm._e(),_vm._v(" "),_c('el-table',{staticClass:"work-type-table",attrs:{"highlight-row":"","stripe":"","border":"","data":_vm.datas}},[_c('el-table-column',{attrs:{"type":"index","label":_vm.$t('system.workType.Sorting'),"width":"85px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('system.workType.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"outputValidName","label":_vm.$t('system.workType.outputValid')}},[_vm._v(_vm._s(_vm.$t('system.workType.yes')))]),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"monopolyName","label":_vm.$t('system.workType.monopoly')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"maintainName","label":_vm.$t('system.workType.maintain')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"displayName","label":_vm.$t('system.workType.display')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"malfunctionName","label":_vm.$t('system.workType.malfunction')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","label":_vm.$t('system.workType.remark')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('system.workType.operating'),"width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.permissions === true)?_c('el-button',{attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){_vm.edit(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('system.workType.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true)?_c('el-button',{attrs:{"type":"danger","size":"small"},nativeOn:{"click":function($event){_vm.remove(scope.row.id, scope.$index)}}},[_vm._v(_vm._s(_vm.$t('system.workType.delete')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"primary","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.workType.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"danger","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.workType.delete')))]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QwKs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QzrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_TW__ = __webpack_require__("WD3H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__("gwsl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW__);




var zhCn = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  menu: {
    home: '首頁',
    system: '系統管理',
    system_management: {
      Role: '角色',
      Department: '部門',
      Account: '帳號',
      WorkTime: '班次',
      WorkType: '工種',
      RoleEdit: '角色管理',
      DepartmentEdit: '部門編輯',
      AccountEdit: '帳號編輯',
      WorkTimeEdit: '班次編輯',
      WorkTypeEdit: '工種編輯',
      systeminfo: '系統資訊',
      SystemAuth: '授權管理'
    },
    Device: '設備管理',
    Device_management: {
      RouterList: '路由器',
      RouterEdit: '路由器編輯',
      Collector: '機台',
      CollectorEdit: '機台編輯',
      CollectorGroup: '機台分組',
      CollectorGroupEdit: '機台分組編輯'
    },
    Card: '卡片管理',
    CardEdit: '卡片編輯',
    People: '人員管理',
    PeopleEdit: '人員編輯',
    Product: '產品管理',
    ProductEdit: '產品編輯',
    Order: '訂單管理',
    OrderEdit: '訂單編輯',
    Plan: '排產管理',
    Plan_Management: {
      Production_plan: '訂單計畫安排',
      Production_management: '投(停)產管理',
      Production_order: '已排產訂單'
    },
    Monitor: '即時監控',
    Monitor_Monitoring: {
      Collector: '機台監控',
      Order: '訂單監控'
    },
    Data: '歷史報表',
    Data_output: {
      Order: '訂單統計',
      device: '設備統計',
      Worker: '人員統計',
      MaintainList: '維修管理',
      MaintainEdit: '維修編輯'
    },
    Setting: '個人設置'
  },
  system: {
    Account: {
      New_account: '新建帳號',
      edit_account: '編輯帳號',
      please_enter: '請輸入',
      please_choose: '請選擇',
      Return_to_account_list: '返回帳號列表',
      User_name: '用戶名',
      User_name_message: '請輸入用戶名',
      Name: '姓名',
      Name_message: '請輸入姓名',
      Role: '角色',
      Role_message: '請選擇角色',
      Worker_number: '工號',
      Department: '部門',
      Department_message: '請選擇部門',
      Telephone: '電話',
      Email: '電子郵箱',
      QQ: 'QQ',
      Wechat: '微信',
      telephone: '電話：',
      email: '電郵：',
      qq: 'ＱＱ帳號：',
      wechat: '微信帳號：',
      save: '保存',
      index: '序號',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      reseat: '重設',
      error: '錯誤',
      error_message1: '<p>帳號重複</p>',
      error_message2: '<p>帳號重複</p>',
      delete_message: '確實要刪除嗎?'
    },
    Department: {
      New_Department: '新建部門',
      edit_Department: '編輯部門',
      index: '序號',
      Department: '部門',
      Authorization: '權限',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      please_enter: '請輸入',
      Return_to_depatement_list: '返回部門列表',
      name: '名稱',
      Move_left: '向左移動',
      Move_right: '向右移動',
      save: '保存',
      All_authorization: '全部許可權',
      Department_authorization: '部門許可權'
    },
    Role: {
      New_Role: '新建角色',
      edit_Role: '編輯角色',
      index: '序號',
      Role: '角色',
      Authorization: '權限',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      please_enter: '請輸入',
      Return_to_role_list: '返回角色列表',
      name: '名稱',
      Move_left: '向左移動',
      Move_right: '向右移動',
      save: '保存',
      All_authorization: '全部權限',
      Role_authorization: '角色權限'
    },
    workTime: {
      New_workTime: '新建班次',
      edit_workTime: '編輯班次',
      index: '序號',
      name: '名稱',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      please_enter: '請輸入',
      please_choose: '選擇時間',
      startTime: '開始時間',
      endTime: '結束時間',
      Return_to_workTime_list: '返回班次列表',
      save: '保存'
    },
    workType: {
      New_workType: '新建工種',
      edit_workType: '編輯工種',
      index: '序號',
      name: '名稱',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確實要刪除嗎?',
      please_enter: '請輸入',
      Return_to_workType_list: '返回工種列表',
      save: '保存',
      yes: '是',
      no: '否',
      outputValid: '計算產量',
      monopoly: '獨佔機台',
      maintain: '維修模式',
      warn: '停機報警',
      Sorting: '排序',
      display: '顯示看板',
      malfunction: '故障計算',
      remark: '備註'
    },
    SystemAuth: {
      Information: '基本資訊',
      systemVersion: '系統版本:',
      systemDealTime: '到期日期:',
      please_enter: '請輸入',
      save: '保存',
      save_success: '保存成功',
      systemAuthCode: '授權碼:'
    },
    SystemInfo: {
      Information: '基本資訊',
      Contect: '聯繫方式',
      systemName: '系統名稱:',
      please_enter: '請輸入',
      name: '企業名稱:',
      contact: '聯繫人:',
      address: '企業地址',
      phone: '聯絡電話:',
      fax: '傳真號碼:',
      eMail: '電子郵箱:',
      save: '保存',
      save_success: '保存成功',
      warnLimitTime: '停機報警間隔:'
    }
  },
  device: {
    collector: {
      New_collector: '新建機台',
      edit_collector: '編輯機台',
      Return_to_collector_list: '返回機台列表',
      name: '名稱',
      deviceNo: '編號',
      routerID: '路由器',
      type: '機器類型',
      computeType: '產能計算方式',
      roller: '滾筒',
      weft_density: '緯密',
      length: '滾筒周長',
      count: '條數',
      width: '出帶寬度',
      deviceCompany: '機器製造商',
      deviceModel: '機器型號',
      buyTime: '機器購買時間',
      deviceLifeTime: '預估使用年限',
      please_enter: '請輸入',
      please_enter_mm: '請輸入(單位:mm)',
      save: '保存',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      error: '錯誤',
      error_message1: '<p>有資料未填寫</p>',
      error_message2: '必須整數',
      remark: '備註',
      Message: {
        name: '請輸入名稱',
        deviceNo: '請輸入編號',
        computeType: '請選擇計算方式',
        routerID: '請選擇所屬路由器',
        length: '請輸入滾筒周長',
        count: '請輸入條數',
        width: '請輸入出帶寬度'
      }
    },
    group: {
      New_group: '新建機器群組',
      edit_group: '編輯機器群組',
      Return_to_group_list: '返回機器群組列表',
      please_enter: '請輸入',
      save: '保存',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      index: '序號',
      name: '名稱',
      devices: '機器',
      chosen: '已選擇',
      remark: '備註',
      width: '寬度',
      router: '路由器'
    },
    router: {
      New_router: '新建路由器',
      edit_router: '編輯路由器',
      Return_to_router_list: '返回路由器列表',
      please_enter: '請輸入',
      index: '序號',
      name: '路由器代號',
      AnotherName: '路由器名稱',
      linkType: '聯網模式',
      channel: '訊號頻道',
      remark: '備註',
      save: '保存',
      action: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      mod: '聯網模式',
      Lan: '區域網路',
      Internet: '網際網路',
      time: '重整',
      save_success: '系統與收集器重整完畢'
    }
  },
  Card: {
    New_Card: '新建卡片',
    edit_Card: '編輯卡片',
    Return_to_Card_list: '返回卡片列表',
    please_enter: '請輸入',
    index: '序號',
    userName: '持有人',
    cardNo: '卡片編號',
    workTypeName: '工種',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    delete_message: '確定要刪除嗎?',
    save: '保存',
    error: '錯誤',
    error_message1: '<p>卡號重複</p>',
    error_message2: '<p>有資料未填寫</p>'
  },
  Product: {
    New_Product: '新建產品',
    edit_Product: '編輯產品',
    Return_to_Product_list: '返回產品列表',
    please_enter: '請輸入',
    index: '序號',
    productNo: '編號',
    name: '名稱',
    latDensity: '緯密',
    kaidu: '開度',
    width: '寬度',
    specifications: '規格',
    valid: '有效',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    delete_message: '確實要刪除嗎?',
    save: '保存',
    error: '錯誤',
    error_message: '<p>有資料未填寫</p>',
    please_enter_kaidu: '请输入（≧1）',
    please_enter_mm: '請輸入（單位：mm）',
    please_enter_latDensity: '請輸入（單位：緯/cm）',
    Message: {
      productNo: '請輸入產品編號',
      name: '請輸入名稱',
      latDensity: '請輸入緯密',
      kaidu: '請輸入開度',
      width: '請輸入寬度'
    }
  },
  Order: {
    New_Order: '新建訂單',
    edit_Order: '編輯訂單',
    Return_to_Order_list: '返回訂單列表',
    please_enter: '請輸入',
    please_enter_date: '請輸入日期',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    save: '保存',
    error: '錯誤',
    error_message1: '<p>未添加產品至訂單</p>',
    error_message2: '<p>訂單資訊未填</p>',
    error_message3: '<p>數量未填</p>',
    error_message4: '<p>單位未填</p>',
    error_message5: '<p>交付未填</p>',
    error_message6: '<p>請先選擇左側產品</p>',
    delete_message: '確定要刪除嗎?',
    change_message: '确定要反結案嗎?',
    orderNo: '訂單編號',
    customer: '客戶',
    ordersTime: '接單日期',
    salesman: '接單業務',
    index: '序號',
    productNo: '產品編號',
    num: '數量',
    unit: '單位',
    attritionRate: '耗損率(%)',
    deliveryTime: '訂單交付日期',
    remark: '備註',
    add: '添加到訂單',
    Product_list: '產品列表',
    search: '編號/名稱',
    No_scheduling: '未排產',
    Not_production: '未投產',
    Producting: '已投產',
    Case_closed: '已結案',
    name: '名稱',
    Meter: '米',
    Yard: '碼',
    Gross: '籮',
    status: '狀態',
    Message: {
      orderNo: '請輸入產品編號',
      ordersTime: '請輸入接單日期',
      customer: '請輸入客戶名',
      salesman: '請輸入業務員'
    }
  },
  Login: {
    username: '請輸入用戶名',
    password: '請輸入密碼',
    systemCode: '請輸入系統號',
    language: '請選擇語言',
    login: '登錄',
    system: '系統登錄',
    changePw: '修改密碼',
    logout: '退出登錄',
    Information: '個人資訊'
  },
  ChangePw: {
    oldPassword: '輸入舊密碼:',
    newPassword: '輸入新密碼:',
    comfirmPassword: '確認新密碼:',
    save: '保存',
    error: '兩次密碼輸入不一致',
    success: '修改成功',
    ChangePw: '修改密碼'
  },
  monitor: {
    Collector: {
      index: '序號',
      name: '名稱',
      group: '群組',
      deviceNo: '編號',
      rpm: '機器轉速',
      status: '機器狀態',
      status1: '設備狀態',
      error: '故障訊息',
      worker: '刷卡人員',
      workType: '刷卡狀態',
      lastTime: '時間',
      timeout: '離線',
      trial: '試運行',
      standby: '待排產',
      run: '生產中',
      orderNo: '訂單',
      producNo: '貨號',
      stop: ' 待機',
      warp: ' 經紗 ',
      weft: ' 緯紗 ',
      thread: ' 底線 ',
      roll: ' 卷取 '
    },
    Order: {
      index: '序號',
      orderNo: '訂單',
      producNo: '貨號',
      salesman: '業務',
      ordersTime: '接單時間',
      output: '產量',
      num: '訂單量',
      unit: '單位',
      countdata: '機台數',
      name: '名稱',
      rpm: '機器轉速',
      worker: '刷卡人員',
      workType: '刷卡狀態',
      DailyOutput: '今日產量',
      deliveryTime: '訂單交期',
      today: '今日產量',
      completed: '已生產完成',
      fastestdelivery: '預估交期',
      please_enter_date1: '訂單交期起始日期',
      please_enter_date2: '訂單交期结束日期',
      Meter: '米',
      Yard: '碼',
      Gross: '籮'
    }
  },
  data: {
    Device: {
      name: '機台',
      date: '日期',
      group: '群組',
      output: '產量',
      unit: '單位',
      runTotalTime: '運行時間',
      stopTime: '停機次數',
      stopTotalTime: '停機時間',
      error1Time: '經紗次數',
      error1TotalTime: '經紗時間',
      error2Time: '緯紗次數',
      error2TotalTime: '緯紗時間',
      error3Time: '底紗次數',
      error3TotalTime: '底紗時間',
      error4Time: '捲曲次數',
      error4TotalTime: '捲曲時間',
      S: '秒',
      M: '分',
      H: '時',
      D: '天',
      Meter: '米',
      output_report: '產能報表',
      run_report: '運行狀況報表',
      please_enter: '請選擇',
      please_enter_date: '請選擇日期',
      start_date: '起始日期',
      end_date: '結束日期',
      ok: '確定',
      out: '輸出',
      status: '運行狀況'
    },
    Order: {
      orderNo: '訂單编号',
      productNo: '貨號',
      collectorName: '機台',
      salesman: '接單業務',
      customer: '客戶',
      ordersTime: '接單時間',
      productTime: '投產時間',
      output: '實際產量',
      target: '目標產量',
      num: '訂單量',
      unit: '單位',
      deliveryTime: '客戶交期',
      Meter: '米',
      Yard: '碼',
      Gross: '籮',
      Order_report: '訂單報表',
      ok: '確定',
      out: '輸出',
      please_enter: '請選擇',
      please_enter_date: '請選擇日期',
      start_date: '起始日期',
      end_date: '結束日期',
      time_range: '時間段',
      No_scheduling: '未排產',
      Not_production: '未投產',
      Producting: '已投產',
      Case_closed: '已結案',
      status: '狀態',
      history: '歷史訂單'
    }
  },
  setting: {
    Basic_Information: '基本資訊',
    company_information: '公司資訊',
    Contact_information: '聯繫方式',
    save: '保存',
    please_enter: '請輸入',
    username: '用戶名:',
    name: '姓名:',
    company: '公司:',
    workNo: '工號:',
    department: '部門:',
    workPosition: '職位:',
    role: '角色:',
    phone: '電話:',
    eMail: '郵箱:',
    qq: 'QQ號碼:',
    wechat: '微信:',
    System_setting: '系統配置',
    language: '語言:',
    zhcn: '簡體中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: '機台篩選',
      name: '機台',
      one: '第一批',
      two: '第二批',
      three: '第三批',
      four: '第四批',
      fiv: '第五批',
      six: '第六批',
      orderNo: '訂單號:',
      productNo: '產品號:',
      row: '條數:',
      delete_message: '確定是否停產?',
      yes: '投產',
      no: '停產'
    },
    Order: {
      orderNo: '訂單號',
      customer: '客戶',
      ordersTime: '接單日期',
      salesman: '業務員',
      index: '序號',
      productNo: '產品編號',
      num: '數量',
      unit: '單位',
      attritionRate: '耗損率(%)',
      output: '完成數',
      deliveryTime: '交付日期',
      action: '操作',
      Meter: '米',
      Yard: '碼',
      Gross: '籮',
      delete_message: '確實是否結案?',
      case1: '結案',
      case2: '已結案'
    },
    Production: {
      productNo: '產品號',
      productName: '產品名稱',
      deliveryTime: '客戶交期',
      num: '數量',
      name: '機台名稱',
      count: '條數',
      width: '寬度',
      collectorName: '機台名稱',
      orderNo: '訂單號',
      planIndex: '批次',
      row: '條數',
      action: '操作',
      delete: '刪除',
      error: '錯誤',
      error_message: '<p>條數未選擇</p>',
      planClick: '已排產計畫列表',
      please_enter: '請輸入',
      deviceNo: '編號',
      save: '確定',
      save1: '派單',
      save2: '插單',
      save3: '並產',
      No_scheduling: '未排產',
      Not_production: '未投產',
      Producting: '已投產',
      Case_closed: '已結案',
      status: '狀態',
      no: '停產',
      delete_message: '確實要刪除嗎?',
      searchCollector: '機台名稱',
      chooose_order: '1.選擇訂單',
      choose_device: '2.選擇機台',
      choose_plan: '3.排產計畫',
      list: '已排產計畫列表',
      message: '此產品已經結案'
    }
  },
  People: {
    index: '序號',
    name: '姓名',
    workNo: '工號',
    sex: '性別',
    boy: '男',
    girl: '女',
    phone: '電話',
    entryTime: '入職時間',
    wechat: '微信號',
    qq: 'QQ號',
    working: '在職',
    working1: '在職',
    working2: '離職',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '編輯',
    edit_People: '編輯人員',
    Return_to_People_list: '返回人員列表',
    please_enter: '請輸入',
    please_enter_date: '選擇日期',
    save: '保存'
  },
  Maintain: {
    index: '序號',
    DeviceName: '機台名稱',
    username: '維修人員',
    startTime: '開始時間',
    endTime: '結束時間',
    remark: '備註',
    action: '操作',
    edit: '編輯',
    edit_Maintain: '編輯維修紀錄',
    Return_to_Maintain_list: '返回維修列表',
    save: '保存',
    please_enter: '請輸入',
    please_enter_date1: '開始時間起始日期',
    please_enter_date2: '開始時間结束日期'
  },
  Permission: {
    super_admin: '超級系統管理',
    system: '系統管理',
    device: '設備管理',
    card: '卡片管理',
    people: '人員管理',
    product: '產品管理',
    order: '訂單管理',
    production_plan: '排產管理',
    monitor: '即時監控',
    report_export: '歷史報表',
    R: '讀',
    W: '寫',
    RW: '讀寫'
  }
}, __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_TW___default.a, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW___default.a);

/* harmony default export */ __webpack_exports__["a"] = (zhCn);

/***/ }),

/***/ "R/9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_ja_JP__ = __webpack_require__("j9N1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_ja_JP___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_ja_JP__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ja__ = __webpack_require__("znjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ja__);




var jaJP = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  menu: {
    home: 'ホームページ',
    system: 'システム設定',
    system_management: {
      Role: '役割',
      Department: '部門',
      Account: 'アカウント',
      WorkTime: 'シフト',
      WorkType: '労働者タイプ',
      RoleEdit: '役割編集',
      DepartmentEdit: '部門編集',
      AccountEdit: 'アカウント編集',
      WorkTimeEdit: 'シフト編集',
      WorkTypeEdit: 'ワーカータイプ編集',
      systeminfo: 'システム情報',
      SystemAuth: '承認管理'
    },
    Device: '設備設定',
    Device_management: {
      RouterList: 'ルーター',
      RouterEdit: 'ルーター編集',
      Collector: '設備',
      CollectorEdit: '設備編集',
      CollectorGroup: 'マシングループ',
      CollectorGroupEdit: 'マシングループ編集'
    },
    Card: 'カード設定',
    CardEdit: 'カード編集',
    People: '人員設定',
    PeopleEdit: '人員編集',
    Product: '製品管理',
    ProductEdit: '製品編集',
    Order: '注文管理',
    OrderEdit: '注文編集',
    Plan: '生産管理',
    Plan_Management: {
      Production_plan: 'オーダー管理',
      Production_management: 'オーダー調整管理',
      Production_order: 'オーダースケジュール'
    },
    Monitor: 'モニタリング',
    Monitor_Monitoring: {
      Collector: '設備',
      Order: '注文管理'
    },
    Data: 'レポート',
    Data_output: {
      Order: '注文管理',
      device: '設備設定',
      Worker: '人員履歴',
      MaintainList: 'メンテナンス履歴',
      MaintainEdit: 'メンテナンス編集'
    },
    Setting: 'ユーザー設定'
  },
  system: {
    Account: {
      New_account: '新規アカウント作成',
      edit_account: 'アカウント編集',
      please_enter: '入力してください',
      please_choose: '選んでください',
      Return_to_account_list: 'アカウントリストに戻る',
      User_name: 'ユーザー名',
      User_name_message: 'ユーザー名を入力してください',
      Name: '名前',
      Name_message: '名前を入力してください',
      Role: '役割',
      Role_message: '役割を選択してください',
      Worker_number: '労働者番号',
      Department: '部門',
      Department_message: '部門を選択してください',
      Telephone: '電話',
      Email: 'Eメール',
      QQ: 'QQ',
      Wechat: 'Wechat',
      telephone: '電話',
      email: 'Eメール',
      qq: 'QQ',
      wechat: 'Wechat',
      save: '保存',
      index: 'No.',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      reseat: 'リセット',
      error: 'エラー',
      error_message1: '<p>アカウント重複</ p>',
      error_message2: '<p>アカウント重複</ p>',
      delete_message: '削除しますか？'
    },
    Department: {
      New_Department: '新規部門',
      edit_Department: '部門編集',
      index: 'No.',
      Department: '部門',
      Authorization: '承認',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      Return_to_depatement_list: '部門リストに戻る',
      name: '名前',
      Move_left: '左に移動する',
      Move_right: '右に移動する',
      save: '保存',
      All_authorization: '全承認',
      Department_authorization: '部署承認'
    },
    Role: {
      New_Role: '新規役割',
      edit_Role: '役割編集',
      index: 'No.',
      Role: '役割',
      Authorization: '承認',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      Return_to_role_list: '役割リストに戻る',
      name: '名前',
      Move_left: '左に移動する',
      Move_right: '右に移動する',
      save: '保存',
      All_authorization: '全承認',
      Role_authorization: 'ロール認証'
    },
    workTime: {
      New_workTime: '新しいシフト',
      edit_workTime: 'シフト編集',
      index: 'No.',
      name: '名前',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      please_choose: '選んでください',
      startTime: '始動時間',
      endTime: '終了時間',
      Return_to_workTime_list: 'シフトリストに戻す',
      save: '保存'
    },
    workType: {
      New_workType: '新しいワーカータイプ',
      edit_workType: 'ワーカータイプの編集',
      index: 'No.',
      name: '名前',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      please_enter: '入力してください',
      Return_to_workType_list: 'ワーカータイプリストに戻る',
      save: '保存',
      yes: 'はい',
      no: 'いいえ',
      outputValid: '効果的な生産',
      monopoly: '占有機',
      maintain: 'モードを維持する',
      warn: 'シャットダウンアラーム',
      Sorting: '並べ替え',
      display: 'ダッシュボード',
      malfunction: 'フォルト計算',
      remark: 'リマーク'
    },
    SystemAuth: {
      Information: '情報',
      systemVersion: 'システムバージョン：',
      systemDealTime: '有効期限：',
      please_enter: '入力してください',
      save: '保存',
      save_success: '保存成功',
      systemAuthCode: '認証番号'
    },
    SystemInfo: {
      Information: '情報',
      Contect: '連絡',
      systemName: 'システム名：',
      please_enter: '入力してください',
      name: '名前',
      contact: 'コンテント名：',
      address: '会社住所：',
      phone: '電話：',
      fax: 'ファックス：',
      eMail: 'Eメール',
      save: '保存',
      save_success: '保存成功',
      warnLimitTime: 'シャットダウンアラーム間隔：'
    }
  },
  device: {
    collector: {
      New_collector: '新規設備',
      edit_collector: '設備編集',
      Return_to_collector_list: 'マシンリストに戻る',
      name: '名前',
      deviceNo: 'No.',
      routerID: 'ルーター',
      type: 'マシンタイプ',
      computeType: '生産量計算方法',
      length: 'ローラー円周',
      count: '幅番号',
      width: 'テープ幅',
      deviceCompany: '設備メーカー',
      deviceModel: '設備モデル番号',
      buyTime: '購入時間',
      deviceLifeTime: '購入年数（年）',
      please_enter: '入力してください',
      please_enter_mm: '入力してください（単位：mm）',
      save: '保存',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      error: 'エラー',
      error_message1: '<p>アカウント重複</ p>',
      error_message2: '<p>アカウント重複</ p>',
      remark: 'リマーク',
      Message: {
        name: '名前',
        deviceNo: 'No.',
        computeType: '生産量計算方法',
        routerID: 'ルーター',
        length: 'ローラー円周',
        count: '幅番号',
        width: 'テープ幅'
      }
    },
    group: {
      New_group: '新しいマシングループ',
      edit_group: 'マシングループの編集',
      Return_to_group_list: 'マシングループリストに戻る',
      please_enter: '入力してください',
      save: '保存',
      operating: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      index: 'No.',
      name: '名前',
      chosen: '選択しました',
      devices: '機械',
      remark: 'リマーク',
      width: 'テープ幅',
      router: 'ルーター'
    },
    router: {
      New_router: '新しいルーター',
      edit_router: 'ルータの編集',
      Return_to_router_list: 'ルータのリストに戻る',
      please_enter: '入力してください',
      index: 'No.',
      name: '名前',
      AnotherName: 'ルータ名',
      linkType: 'ネットワークタイプ',
      channel: 'シグナルチャネル',
      remark: 'リマーク',
      save: '保存',
      action: '操作',
      edit: '編集',
      delete: '削除',
      delete_message: '削除しますか？',
      mod: 'ネットワークタイプ',
      Lan: 'ローカルLAN',
      Internet: 'インターネット',
      time: '並べ替え',
      save_success: '保存成功'
    }
  },
  Card: {
    New_Card: '新しいカード',
    edit_Card: 'カード編集',
    Return_to_Card_list: 'カードリストに戻る',
    please_enter: '入力してください',
    index: 'No.',
    userName: '所有者',
    cardNo: 'カード番号',
    workTypeName: 'ワークタイプ',
    action: '操作',
    edit: '編集',
    delete: '削除',
    delete_message: '削除しますか？',
    save: '保存',
    error: 'エラー',
    error_message1: '<p>アカウント重複</ p>',
    error_message2: '<p>アカウント重複</ p>'
  },
  Product: {
    New_Product: '新製品',
    edit_Product: '商品の編集',
    Return_to_Product_list: '製品リストに戻る',
    please_enter: '入力してください',
    index: 'No.',
    productNo: 'No.',
    name: '名前',
    latDensity: '緯糸密度',
    kaidu: 'テンション',
    width: 'テープ幅',
    specifications: '仕様',
    valid: '有効性',
    yes: 'はい',
    no: 'いいえ',
    action: '操作',
    edit: '編集',
    delete: '削除',
    delete_message: '削除しますか？',
    save: '保存',
    error: 'エラー',
    error_message: '<p>情報が完成していません</ p>',
    please_enter_mm: '入力してください（単位：mm）',
    please_enter_kaidu: '入力してください（≧1）',
    please_enter_latDensity: '入力してください（単位：weft / cm）',
    Message: {
      productNo: 'No.',
      name: '名前',
      latDensity: '緯糸密度',
      kaidu: 'テンション',
      width: 'テープ幅'
    }
  },
  Order: {
    New_Order: '新規注文',
    edit_Order: '注文の編集',
    Return_to_Order_list: '注文リストに戻る',
    please_enter: '入力してください',
    please_enter_date: '日付を入力してください',
    action: '操作',
    edit: '編集',
    delete: '削除',
    save: '保存',
    error: 'エラー',
    error_message1: '<p>アカウント重複</ p>',
    error_message2: '<p>アカウント重複</ p>',
    error_message3: '<p>数量が完了していません</ p>',
    error_message4: '<p>ユニットが未完了です</ p>',
    error_message5: '<p>配達日が未完了</ p>',
    error_message6: '<p>請先選擇左側產品</p>',
    delete_message: '削除しますか？',
    change_message: 'あなたはケースを開きたいですか？',
    orderNo: '注文番号',
    customer: '顧客',
    ordersTime: '注文日',
    salesman: '販売',
    index: 'No.',
    productNo: 'No.',
    num: '数量',
    unit: '単位',
    attritionRate: 'ロス率（％）',
    deliveryTime: '出荷日',
    remark: 'リマーク',
    add: '注文に追加',
    Product_list: '製品リスト',
    search: '項目名',
    No_scheduling: '生産スケジュールなし',
    Not_production: '生産なし',
    Producting: '生産スケジュール始めて',
    Case_closed: '生産終了',
    name: '名前',
    Meter: 'メーター',
    Yard: 'ヤード',
    Gross: 'グロス',
    status: '状態',
    Message: {
      orderNo: '注文番号',
      ordersTime: '注文日',
      customer: '顧客',
      salesman: '販売'
    }
  },
  Login: {
    username: 'ユーザー名を入力してください',
    password: 'パスワードを入力してください',
    systemCode: 'システムコードを入力してください',
    language: '言語を選択してください',
    login: 'ログイン',
    system: 'システム設定',
    changePw: 'パスワードを変更する',
    logout: 'ログアウト',
    Information: '情報'
  },
  ChangePw: {
    oldPassword: '古いパスワードを入力：',
    newPassword: '新しいパスワードを入力してください',
    comfirmPassword: '新しいパスワードを確認する',
    save: '保存',
    error: 'エラー',
    success: '変更を正常に完了',
    ChangePw: 'パスワードを変更する'
  },
  monitor: {
    Collector: {
      index: 'No.',
      name: '名前',
      group: 'グループ',
      deviceNo: 'No.',
      rpm: 'マシンRPM',
      status: '状態',
      status1: 'デバイスステータス',
      error: 'エラー',
      worker: '人員履歴',
      workType: '労働者タイプ',
      lastTime: '時間',
      timeout: 'オフライン',
      trial: 'トライアル',
      standby: '待機する',
      run: 'ランニング',
      orderNo: '注文番号',
      producNo: '製品番号',
      stop: '待機する',
      warp: '経糸',
      weft: ' 緯糸',
      thread: ' 糸',
      roll: ' ローラー'
    },
    Order: {
      index: 'No.',
      orderNo: '注文番号',
      producNo: '製品番号',
      salesman: '販売',
      ordersTime: '注文日',
      output: '生産',
      num: '数量',
      unit: '単位',
      countdata: 'マシン番号',
      name: '名前',
      rpm: 'マシンRPM',
      worker: '人員履歴',
      workType: '労働者タイプ',
      DailyOutput: '今日の生産量',
      deliveryTime: '出荷日',
      today: '今日の生産量',
      completed: '生産完了',
      fastestdelivery: '推定日',
      please_enter_date1: '注文の配信開始日',
      please_enter_date2: '注文の配信終了日',
      Meter: 'メーター',
      Yard: 'ヤード',
      Gross: 'グロス'
    }
  },
  data: {
    Device: {
      name: '名前',
      date: '日付',
      group: 'グループ',
      output: '生産',
      unit: '単位',
      runTotalTime: 'ランニングタイム',
      stopTime: 'ダウンタイム',
      stopTotalTime: 'ダウンタイム',
      error1Time: 'ワープ時間',
      error1TotalTime: 'ワープ時間',
      error2Time: '緯糸番号',
      error2TotalTime: '緯糸の時間',
      error3Time: '下糸の本数',
      error3TotalTime: 'ボトムタイム',
      error4Time: 'カール数',
      error4TotalTime: 'カール時間',
      S: '二番目',
      M: '分',
      H: '時間',
      D: '日',
      Meter: 'メーター',
      output_report: '生産量報告',
      run_report: '稼働状況表',
      please_enter: '選択してください',
      please_enter_date: '日付を選択してください',
      start_date: '開始日',
      end_date: '終了日',
      ok: '決定する',
      out: '出力',
      status: '状態'
    },
    Order: {
      orderNo: '注文番号',
      productNo: 'No.',
      collectorName: '設備',
      salesman: '販売',
      customer: '顧客',
      ordersTime: '注文日',
      productTime: '生産時間',
      output: '生産',
      target: '生産目標',
      num: '数量',
      unit: '単位',
      deliveryTime: '出荷日',
      Meter: 'メーター',
      Yard: 'ヤード',
      Gross: 'グロス',
      Order_report: '注文レポート',
      ok: '決定する',
      out: '出力',
      please_enter: '入力してください',
      please_enter_date: '日付を入力してください',
      start_date: '開始日',
      end_date: '終了日',
      time_range: 'Time range',
      No_scheduling: '生産スケジュールなし',
      Not_production: '生産なし',
      Producting: '生産スケジュール始めて',
      Case_closed: '生産終了',
      status: '状態'
    }
  },
  setting: {
    Basic_Information: '基本情報',
    company_information: '会社情報',
    Contact_information: '連絡先情報',
    save: '保存',
    please_enter: '入力してください',
    username: '所有者',
    name: '名前',
    company: '会社：',
    workNo: 'ジョブ番号：',
    department: '部門',
    workPosition: 'ポジション：',
    role: '役割',
    phone: '電話：',
    eMail: 'Eメール',
    qq: 'QQ',
    wechat: 'Wechat',
    System_setting: 'システム構成',
    language: '言語：',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: '項目名',
      name: '名前',
      one: '最初のバッチ',
      two: '2番目のバッチ',
      three: '3番目のバッチ',
      four: '第4バッチ',
      fiv: '第5バッチ',
      six: '第6バッチ',
      orderNo: '注文番号',
      productNo: 'No.',
      row: '本数',
      delete_message: '削除しますか？',
      yes: 'はい',
      no: 'いいえ'
    },
    Order: {
      orderNo: '注文番号',
      customer: '顧客',
      ordersTime: '注文日',
      salesman: '販売',
      index: 'No.',
      productNo: 'No.',
      num: '数量',
      unit: '単位',
      attritionRate: 'ロス率（％）',
      output: '生産',
      deliveryTime: '出荷日',
      action: '操作',
      Meter: 'メーター',
      Yard: 'ヤード',
      Gross: 'グロス',
      delete_message: '削除しますか？',
      case1: 'オーダーを終わります',
      case2: 'オーダー完了'
    },
    Production: {
      productNo: 'No.',
      productName: '製品名',
      deliveryTime: '出荷日',
      num: '数量',
      name: '設備',
      count: '幅番号',
      width: 'テープ幅',
      collectorName: '設備',
      orderNo: '注文番号',
      planIndex: 'バッチ',
      row: '本数',
      action: '操作',
      delete: '削除',
      error: 'エラー',
      error_message: '<p>情報が完成していません</ p>',
      planClick: '予定された計画',
      please_enter: '入力してください',
      deviceNo: 'No.',
      save: '保存',
      save1: '注文',
      save2: 'オーダー入れ替え',
      save3: 'そして生産',
      No_scheduling: '生産スケジュールなし',
      Not_production: '生産なし',
      Producting: '生産スケジュール始めて',
      Case_closed: '生産終了',
      status: '状態',
      no: 'いいえ',
      delete_message: '削除しますか？',
      searchCollector: 'マシン名',
      chooose_order: '1.注文を選択',
      choose_device: '2.マシンを選択',
      choose_plan: '3.スケジュール計画',
      list: '予定された計画',
      message: 'この商品は閉じられています'
    }
  },
  People: {
    index: 'No.',
    name: '名前',
    workNo: 'ジョブ番号：',
    sex: 'ジェンダー',
    boy: '男性',
    girl: '女性',
    phone: '電話：',
    entryTime: 'エントリー時間',
    wechat: 'Wechat',
    qq: 'QQ',
    working: '現職',
    working1: '現職',
    working2: '辞職',
    yes: 'はい',
    no: 'いいえ',
    action: '操作',
    edit: '編集',
    edit_People: '編集スタッフ',
    Return_to_People_list: '人のリストに戻る',
    please_enter: '入力してください',
    please_enter_date: '日付を入力してください',
    save: '保存'
  },
  Maintain: {
    index: 'No.',
    DeviceName: 'マシン名',
    username: '所有者',
    startTime: '始動時間',
    endTime: '終了時間',
    remark: 'リマーク',
    action: '操作',
    edit: '編集',
    edit_Maintain: 'メンテナンス記録を編集する',
    Return_to_Maintain_list: '修理リストに戻る',
    save: '保存',
    please_enter: '入力してください',
    please_enter_date1: '注文の配信開始日',
    please_enter_date2: '注文の配信終了日'
  },
  Permission: {
    super_admin: 'スーパーシステム管理',
    system: 'システム設定',
    device: '設備設定',
    card: 'カード設定',
    people: '人員設定',
    product: '製品管理',
    order: '注文管理',
    production_plan: 'オーダー管理',
    monitor: 'モニタリング',
    report_export: '過去のレポート',
    R: '読む',
    W: '書く',
    RW: '読み書き'
  }
}, __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_ja_JP___default.a, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_ja___default.a);

/* harmony default export */ __webpack_exports__["a"] = (jaJP);

/***/ }),

/***/ "R1Nv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role-page"},[(_vm.permissionscheck === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.Role.New_Role")))]):_vm._e(),_vm._v(" "),(_vm.permissionscheck !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""}},[_vm._v(_vm._s(_vm.$t("system.Role.New_Role")))]):_vm._e(),_vm._v(" "),_c('el-table',{staticClass:"account-table",attrs:{"highlight-row":"","stripe":"","border":"","data":_vm.datas}},[_c('el-table-column',{attrs:{"type":"index","label":_vm.$t('system.Role.index'),"width":"65px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('system.Role.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Authorization","label":_vm.$t('system.Role.Authorization')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('system.Role.operating'),"width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.permissionscheck === true)?_c('el-button',{attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){_vm.edit(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('system.Role.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissionscheck === true)?_c('el-button',{attrs:{"type":"danger","size":"small"},nativeOn:{"click":function($event){_vm.remove(scope.row.id, scope.$index)}}},[_vm._v(_vm._s(_vm.$t('system.Role.delete')))]):_vm._e(),_vm._v(" "),(_vm.permissionscheck !== true)?_c('el-button',{attrs:{"type":"primary","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.Role.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissionscheck !== true)?_c('el-button',{attrs:{"type":"danger","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.Role.delete')))]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RKnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var computeType = {
  list: function list() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = [{ id: 1, name: '纬密' }, { id: 2, name: '滚筒' }];
      setTimeout(resolve, 10, data);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (computeType);

/***/ }),

/***/ "Rix0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-page"},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('plan.Collector.search')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Row',[_c('Col',{staticClass:"plan-title",attrs:{"span":"2"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.name')))]),_vm._v(" "),_c('Col',{attrs:{"span":"22"}},[_c('Row',{staticClass:"plan-title-wrapper"},[_c('Col',{attrs:{"span":"4"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.one')))]),_c('Col',{attrs:{"span":"4"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.two')))]),_c('Col',{attrs:{"span":"4"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.three')))]),_c('Col',{attrs:{"span":"4"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.four')))]),_c('Col',{attrs:{"span":"4"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.fiv')))]),_c('Col',{attrs:{"span":"4"}},[_vm._v(_vm._s(_vm.$t('plan.Collector.six')))])],1)],1)],1),_vm._v(" "),_vm._l((_vm.collectorPlanDatas),function(cplan,cindex){return _c('Row',{key:cplan.name},[_c('Col',{attrs:{"span":"2"}},[_c('div',{staticClass:"collector-name"},[_vm._v(_vm._s(cplan.name))])]),_vm._v(" "),_c('Col',{attrs:{"span":"22"}},[_c('Row',_vm._l((cplan.plans),function(item,index){return _c('Col',{key:item.plans.length,staticClass:"plan-row",attrs:{"span":"4"}},[(item.plans.length > 1)?_c('Badge',{attrs:{"count":item.plans.length}},[(item.plans.length !== 0)?_c('div',{staticClass:"plan-info",on:{"click":function($event){_vm.exporePlan(cindex,index)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('plan.Collector.orderNo'))+": "+_vm._s(item.plans[0].orderNo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('plan.Collector.productNo'))+": "+_vm._s(item.plans[0].productNo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('plan.Collector.row'))+": "+_vm._s(item.plans[0].row))])]):_vm._e()]):_c('span',{staticClass:"plan-info-span"},[(item.plans.length !== 0)?_c('div',{staticClass:"plan-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('plan.Collector.orderNo'))+": "+_vm._s(item.plans[0].orderNo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('plan.Collector.productNo'))+": "+_vm._s(item.plans[0].productNo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('plan.Collector.row'))+": "+_vm._s(item.plans[0].row))])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(index == 0 && item.plans.length !== 0 && cplan.producting == 0 && _vm.permissions === true)?_c('Button',{attrs:{"type":"ghost"},on:{"click":function($event){_vm.production(cindex)}}},[_vm._v(_vm._s(_vm.$t('plan.Collector.yes')))]):_vm._e(),_vm._v(" "),(index == 0 && item.plans.length !== 0 && cplan.producting == 0 && _vm.permissions !== true)?_c('Button',{attrs:{"type":"ghost","disabled":""},on:{"click":function($event){_vm.production(cindex)}}},[_vm._v(_vm._s(_vm.$t('plan.Collector.yes')))]):_vm._e(),_vm._v(" "),(index == 0 && item.plans.length !== 0 && cplan.producting == 1 && _vm.permissions === true)?_c('Button',{attrs:{"type":"ghost"},on:{"click":function($event){_vm.productionStop(cindex)}}},[_vm._v(_vm._s(_vm.$t('plan.Collector.no')))]):_vm._e(),_vm._v(" "),(index == 0 && item.plans.length !== 0 && cplan.producting == 1 && _vm.permissions !== true)?_c('Button',{attrs:{"type":"ghost","disabled":""},on:{"click":function($event){_vm.productionStop(cindex)}}},[_vm._v(_vm._s(_vm.$t('plan.Collector.no')))]):_vm._e()],1)}))],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SBHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var workTime = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/workTime/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: '早班', startTime: '8:00', endTime: '16:00'},
    //     {id: 2, name: '中班', startTime: '16:00', endTime: '24:00'},
    //     {id: 3, name: '晚班', startTime: '00:00', endTime: '8:00'}
    //   ]
    //   resolve(data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/workTime/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/workTime/get', { id: id });
  },
  save: function save(wt) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/workTime/save', wt);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (workTime);

/***/ }),

/***/ "SEUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Order',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('plan.Order.index'), width: 65 }, { title: this.$t('plan.Production.productName'), key: 'name' }, { title: this.$t('plan.Order.productNo'), key: 'productNo' }, { title: this.$t('plan.Order.num'), key: 'num' }, { title: this.$t('plan.Order.unit'), key: 'unit' }, { title: this.$t('plan.Order.attritionRate'), key: 'attritionRate' }, { title: this.$t('plan.Order.output'), key: 'output' }, { title: this.$t('plan.Order.deliveryTime'), key: 'deliveryTime' }, {
        title: this.$t('plan.Order.action'),
        key: 'action',
        width: 125,
        render: function render(h, params) {
          // console.log(params, params.row, params.row.valid)
          if (_this.permissions === true) {
            if (params.row.valid === 1) {
              return h('div', [h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: function click() {
                    _this.close(params.row, params.index);
                  }
                }
              }, _this.$t('plan.Order.case1'))]);
            } else {
              return h('div', [h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                }
              }, _this.$t('plan.Order.case2'))]);
            }
          } else {
            if (params.row.valid === 1) {
              return h('div', [h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: true
                },
                style: {
                  marginRight: '5px'
                }
              }, _this.$t('plan.Order.case1'))]);
            } else {
              return h('div', [h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: true
                },
                style: {
                  marginRight: '5px'
                }
              }, _this.$t('plan.Order.case2'))]);
            }
          }
        }
      }],
      datas: [],
      permissions: false
    };
  },

  computed: {},
  methods: {
    close: function close(row, index) {
      var _this2 = this;

      if (confirm(this.$t('plan.Order.delete_message'))) {
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].orderPlan.close(row.id).then(function () {
          for (var i = 0; i < _this2.datas.length; i++) {
            if (_this2.datas[i].orderID === row.orderID) {
              _this2.datas[i].orderProducts[index].valid = 0;
            }
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'production_plan' && res.user.permissions[i].value === 3) {
          _this3.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].orderPlan.list().then(function (res) {
      next(function (vm) {
        var d = [];
        vm.datas = res.orderInfos;
        for (var i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].Ordervalid === 1) {
            for (var j = 0; j < vm.datas[i].orderProducts.length; j++) {
              if (vm.datas[i].orderProducts[j].unit === 1) {
                vm.datas[i].orderProducts[j].unit = vm.$t('plan.Order.Meter');
              } else if (vm.datas[i].orderProducts[j].unit === 2) {
                vm.datas[i].orderProducts[j].unit = vm.$t('plan.Order.Yard');
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output * 1.0936;
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output.toFixed(0);
              } else if (vm.datas[i].orderProducts[j].unit === 3) {
                vm.datas[i].orderProducts[j].unit = vm.$t('plan.Order.Gross');
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output / (144.0 * 0.9144);
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output.toFixed(0);
              }
            }
            d.push(vm.datas[i]);
          }
        }
        vm.datas = d;
      });
    });
  }
});

/***/ }),

/***/ "SR88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RouterEdit',
  data: function data() {
    return {
      formValidate: {
        id: 0,
        deviceNo: '',
        name: '',
        type: '',
        routerID: '',
        computeType: '',
        length: '',
        count: '',
        width: '',
        deviceCompany: '',
        deviceModel: '',
        buyTime: '',
        deviceLifeTime: '',
        mac: '',
        remark: '',
        routerList: [],
        computeTypes: []
      },
      ruleValidate: {
        name: [{ required: true, message: this.$t('device.collector.Message.name'), trigger: 'blur' }],
        deviceNo: [{ required: true, message: this.$t('device.collector.Message.deviceNo'), trigger: 'blur' }],
        computeType: [{ required: true, message: this.$t('device.collector.Message.computeType'), pattern: /.+/, trigger: 'change' }],
        routerID: [{ required: true, message: this.$t('device.collector.Message.routerID'), pattern: /.+/, trigger: 'change' }],
        length: [{ required: true, message: this.$t('device.collector.Message.length'), trigger: 'blur' }],
        count: [{ required: true, message: this.$t('device.collector.Message.count'), trigger: 'blur' }],
        width: [{ required: true, message: this.$t('device.collector.Message.width'), trigger: 'blur' }]
      },
      list: [],
      check: false
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('device.collector.New_collector') : this.$t('device.collector.edit_collector');
    }
  },
  methods: {
    // handleSubmit (name) {
    //   this.$refs[name].validate((valid) => {
    //     if (valid) {
    //       this.$Message.success('Success!')
    //     } else {
    //       this.$Message.error('Fail!')
    //     }
    //   })
    // },
    // handleReset (name) {
    //   this.$refs[name].resetFields()
    // },
    back: function back() {
      this.$router.back();
    },
    routerChange: function routerChange(id) {
      for (var i = 0; i < this.formValidate.routerList.length; i++) {
        if (id === this.formValidate.routerList[i].id) {
          this.mac = this.formValidate.routerList[i].mac;
          break;
        }
      }
    },
    save: function save() {
      var _this = this;

      var collector = void 0;
      if (Number(this.formValidate.length) % 1 !== 0 || Number(this.formValidate.count) % 1 !== 0 || Number(this.formValidate.width) % 1 !== 0) {
        var title = this.$t('device.collector.error');
        var content = '<p>' + this.$t('device.collector.length') + ',' + this.$t('device.collector.count') + ',' + this.$t('device.collector.width') + this.$t('device.collector.error_message2') + '</p>';
        this.$Modal.error({
          title: title,
          content: content
        });
      } else if (this.formValidate.deviceNo !== '' && this.formValidate.name !== '' && this.formValidate.routerID !== '' && this.formValidate.computeType !== '' && this.formValidate.length !== '' && this.formValidate.count !== '' && this.formValidate.width !== '') {
        collector = {
          id: this.formValidate.id,
          deviceNo: this.formValidate.deviceNo,
          name: this.formValidate.name,
          type: this.formValidate.type,
          routerID: this.formValidate.routerID,
          computeType: this.formValidate.computeType,
          length: Number(this.formValidate.length),
          count: Number(this.formValidate.count),
          width: Number(this.formValidate.width),
          deviceCompany: this.formValidate.deviceCompany,
          deviceModel: this.formValidate.deviceModel,
          buyTime: this.formValidate.buyTime,
          deviceLifeTime: this.formValidate.deviceLifeTime,
          mac: this.formValidate.mac,
          remark: this.formValidate.remark
        };
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collector.save(collector).then(function () {
          _this.$router.push({ 'name': 'Collector' });
        });
      } else {
        var _title = this.$t('device.collector.error');
        var _content = this.$t('device.collector.error_message1');
        this.$Modal.error({
          title: _title,
          content: _content
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].router.list().then(function (res) {
      _this2.formValidate.routerList = res.routers;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].computeType.list().then(function (res) {
      _this2.formValidate.computeTypes = res;
      _this2.formValidate.computeTypes[0].name = _this2.$t('device.collector.roller');
      _this2.formValidate.computeTypes[1].name = _this2.$t('device.collector.weft_density');
      // console.log(this.formValidate.computeTypes)
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    // console.log(id)
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collector.get(id).then(function (res) {
        var c = res.collector;
        next(function (vm) {
          __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].monitor.collectors().then(function (res) {
            vm.list = res.collectors;
            vm.formValidate.id = c.id;
            vm.formValidate.deviceNo = c.deviceNo;
            vm.formValidate.name = c.name;
            vm.formValidate.type = c.type;
            vm.formValidate.routerID = c.routerID;
            vm.formValidate.computeType = c.computeType;
            vm.formValidate.length = c.length;
            vm.formValidate.count = c.count;
            vm.formValidate.width = c.width;
            vm.formValidate.deviceCompany = c.deviceCompany;
            vm.formValidate.deviceModel = c.deviceModel;
            vm.formValidate.buyTime = c.buyTime;
            vm.formValidate.deviceLifeTime = c.deviceLifeTime;
            vm.formValidate.mac = c.mac;
            vm.formValidate.remark = c.remark;
            for (var i = 0; i < vm.list.length; i++) {
              if (vm.list[i].id === vm.formValidate.id && vm.list[i].status === '未知') {
                vm.check = true;
              }
            }
          });
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "STSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var role = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/role/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'admin1', permissions: [{action: 'system', value: 1}, {action: 'people', value: 2}]},
    //     {id: 2, name: 'admin2', permissions: [{action: 'device', value: 3}, {action: 'system', value: 1}]},
    //     {id: 3, name: 'admin3', permissions: [{action: 'order', value: 1}]}
    //   ]
    //   setTimeout(resolve, 100, data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/role/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/role/get', { id: id });
  },
  save: function save(r) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/role/save', r);
    // return Promise.resolve({ id: r.id, name: 'admin', permissions: [{action: 'system', value: 1}, {action: 'people', value: 2}] })
  }
};

/* harmony default export */ __webpack_exports__["a"] = (role);

/***/ }),

/***/ "SVcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var router = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/router/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'router1', linkType: 0, cardNo: '778721', serverAddr: 'router.eweaving.com', remark: ''},
    //     {id: 2, name: 'router2', linkType: 0, cardNo: '883525', serverAddr: 'router.eweaving.com', remark: ''}
    //   ]
    //   resolve(data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/router/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/router/get', { id: id });
  },
  save: function save(router) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/router/save', router);
  },
  collectorsTmSet: function collectorsTmSet(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/router/collectorsTmSet', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "SsQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePw_vue__ = __webpack_require__("vP06");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a630a09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePw_vue__ = __webpack_require__("dG/d");
function injectStyle (ssrContext) {
  __webpack_require__("5R8L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a630a09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a630a09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePw_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Svqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-page"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.Account.New_account")))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(0)}}},[_vm._v(_vm._s(_vm.$t("system.Account.New_account")))]):_vm._e(),_vm._v(" "),_c('el-table',{staticClass:"account-table",attrs:{"highlight-row":"","stripe":"","border":"","data":_vm.datas,"default-sort":{prop: 'username', order: 'ascending'}}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-form',{staticClass:"demo-table-expand",attrs:{"label-position":"left","inline":""}},[_c('el-form-item',{attrs:{"label":_vm.$t('system.Account.telephone')}},[_c('span',[_vm._v(_vm._s(props.row.phone))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('system.Account.email')}},[_c('span',[_vm._v(_vm._s(props.row.eMail))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('system.Account.qq')}},[_c('span',[_vm._v(_vm._s(props.row.qq))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('system.Account.wechat')}},[_c('span',[_vm._v(_vm._s(props.row.wechat))])])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","label":_vm.$t('system.Account.index'),"width":"65px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"username","label":_vm.$t('system.Account.User_name'),"sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('system.Account.Name'),"sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"workNo","label":_vm.$t('system.Account.Worker_number'),"sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"RoleName","label":_vm.$t('system.Account.Role')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('system.Account.operating'),"width":"220px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.permissions === true)?_c('el-button',{attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){_vm.edit(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('system.Account.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true)?_c('el-button',{attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){_vm.reset(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('system.Account.reseat')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true)?_c('el-button',{attrs:{"type":"danger","size":"small"},nativeOn:{"click":function($event){_vm.remove(scope.row.id, scope.$index)}}},[_vm._v(_vm._s(_vm.$t('system.Account.delete')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"primary","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.Account.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.Account.reseat')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('el-button',{attrs:{"type":"danger","size":"small","disabled":""}},[_vm._v(_vm._s(_vm.$t('system.Account.delete')))]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TAmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("vuLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e54a307_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("bSRY");
function injectStyle (ssrContext) {
  __webpack_require__("eLmY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e54a307"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e54a307_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TDoV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_vi_VN__ = __webpack_require__("5//n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_vi_VN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_vi_VN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_vi__ = __webpack_require__("MpSA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_vi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_vi__);




var viVN = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  'menu': {
    'home': 'nhà',
    'system': 'Quản lý bằnghệ thống',
    'system_management': {
      'Role': 'vai trò',
      'Department': 'bộ phận',
      'Account': 'tài khỏan',
      'WorkTime': 'ca làm việc',
      'WorkType': 'tên lọai công việc',
      'RoleEdit': 'điều chỉnh vai trò ',
      'DepartmentEdit': 'điều chỉnh bộ phận ',
      'AccountEdit': 'điều chỉnh tài khỏan',
      'WorkTimeEdit': 'điều chỉnh ca làm việc',
      'WorkTypeEdit': 'điều chỉnh nhân công',
      'systeminfo': 'thông tin',
      'SystemAuth': 'giấy phép'
    },
    'Device': 'Quản lý bằng thiết bị',
    'Device_management': {
      'RouterList': 'bộ định tâm',
      'RouterEdit': 'điều chỉnh bộ định tâm',
      'Collector': 'máy',
      'CollectorEdit': 'điều chỉnh máy móc',
      'CollectorGroup': 'nhóm máy móc',
      'CollectorGroupEdit': 'điều chỉnh nhóm máy móc'
    },
    'Card': 'Quản lý bằng thẻ',
    'CardEdit': 'điều chỉnh thẻ',
    'People': 'Người quản lý',
    'PeopleEdit': 'điều chỉnh con nguời',
    'Product': 'Quản lý nhân sự',
    'ProductEdit': 'điều chỉnh sản phẩm',
    'Order': 'Quản lý đơn hàng',
    'OrderEdit': 'điều chỉnh đặt hàng',
    'Plan': 'Quản ký sản xuất',
    'Plan_Management': {
      'Production_plan': 'kế họach sản xuất',
      'Production_management': 'quản lý sản xuất',
      'Production_order': 'đơn hàng sản xuất'
    },
    'Monitor': 'Giám sát tức thì',
    'Monitor_Monitoring': {
      'Collector': 'trạng thái máy',
      'Order': 'tình trạng đơn hàng'
    },
    'Data': 'Báo cáo',
    'Data_output': {
      'Order': ' đơn hàng',
      'device': 'thiết bị ',
      'Worker': 'công nhân',
      'MaintainList': 'danh sách bảo duỡng',
      'MaintainEdit': 'điều chỉnh bảo duỡng'
    },
    'Setting': 'cài đặt '
  },
  'system': {
    'Account': {
      'New_account': 'tài khỏan mới',
      'edit_account': 'đềiu chỉnh tài khỏan',
      'please_enter': 'Đăng nhập',
      'please_choose': 'chọn',
      'Return_to_account_list': 'trở về danh sách tài khỏan',
      'User_name': 'tên nguời dùng',
      'User_name_message': 'Vui lòng nhập tên nguời sử dụng',
      'Name': 'tên',
      'Name_message': 'nhập tên ',
      'Role': 'vai trò',
      'Role_message': 'chọn vài trò',
      'Worker_number': 'số seri công việc',
      'Department': 'bộ phận',
      'Department_message': 'chọn bộ phận',
      'Telephone': 'điện thoại',
      'Email': 'E-mail',
      'QQ': 'QQ',
      'Wechat': 'Wechat',
      'telephone': 'điện thọai',
      'email': 'E-mail:',
      'qq': 'QQ:',
      'wechat': 'Wechat:',
      'save': 'lưu',
      'index': 'Số seri',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'reseat': 'điều chỉnh lại',
      'error': 'lỗi',
      'error_message1': '<p> Tài khoản được lặp lại </ p>',
      'error_message2': '<p> Tài khoản được lặp lại </ p>',
      'delete_message': 'xóa tin nhắn'
    },
    'Department': {
      'New_Department': 'bộ phận mới',
      'edit_Department': 'tùy chỉnh bộ phận ',
      'index': 'Số seri',
      'Department': 'bộ phận',
      'Authorization': 'giấy phép',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'please_enter': 'Đăng nhập',
      'Return_to_depatement_list': 'trở lại bộ phận danh sách ',
      'name': 'tên',
      'Move_left': 'chuyển về bên trái',
      'Move_right': 'chuyền về bên phải',
      'save': 'lưu',
      'All_authorization': 'tất cả giấy phép',
      'Department_authorization': 'giấy phép bộ phận'
    },
    'Role': {
      'New_Role': 'vai trò mới',
      'edit_Role': 'tùy chỉnh vai trò ',
      'index': 'Số seri',
      'Role': 'vai trò',
      'Authorization': 'giấy phép',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'please_enter': 'Đăng nhập',
      'Return_to_role_list': 'trở về danh sách vai trò',
      'name': 'tên',
      'Move_left': 'chuyển về bên trái',
      'Move_right': 'chuyền về bên phải',
      'save': 'lưu',
      'All_authorization': 'tất cả giấy phép',
      'Role_authorization': 'vai trò giấy phép'
    },
    'workTime': {
      'New_workTime': 'ca làm việc mới',
      'edit_workTime': 'điều chỉnh ca làm việc',
      'index': 'Số seri',
      'name': 'tên',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'please_enter': 'Đăng nhập',
      'please_choose': 'vui lòng-chọn',
      'startTime': 'Thời gian bắt đầu',
      'endTime': 'Thời gian kết thúc',
      'Return_to_workTime_list': 'trở về danh sách ca làm việc',
      'save': 'lưu'
    },
    'workType': {
      'New_workType': 'thể lọai công việc mới',
      'edit_workType': 'điều chỉnh công việc mới',
      'index': 'Số seri',
      'name': 'tên',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'xóa tin nhắn',
      'please_enter': 'Đăng nhập',
      'Return_to_workType_list': 'trở về danh sách ca làm việc',
      'save': 'lưu',
      'yes': 'có ',
      'no': 'không',
      'outputValid': 'hiệu quả sản xuất',
      'monopoly': ' độc quyền',
      'maintain': 'bảo duỡng',
      'warn': 'báo tắt máy',
      'Sorting': 'sắp xếp',
      'display': 'màn hình',
      'malfunction': 'sự cố',
      'remark': 'Nhận xét'
    },
    'SystemAuth': {
      'Information': 'thông tin cơ bản',
      'systemVersion': 'phiên bản hệ thống',
      'systemDealTime': 'ngày hết hạn',
      'please_enter': 'Đăng nhập',
      'save': 'lưu',
      'save_success': 'lưu thành công',
      'systemAuthCode': 'mã '
    },
    'SystemInfo': {
      'Information': 'thông tin cơ bản',
      'Contect': 'liên hệ',
      'systemName': 'hệ thống tên',
      'please_enter': 'Đăng nhập',
      'name': 'tên',
      'contact': 'thông tin liên lạc',
      'address': 'địa chỉ',
      'phone': 'số điện thọai',
      'fax': 'số fax',
      'eMail': 'E-mail:',
      'save': 'lưu',
      'save_success': 'lưu thành công',
      'warnLimitTime': 'thời gian báo tắt máy'
    }
  },
  'device': {
    'collector': {
      'New_collector': 'máy mới',
      'edit_collector': 'điều chỉnh máy',
      'Return_to_collector_list': 'trở về danh sách máy',
      'name': 'tên',
      'deviceNo': 'đánh số',
      'routerID': 'bộ định tâm',
      'type': 'lọai máy',
      'computeType': 'phương pháp tính công suất',
      'roller': 'trục lăn',
      'weft_density': 'mật độ sợi ngang',
      'length': 'chu vi trục lăn',
      'count': 'số lượng',
      'width': 'chiều rộng vành đai',
      'deviceCompany': 'nhà sản xuất máy',
      'deviceModel': 'số hiệu máy',
      'buyTime': 'thời gian mua ',
      'deviceLifeTime': 'tuổi thọ máy',
      'please_enter': 'Đăng nhập',
      'please_enter_mm': 'vui lòng -nhập mm',
      'save': 'lưu',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'error': 'lỗi',
      'error_message1': 'báo lỗi- tin nhắn ',
      'error_message2': 'phải là số nguyên',
      'remark': 'Nhận xét',
      'Message': {
        'name': 'Vui lòng nhập tên',
        'deviceNo': 'vui lòng nhập số',
        'computeType': 'vui lòng nhập phuơng pháp tính năng suất',
        'routerID': 'vui lòng nhập bộ định tâm',
        'length': 'vui lòng nhập chu vi trục lăn',
        'count': 'vui lòng nhập dây đai',
        'width': 'vui lòng nhập chiều rộng dây đai'
      }
    },
    'group': {
      'New_group': 'nhóm máy mới',
      'edit_group': 'điều chỉnh nhóm máy',
      'Return_to_group_list': 'trở về danh sách nhóm máy',
      'please_enter': 'Đăng nhập',
      'save': 'lưu',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'index': 'Số seri',
      'name': 'tên',
      'devices': 'lựa chọn',
      'chosen': 'máy móc',
      'remark': 'Nhận xét',
      'width': 'chiều rộng',
      'router': 'bộ định tâm'
    },
    'router': {
      'New_router': 'bộ định tâm mới',
      'edit_router': 'điều chỉnh bộ định tâm ',
      'Return_to_router_list': 'trở về danh sách bộ định tâm ',
      'please_enter': 'Đăng nhập',
      'index': 'Số seri',
      'name': 'mã bộ định tâm',
      'AnotherName': 'tên bộ định tâm',
      'linkType': 'thể lọai kết nối',
      'channel': 'kênh tín hiệu',
      'remark': 'Nhận xét',
      'save': 'lưu',
      'action': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'mod': 'thể lọai kết nối',
      'Lan': 'LAN cục bộ',
      'Internet': 'kết nối',
      'time': 'Sắp xếp lại',
      'save_success': 'Hệ thống và bộ sưu tập đã được sắp xếp lại'
    }
  },
  'Card': {
    'New_Card': 'thẻ mới',
    'edit_Card': 'điều chỉnh thẻ',
    'Return_to_Card_list': 'trở về danh sách thẻ',
    'please_enter': 'Đăng nhập',
    'index': 'Số seri',
    'userName': 'tên nguời dùng',
    'cardNo': 'số thẻ',
    'workTypeName': 'tên lọai công việc',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'delete': 'xóa ',
    'delete_message': 'Bạn có muốn xóa không?',
    'save': 'lưu',
    'error': 'lỗi',
    'error_message1': '<p> Lặp lại số thẻ </ p>',
    'error_message2': 'báo lỗi- tin nhắn '
  },
  'Product': {
    'New_Product': ' sản xuất mới',
    'edit_Product': 'điều chỉnh sản xuất',
    'Return_to_Product_list': 'trở về danh sách sản xuất',
    'please_enter': 'Đăng nhập',
    'index': 'Số seri',
    'productNo': 'đánh số',
    'name': 'tên',
    'latDensity': 'mật độ sợi ngang',
    'kaidu': 'sức căng',
    'width': 'chiều rộng',
    'specifications': 'Đặc điểm kỹ thuật',
    'valid': 'Hiệu quả',
    'yes': 'có ',
    'no': 'không',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'delete': 'xóa ',
    'delete_message': 'xóa tin nhắn',
    'save': 'lưu',
    'error': 'lỗi',
    'error_message': 'báo lỗi- tin nhắn ',
    'please_enter_kaidu': 'Vui lòng nhập nội dung nào đó (≧ 1)',
    'please_enter_mm': 'vui lòng nhập :mm',
    'please_enter_latDensity': 'vui lòng nhập nội dung (sợi ngang/cm)',
    'Message': {
      'productNo': 'Vui lòng nhập số sản phẩm',
      'name': 'Vui lòng nhập tên',
      'latDensity': 'Vui lòng nhập mật độ sợi ngang',
      'kaidu': 'Vui lòng nhập sức căng',
      'width': 'Vui lòng nhập chiều rộng '
    }
  },
  'Order': {
    'New_Order': 'đơn hàng mới',
    'edit_Order': 'điều chỉnh đơn hàng',
    'Return_to_Order_list': 'trở về danh sách đơn hàng',
    'please_enter': 'Đăng nhập',
    'please_enter_date': 'vui lòng nhập ngày',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'delete': 'xóa ',
    'save': 'lưu',
    'error': 'lỗi',
    'error_message1': '<p> Không có sản phẩm nào được thêm vào đơn đặt hàng </ p>',
    'error_message2': '<p> Thông tin đặt hàng không được điền </ p>',
    'error_message3': '<p> Số lượng không được điền </ p>',
    'error_message4': '<p> Đơn vị không được điền </ p>',
    'error_message5': '<p> Phân phối không được điền </ p>',
    'error_message6': '<p>請先選擇左側產品</p>',
    'delete_message': 'Bạn có muốn xóa không?',
    'change_message': 'Bạn có muốn mở trường hợp này không?',
    'orderNo': 'số đơn hàng',
    'customer': 'khách hàng',
    'ordersTime': 'ngày đặt hàng',
    'salesman': 'nhân viên kinh doanh',
    'index': 'Số seri',
    'productNo': 'số sản phẩm',
    'num': 'số lượng',
    'unit': 'đơn vị',
    'attritionRate': 'tỷ lệ phân tán',
    'deliveryTime': 'ngày giao hàng',
    'remark': 'Nhận xét',
    'add': 'Thêm vào đơn đặt hàng',
    'Product_list': 'Danh sách sản phẩm',
    'search': 'Số / tên',
    'No_scheduling': 'không lên lịch',
    'Not_production': 'không đưa vào sản xuất',
    'Producting': 'đưa vào sản xuất',
    'Case_closed': 'đã đóng',
    'name': 'tên',
    'Meter': 'mét',
    'Yard': 'đơn vị đo',
    'Gross': 'tỏng',
    'status': 'trạng thái',
    'Message': {
      'orderNo': 'Vui lòng nhập số sản phẩm',
      'ordersTime': 'Vui lòng nhập ngày đơn hàng',
      'customer': 'Vui lòng nhập khách hàng',
      'salesman': 'Vui lòng nhập bán hàng'
    }
  },
  'Login': {
    'username': 'Vui lòng nhập tên nguời sử dụng',
    'password': 'Vui lòng nhập mật khẩu',
    'systemCode': 'Vui lòng nhập mã hệ thống',
    'language': '請選擇語言',
    'login': 'Đăng nhập',
    'system': 'hệ thống đăng nhập',
    'changePw': 'thay đổi mật khẩu',
    'logout': 'Đăng xuất',
    'Information': 'Thông tin cá nhân'
  },
  'ChangePw': {
    'oldPassword': 'nhập mật khẩu cũ',
    'newPassword': 'nhập mật khẩu mới',
    'comfirmPassword': 'xác nhận mật khẩu mới',
    'save': 'lưu',
    'error': 'Hai mục nhập mật khẩu không nhất quán',
    'success': 'Đã sửa đổi thành công',
    'ChangePw': 'thay đổi mật khẩu'
  },
  'monitor': {
    'Collector': {
      'index': 'Số seri',
      'name': 'tên',
      'group': 'nhóm',
      'deviceNo': 'đánh số',
      'rpm': 'Tốc độ máy RPM',
      'status': 'trạng thái máy',
      'status1': 'Trạng thái thiết bị',
      'error': 'Thông báo lỗi',
      'worker': 'công nhân',
      'workType': 'trạng thái thẻ',
      'lastTime': 'thời gian',
      'timeout': 'ngọai tuyến',
      'trial': 'Chạy thử',
      'standby': 'Đứng gần',
      'run': 'Đang chạy',
      'orderNo': 'số đơn hàng',
      'producNo': 'seri đơn hàng',
      'stop': 'chế độ chờ',
      'warp': 'làm cong',
      'weft': 'Sợi ngang',
      'thread': 'chủ đề',
      'roll': 'trục lăn'
    },
    'Order': {
      'index': 'Số seri',
      'orderNo': 'số đơn hàng',
      'producNo': 'seri đơn hàng',
      'salesman': 'bán hàng',
      'ordersTime': 'thời gian đặt hàng',
      'output': 'Năng suất',
      'num': 'số lượng đơn hàng',
      'unit': 'đơn vị',
      'countdata': 'số máy',
      'name': 'tên',
      'rpm': 'Tốc độ máy RPM',
      'worker': 'công nhân',
      'workType': 'trạng thái thẻ',
      'DailyOutput': 'Sản xuất hàng ngày',
      'deliveryTime': 'ngày giao hàng',
      'today': 'Sản xuất hàng ngày',
      'completed': '已生產完成',
      'fastestdelivery': '預估交期',
      'please_enter_date1': 'Ngày bắt đầu giao hàng',
      'please_enter_date2': 'Ngày kết thúc giao hàng',
      'Meter': 'mét',
      'Yard': 'đơn vị đo',
      'Gross': 'tỏng'
    }
  },
  'data': {
    'Device': {
      'name': 'máy',
      'date': 'ngày',
      'group': 'nhóm',
      'output': 'Năng suất',
      'unit': 'đơn vị',
      'runTotalTime': 'tổng thời gian chạy',
      'stopTime': 'Thời gian ngừng hoạt động',
      'stopTotalTime': ' tổng thời gian ngừng họat động',
      'error1Time': 'báo lỗi 1: làm cong ',
      'error1TotalTime': 'tổng báo lỗi 1: làm cong ',
      'error2Time': 'báo lỗi 2: sợi ngang ',
      'error2TotalTime': 'tổng báo lỗi 2:sợi ngang ',
      'error3Time': 'báo lỗi 3: sợi duới cùng ',
      'error3TotalTime': 'tổng báo lỗi 3: sợi duới cùng',
      'error4Time': 'báo lỗi 4: thời gian bị lỗi',
      'error4TotalTime': 'tổng báo lỗi 4: thời gian bị lỗi',
      'S': 'giây',
      'M': 'phút',
      'H': 'giờ ',
      'D': 'ngày',
      'Meter': 'mét',
      'output_report': 'báo cáo sản lượng',
      'run_report': 'báo cáo tình trạng',
      'please_enter': 'chọn',
      'please_enter_date': 'chọn ngày',
      'start_date': 'ngày bắt đầu',
      'end_date': 'ngày kết thúc',
      'ok': 'lưu',
      'out': 'đầu ra',
      'status': 'trạng thái hoạt động'
    },
    'Order': {
      'orderNo': 'seri đặt hàng',
      'productNo': 'seri đơn hàng',
      'collectorName': 'máy',
      'salesman': 'nhân viên kinh doanh',
      'customer': 'khách hàng',
      'ordersTime': 'thời gian đặt hàng',
      'productTime': 'thời gian sản xuất',
      'output': 'sản xuất thực tế',
      'target': 'mục tiêu dơn hàng',
      'num': 'số lượng đơn hàng',
      'unit': 'đơn vị',
      'deliveryTime': 'thời gian giao hàng',
      'Meter': 'mét',
      'Yard': 'đơn vị đo',
      'Gross': 'tỏng',
      'Order_report': 'báo cáo đơn hàng',
      'ok': 'lưu',
      'out': 'đầu ra',
      'please_enter': 'chọn',
      'please_enter_date': 'chọn ngày',
      'start_date': 'ngày bắt đầu',
      'end_date': 'ngày kết thúc',
      'time_range': 'Time range',
      'No_scheduling': 'không lên lịch',
      'Not_production': 'không đưa vào sản xuất',
      'Producting': 'đưa vào sản xuất',
      'Case_closed': 'đã đóng',
      'status': 'trạng thái',
      'history': 'thứ tự đơn hàng'
    }
  },
  'setting': {
    'Basic_Information': 'thông tin cơ bản',
    'company_information': 'thông tin công ty',
    'Contact_information': 'liên hệ',
    'save': 'lưu',
    'please_enter': 'Đăng nhập',
    'username': 'tên người dùng',
    'name': 'tên',
    'company': 'công ty',
    'workNo': 'seri làm việc',
    'department': 'bộ phận',
    'workPosition': 'chức vụ',
    'role': 'vai trò',
    'phone': 'điện thoại',
    'eMail': 'E_mail',
    'qq': 'QQ',
    'wechat': 'wechat',
    'System_setting': 'cấu hình hệ thống',
    'language': 'ngôn ngữ',
    'zhcn': '簡體中文',
    'zhtw': '繁體中文',
    'enUS': 'English',
    'jaJP': '日本語',
    'viVN': 'Việt Nam - Tiếng việt',
    'thTH': 'ไทย - ไทย (แปรตรงตัว)'
  },
  'plan': {
    'Collector': {
      'search': 'tên máy',
      'name': 'máy',
      'one': 'lô thư 1',
      'two': 'lô thư 2',
      'three': 'lô thứ 3',
      'four': 'lô thứ 4',
      'fiv': 'lô thứ 5',
      'six': 'lô thứ 6',
      'orderNo': 'seri đơn hàng',
      'productNo': 'seri sản xuất',
      'row': 'số lượng',
      'delete_message': 'ngừng sản xuất',
      'yes': 'bắt đầu',
      'no': 'dừng lại'
    },
    'Order': {
      'orderNo': 'số seri đơn hàng',
      'customer': 'khách hàng',
      'ordersTime': 'ngày đặt hàng',
      'salesman': 'nhân viên bán hàng',
      'index': 'Số seri',
      'productNo': 'số sản phẩm',
      'num': 'số lượng',
      'unit': 'đơn vị',
      'attritionRate': 'tỷ lệ phân tán',
      'output': 'số hoàn thành',
      'deliveryTime': 'ngày giao hàng',
      'action': 'Vận hành',
      'Meter': 'mét',
      'Yard': 'đơn vị đo',
      'Gross': 'tỏng',
      'delete_message': 'xóa đơn hàng',
      'case1': 'đã đóng PO',
      'case2': 'đã đóng'
    },
    'Production': {
      'productNo': 'số sản phẩm',
      'productName': '產品名稱',
      'deliveryTime': 'thời gian giao hàng',
      'num': 'số lượng',
      'name': 'Tên máy',
      'count': 'số lượng',
      'width': 'chiều rộng',
      'collectorName': 'Tên máy',
      'orderNo': 'số seri đơn hàng',
      'planIndex': 'lô hàng',
      'row': 'số lượng',
      'action': 'Vận hành',
      'delete': 'xóa ',
      'error': 'lỗi',
      'error_message': 'số mục không được chọn',
      'planClick': 'lich kế hoạch',
      'please_enter': 'Đăng nhập',
      'deviceNo': 'đánh số',
      'save': 'lưu',
      'save1': 'gửi đơn hàng 1',
      'save2': 'chèn đơn hàng 1',
      'save3': 'sản xuất',
      'No_scheduling': 'không lên lịch',
      'Not_production': 'không đưa vào sản xuất',
      'Producting': 'đưa vào sản xuất',
      'Case_closed': 'đã đóng',
      'status': 'trạng thái',
      'no': 'dừng lại',
      'delete_message': 'xóa tin nhắn',
      'searchCollector': 'Tên máy',
      'chooose_order': '1.選擇訂單',
      'choose_device': '2.選擇機台',
      'choose_plan': '3.排產計畫',
      'list': 'lich kế hoạch',
      'message': '此產品已經結案'
    }
  },
  'People': {
    'index': 'Số seri',
    'name': 'tên',
    'workNo': 'số seri công việc',
    'sex': 'giới tính',
    'boy': 'nam',
    'girl': 'nữ',
    'phone': 'điện thoại',
    'entryTime': 'thời gain nhập cảnh',
    'wechat': 'WECHAT',
    'qq': 'QQ',
    'working': 'đang làm việc 2',
    'working1': 'đang làm việc 2',
    'working2': 'khởi động',
    'yes': 'có ',
    'no': 'không',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'edit_People': 'người cài đặt',
    'Return_to_People_list': 'quay trở lại danh sách người',
    'please_enter': 'Đăng nhập',
    'please_enter_date': 'chọn ngày',
    'save': 'lưu'
  },
  'Maintain': {
    'index': 'Số seri',
    'DeviceName': 'Tên máy',
    'username': 'Vận hành',
    'startTime': 'Thời gian bắt đầu',
    'endTime': 'Thời gian kết thúc',
    'remark': 'Nhận xét',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'edit_Maintain': 'cài đặt hồ sơ bảo trì',
    'Return_to_Maintain_list': 'Quay lại danh sách sữa chữa',
    'save': 'lưu',
    'please_enter': 'Đăng nhập',
    'please_enter_date1': 'Thời gian bắt đầu',
    'please_enter_date2': 'Thời gian kết thúc'
  },
  'Permission': {
    'super_admin': 'Hệ thống siêu cấp',
    'system': 'Quản lý bằnghệ thống',
    'device': 'Quản lý bằng thiết bị',
    'card': 'Quản lý bằng thẻ',
    'people': 'Người quản lý',
    'product': 'Quản lý nhân sự',
    'order': 'Quản lý đơn hàng',
    'production_plan': 'Quản ký sản xuất',
    'monitor': 'Giám sát tức thì',
    'report_export': 'Báo cáo',
    'R': 'R',
    'W': 'W',
    'RW': ' RW'
  }
}, __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_vi_VN___default.a, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_vi___default.a);

/* harmony default export */ __webpack_exports__["a"] = (viVN);

/***/ }),

/***/ "TTMZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UgCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var product = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/product/list');
    // return new Promise((resolve, reject) => {
    // let data = [
    //   {id: 1, productNo: 'xt-001', name: '呆呆', latDensity: 10, density: 22, kaidu: 12, width: 32, specifications: '12345678901', valid: 1, image: 'https://cdn.lljgame.com/FlypplRUJ3TwzjaQxPtBtS8FvZtf'}
    // ]
    // resolve(data)
    // })
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/product/get', { id: id });
  },
  save: function save(product) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/product/save', product);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/product/delete', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (product);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  menus: function menus(state) {
    return state.menu.menus;
  },
  menusOpened: function menusOpened(state) {
    return state.menu.opened;
  },
  menusCreated: function menusCreated(state) {
    return state.menu.created;
  },
  userInit: function userInit(state) {
    return state.user.inited;
  },
  userName: function userName(state) {
    return state.user.user.username;
  },
  permissions: function permissions(state) {
    return state.permission.permissions;
  },
  permissionsInited: function permissionsInited(state) {
    return state.permission.permissionsInited;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "V/8j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var system = {
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/company/get');
    // return Promise.resolve({ id: 1, name: 'e-weaving', company: '心恬电子', address: '天河区思成路1号', contact: 'DaviaLi', phone: '13890039213', fax: '020-24434241', eMail: '22121@wewe.com', language: 'zh-cn', warnLimitTime: 300 })
  },
  save: function save(info) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/company/update', info);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (system);

/***/ }),

/***/ "VUuE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vpel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("2ju2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199237a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("Yxbe");
function injectStyle (ssrContext) {
  __webpack_require__("dqCe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199237a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W1Nd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collector-page"},[_c('Row',[_c('i-Col',{attrs:{"span":"4"}},[_c('Select',{attrs:{"value":_vm.groupname,"filterable":""},model:{value:(_vm.groupname),callback:function ($$v) {_vm.groupname=$$v},expression:"groupname"}},_vm._l((_vm.group),function(item){return _c('Option',{key:item.id,attrs:{"value":item.name}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"6"}},[_c('Input',{attrs:{"placeholder":_vm.$t('Product.productNo')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.check === false)?_c('Table',{staticClass:"collector-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}}):_vm._e(),_vm._v(" "),(_vm.check === true)?_c('Table',{staticClass:"collector-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.temp}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WLYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WsRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'People',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('People.index') }, { title: this.$t('People.name'), key: 'name' }, { title: this.$t('People.workNo'), key: 'workNo' }, {
        title: this.$t('People.sex'),
        key: 'sex',
        render: function render(h, params) {
          var s = params.row.sex === 1 ? _this.$t('People.boy') : _this.$t('People.girl');
          return h('span', s);
        }
      },
      // {
      //   title: '工种',
      //   key: 'workType',
      //   render: (h, params) => {
      //     if (params.row.workType === null) {
      //       return h('')
      //     }
      //     let wts = []
      //     for (var v of params.row.workType) {
      //       let wt = this.workType[v]
      //       if (wt !== undefined) {
      //         wts.push(wt)
      //       }
      //     }
      //     return h('span', wts.join())
      //   }
      // },
      { title: this.$t('People.phone'), key: 'phone' }, { title: this.$t('People.entryTime'), key: 'entryTime' }, { title: this.$t('People.wechat'), key: 'wechat' }, { title: this.$t('People.qq'), key: 'qq' }, {
        title: this.$t('People.working'),
        key: 'working',
        render: function render(h, params) {
          var s = params.row.working === 1 ? _this.$t('People.working1') : _this.$t('People.working2');
          return h('span', s);
        }
      }, {
        title: this.$t('People.action'),
        key: 'action',
        render: function render(h, params) {
          if (_this.permissions === true) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.edit(params.index);
                }
              }
            }, _this.$t('People.edit'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              }
            }, _this.$t('People.edit'))]);
          }
        }
      }],
      datas: [],
      workType: {},
      permissions: false
    };
  },

  computed: {},
  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : this.datas[index].id;
      this.$router.push({ name: 'PeopleEdit', params: { id: id } });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].workType.list().then(function (res) {
      var wts = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.workTypes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var wt = _step.value;

          wts[wt.id] = wt.name;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _this2.workType = wts;
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'people' && res.user.permissions[i].value === 3) {
          _this2.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].people.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.accounts;
      });
    });
  }
});

/***/ }),

/***/ "WvoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-type-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("system.workType.Return_to_workType_list")))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":"100"}},[_c('FormItem',{attrs:{"label":_vm.$t('system.workType.name')}},[(_vm.id == 0)?_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.workType.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e(),_vm._v(" "),(_vm.id != 0)?_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.workType.please_enter'),"disabled":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e()],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.Sorting')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.workType.please_enter')},model:{value:(_vm.Sorting),callback:function ($$v) {_vm.Sorting=$$v},expression:"Sorting"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.outputValid')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.outputValid},model:{value:(_vm.outputValid),callback:function ($$v) {_vm.outputValid=$$v},expression:"outputValid"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t("system.workType.no")))]),_vm._v(" "),_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t("system.workType.yes")))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.monopoly')}},[_c('Select',{staticClass:"info",attrs:{"value":"0"},model:{value:(_vm.monopoly),callback:function ($$v) {_vm.monopoly=$$v},expression:"monopoly"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t("system.workType.no")))]),_vm._v(" "),_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t("system.workType.yes")))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.maintain')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.maintain},model:{value:(_vm.maintain),callback:function ($$v) {_vm.maintain=$$v},expression:"maintain"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t("system.workType.no")))]),_vm._v(" "),_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t("system.workType.yes")))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.display')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.display},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t("system.workType.no")))]),_vm._v(" "),_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t("system.workType.yes")))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.malfunction')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.malfunction},model:{value:(_vm.malfunction),callback:function ($$v) {_vm.malfunction=$$v},expression:"malfunction"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t("system.workType.no")))]),_vm._v(" "),_c('Option',{key:Number(1),attrs:{"value":Number(1)}},[_vm._v(_vm._s(_vm.$t("system.workType.yes")))])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workType.remark')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.workType.please_enter')},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.workType.save")))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XAjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RouterEdit',
  data: function data() {
    return {
      id: 0,
      name: '',
      sum: 0,
      collectors: [],
      remark: '',
      collectorList: [],
      search: '',
      selection: [],
      checked: [],
      routers: [],
      columns: [{ type: 'selection', width: 60 }, { title: this.$t('device.group.name'), key: 'name', sortable: true, sortType: 'asc' }, { title: this.$t('device.group.width'), key: 'width', sortable: true, width: 100 }, { title: this.$t('device.group.router'), key: 'RouterName', sortable: true
        // { title: '宽度', key: 'width' }
      }]
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('device.group.New_group') : this.$t('device.group.edit_group');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var d = [];
      for (var i = 0; i < this.selection.length; i++) {
        d[i] = this.selection[i].id;
      }
      var group = {
        id: this.id,
        name: this.name,
        collectors: d,
        remark: this.remark
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorGroup.save(group).then(function () {
        _this.$router.push({ 'name': 'CollectorGroup' });
      });
    },
    handleSearch: function handleSearch() {
      this.collectors = [];
      for (var i = 0; i < this.collectorList.length; i++) {
        var p = this.collectorList[i];
        if (p.name.indexOf(this.search) !== -1) {
          this.collectors.push(p);
        }
      }
    },
    handleReset: function handleReset() {
      this.collectors = this.collectorList;
    },
    collectorSelect: function collectorSelect(s) {
      this.selection = s;
      this.sum = this.selection.length;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].router.list().then(function (res) {
      _this2.routers = res.routers;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collector.list().then(function (res) {
      _this2.collectorList = res.collectors;
      _this2.collectors = res.collectors;
      for (var i = 0; i < _this2.collectors.length; i++) {
        for (var j = 0; j < _this2.checked.length; j++) {
          if (_this2.checked[j] === _this2.collectors[i].id) {
            _this2.collectors[i]._checked = true;
            _this2.sum++;
          }
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorGroup.get(id).then(function (res) {
        var g = res.collectorGroup;
        next(function (vm) {
          vm.id = g.id;
          vm.name = g.name;
          vm.checked = g.collectors;
          vm.remark = g.remark;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "Xfvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XgKt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XiYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("test")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y+Hs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YJCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role-edit"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("system.Role.Return_to_role_list")))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('FormItem',{attrs:{"label":_vm.$t('system.Role.name')}},[_c('Input',{attrs:{"placeholder":_vm.$t('system.Role.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('Transfer',{attrs:{"data":_vm.permissionsData,"operations":[_vm.$t('system.Role.Move_left'),_vm.$t('system.Role.Move_right')],"target-keys":_vm.targetKeys,"list-style":_vm.listStyle,"filterable":"","render-format":_vm.renderFormat,"titles":[_vm.$t('system.Role.All_authorization'), _vm.$t('system.Role.Role_authorization')]},on:{"on-change":_vm.handleChange}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.Role.save")))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YPbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppMain__ = __webpack_require__("TAmc");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__AppMain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar__ = __webpack_require__("JJU9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SideBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavBar__ = __webpack_require__("KKJ/");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__NavBar__["a"]; });






/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export staticRouterMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menueRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__("lmfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ChangePw__ = __webpack_require__("SsQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Welcome__ = __webpack_require__("NjT6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__ = __webpack_require__("AkUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_system_role_Role__ = __webpack_require__("Ik6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_system_role_RoleEdit__ = __webpack_require__("kOsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_system_account_Account__ = __webpack_require__("gPbT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_system_account_AccountEdit__ = __webpack_require__("/e6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_system_workTime_List__ = __webpack_require__("kxng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_system_workTime_Edit__ = __webpack_require__("9fEZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_system_workType_List__ = __webpack_require__("uCnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_system_workType_Edit__ = __webpack_require__("l9Z+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_system_SystemInfo__ = __webpack_require__("t6H/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_system_SystemAuth__ = __webpack_require__("Jvsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_device_router_List__ = __webpack_require__("DpBd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_device_router_edit__ = __webpack_require__("0X9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_device_collector_List__ = __webpack_require__("1qbB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_device_collector_Edit__ = __webpack_require__("ahPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_device_group_List__ = __webpack_require__("j7a1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_device_group_Edit__ = __webpack_require__("ZaMd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_people_List__ = __webpack_require__("pHN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_people_Edit__ = __webpack_require__("EEld");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_product_List__ = __webpack_require__("xzhI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_product_Edit__ = __webpack_require__("2++O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_order_List__ = __webpack_require__("1ffi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_order_Edit__ = __webpack_require__("EbhV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_card_List__ = __webpack_require__("CjWv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_card_Edit__ = __webpack_require__("MzWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_plan_production__ = __webpack_require__("quIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_plan_Order__ = __webpack_require__("l7W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_plan_Collector__ = __webpack_require__("HHWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_maintain_List__ = __webpack_require__("Vpel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_maintain_Edit__ = __webpack_require__("sqA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_setting_Setting__ = __webpack_require__("BMVo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_monitor_Collector__ = __webpack_require__("2jAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_monitor_Order__ = __webpack_require__("hYqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_data_device__ = __webpack_require__("sbs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_data_order__ = __webpack_require__("+rlU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_Test__ = __webpack_require__("dDHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__api__ = __webpack_require__("gyMJ");









// import Department from '@/views/system/department/Department'
// import DepartmentEdit from '@/views/system/department/DepartmentEdit'






















// import Plan from '@/views/plan/List'









// import PeopleData from '@/views/data/people'




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var staticRouterMap = [{
  name: 'Login',
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_3__views_Login__["a" /* default */]
}, {
  path: '/',
  name: 'Index',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  redirect: '/index',
  children: [{
    path: 'index',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Welcome__["a" /* default */]
  }]
}, {
  name: 'ChangePw',
  path: '/changePw',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  redirect: '/changePw/index',
  children: [{ name: 'index', path: 'index', component: __WEBPACK_IMPORTED_MODULE_4__views_ChangePw__["a" /* default */] }]
}, {
  path: '/test',
  component: __WEBPACK_IMPORTED_MODULE_41__views_Test__["a" /* default */]
}];

var menueRouterMap = [{
  name: 'System',
  path: '/system',
  meta: { title: 'menu.system' },
  redirect: '/system/role',
  icon: 'ios-information',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: true,
  permission: 'system',
  children: [{ name: 'Role', path: 'role', meta: { title: 'menu.system_management.Role' }, component: __WEBPACK_IMPORTED_MODULE_7__views_system_role_Role__["a" /* default */] }, { name: 'RoleEdit', path: 'role/:id', meta: { title: 'menu.system_management.RoleEdit' }, component: __WEBPACK_IMPORTED_MODULE_8__views_system_role_RoleEdit__["a" /* default */], hideMenu: true },
  // { name: 'Department', path: 'department', meta: {title: 'menu.system_management.Department'}, component: Department },
  // { name: 'DepartmentEdit', path: 'department/:id', meta: {title: 'menu.system_management.DepartmentEdit'}, component: DepartmentEdit, hideMenu: true },
  { name: 'Account', path: 'account', meta: { title: 'menu.system_management.Account' }, component: __WEBPACK_IMPORTED_MODULE_9__views_system_account_Account__["a" /* default */] }, { name: 'AccountEdit', path: 'account/:id', meta: { title: 'menu.system_management.AccountEdit' }, component: __WEBPACK_IMPORTED_MODULE_10__views_system_account_AccountEdit__["a" /* default */], hideMenu: true }, { name: 'WorkTime', path: 'worktime', meta: { title: 'menu.system_management.WorkTime' }, component: __WEBPACK_IMPORTED_MODULE_11__views_system_workTime_List__["a" /* default */] }, { name: 'WorkTimeEdit', path: 'workTime/:id', meta: { title: 'menu.system_management.WorkTimeEdit' }, component: __WEBPACK_IMPORTED_MODULE_12__views_system_workTime_Edit__["a" /* default */], hideMenu: true }, { name: 'WorkType', path: 'worktype', meta: { title: 'menu.system_management.WorkType' }, component: __WEBPACK_IMPORTED_MODULE_13__views_system_workType_List__["a" /* default */] }, { name: 'WorkTypeEdit', path: 'workType/:id', meta: { title: 'menu.system_management.WorkTypeEdit' }, component: __WEBPACK_IMPORTED_MODULE_14__views_system_workType_Edit__["a" /* default */], hideMenu: true }, { name: 'SystemInfo', path: 'systeminfo', meta: { title: 'menu.system_management.systeminfo' }, component: __WEBPACK_IMPORTED_MODULE_15__views_system_SystemInfo__["a" /* default */] },
  // { name: 'ServerCfg', path: 'servercfg', meta: {title: '服务器配置管理'}, component: Welcome },
  { name: 'SystemAuth', path: 'systemauth', meta: { title: 'menu.system_management.SystemAuth' }, component: __WEBPACK_IMPORTED_MODULE_16__views_system_SystemAuth__["a" /* default */] }]
}, {
  name: 'Device',
  path: '/device',
  meta: { title: 'menu.Device' },
  redirect: '/device/router',
  icon: 'android-phone-portrait',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: true,
  permission: 'device',
  children: [{ name: 'RouterList', path: 'router', meta: { title: 'menu.Device_management.RouterList' }, component: __WEBPACK_IMPORTED_MODULE_17__views_device_router_List__["a" /* default */] }, { name: 'RouterEdit', path: 'router/:id', meta: { title: 'menu.Device_management.RouterEdit' }, component: __WEBPACK_IMPORTED_MODULE_18__views_device_router_edit__["a" /* default */], hideMenu: true }, { name: 'Collector', path: 'collector', meta: { title: 'menu.Device_management.Collector' }, component: __WEBPACK_IMPORTED_MODULE_19__views_device_collector_List__["a" /* default */] }, { name: 'CollectorEdit', path: 'collector/:id', meta: { title: 'menu.Device_management.CollectorEdit' }, component: __WEBPACK_IMPORTED_MODULE_20__views_device_collector_Edit__["a" /* default */], hideMenu: true }, { name: 'CollectorGroup', path: 'collectorgroup', meta: { title: 'menu.Device_management.CollectorGroup' }, component: __WEBPACK_IMPORTED_MODULE_21__views_device_group_List__["a" /* default */] }, { name: 'CollectorGroupEdit', path: 'collectorgroup/:id', meta: { title: 'menu.Device_management.CollectorGroupEdit' }, component: __WEBPACK_IMPORTED_MODULE_22__views_device_group_Edit__["a" /* default */], hideMenu: true }]
}, {
  name: 'Card',
  path: '/card',
  meta: { title: 'menu.Card' },
  redirect: '/card/list',
  icon: 'android-person',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: false,
  permission: 'card',
  children: [{ name: 'CardList', path: 'list', meta: { title: 'menu.Card' }, component: __WEBPACK_IMPORTED_MODULE_29__views_card_List__["a" /* default */] }, { name: 'CardEdit', path: 'edit/:id', meta: { title: 'menu.CardEdit' }, component: __WEBPACK_IMPORTED_MODULE_30__views_card_Edit__["a" /* default */], hideMenu: true }]
}, {
  name: 'People',
  path: '/people',
  meta: { title: 'menu.People' },
  redirect: '/people/list',
  icon: 'android-person',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: false,
  permission: 'people',
  children: [{ name: 'PeopleList', path: 'list', meta: { title: 'menu.People' }, component: __WEBPACK_IMPORTED_MODULE_23__views_people_List__["a" /* default */] }, { name: 'PeopleEdit', path: 'edit/:id', meta: { title: 'menu.PeopleEdit' }, component: __WEBPACK_IMPORTED_MODULE_24__views_people_Edit__["a" /* default */], hideMenu: true }]
}, {
  name: 'Product',
  path: '/product',
  meta: { title: 'menu.Product' },
  redirect: '/product/list',
  icon: 'bookmark',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: false,
  permission: 'product',
  children: [{ name: 'ProductList', path: 'list', meta: { title: 'menu.Product' }, component: __WEBPACK_IMPORTED_MODULE_25__views_product_List__["a" /* default */] }, { name: 'ProductEdit', path: 'edit/:id', meta: { title: 'menu.ProductEdit' }, component: __WEBPACK_IMPORTED_MODULE_26__views_product_Edit__["a" /* default */], hideMenu: true }]
}, {
  name: 'Order',
  path: '/order',
  meta: { title: 'menu.Order' },
  redirect: '/order/list',
  icon: 'clipboard',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: false,
  permission: 'order',
  children: [{ name: 'OrderList', path: 'list', meta: { title: 'menu.Order' }, component: __WEBPACK_IMPORTED_MODULE_27__views_order_List__["a" /* default */] }, { name: 'OrderEdit', path: 'edit/:id', meta: { title: 'menu.OrderEdit' }, component: __WEBPACK_IMPORTED_MODULE_28__views_order_Edit__["a" /* default */], hideMenu: true }]
}, {
  name: 'Plan',
  path: '/plan',
  meta: { title: 'menu.Plan' },
  redirect: '/plan/production',
  icon: 'android-time',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: true,
  permission: 'production_plan',
  children: [{ name: 'ProductionPlan', path: 'production', meta: { title: 'menu.Plan_Management.Production_plan' }, component: __WEBPACK_IMPORTED_MODULE_31__views_plan_production__["a" /* default */] }, { name: 'CollectorPlan', path: 'collector', meta: { title: 'menu.Plan_Management.Production_management' }, component: __WEBPACK_IMPORTED_MODULE_33__views_plan_Collector__["a" /* default */] }, { name: 'OrderPlan', path: 'order', meta: { title: 'menu.Plan_Management.Production_order' }, component: __WEBPACK_IMPORTED_MODULE_32__views_plan_Order__["a" /* default */] }]
},
// {
//   name: 'Maintain',
//   path: '/maintain',
//   meta: {title: '维修管理'},
//   redirect: '/maintain/index',
//   icon: 'wrench',
//   component: Layout,
//   haveSubMenu: false,
//   children: [
//     { name: 'MaintainList', path: 'list', meta: {title: '维修管理'}, component: Maintain },
//     { name: 'MaintainEdit', path: 'edit/:id', meta: {title: '维修编辑'}, component: MaintainEdit, hideMenu: true }
//   ]
// },
{
  name: 'Monitor',
  path: '/monitor',
  meta: { title: 'menu.Monitor' },
  redirect: '/monitor/collector',
  icon: 'monitor',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: true,
  permission: 'monitor',
  children: [{ name: 'CollectorMonitor', path: 'collector', meta: { title: 'menu.Monitor_Monitoring.Collector' }, component: __WEBPACK_IMPORTED_MODULE_37__views_monitor_Collector__["a" /* default */] }, { name: 'OrderMonitor', path: 'order', meta: { title: 'menu.Monitor_Monitoring.Order' }, component: __WEBPACK_IMPORTED_MODULE_38__views_monitor_Order__["a" /* default */] }]
}, {
  name: 'Data',
  path: '/data',
  meta: { title: 'menu.Data' },
  redirect: '/data/device',
  icon: 'stats-bars',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: true,
  permission: 'report_export',
  children: [{ name: 'deviceData', path: 'device', meta: { title: 'menu.Data_output.device' }, component: __WEBPACK_IMPORTED_MODULE_39__views_data_device__["a" /* default */] },
  // { name: 'peopleData', path: 'people', meta: {title: '人员统计'}, component: PeopleData },
  { name: 'OrderData', path: 'order', meta: { title: 'menu.Data_output.Order' }, component: __WEBPACK_IMPORTED_MODULE_40__views_data_order__["a" /* default */] }, { name: 'MaintainList', path: 'list', meta: { title: 'menu.Data_output.MaintainList' }, component: __WEBPACK_IMPORTED_MODULE_34__views_maintain_List__["a" /* default */] }, { name: 'MaintainEdit', path: 'edit/:id', meta: { title: 'menu.Data_output.MaintainEdit' }, component: __WEBPACK_IMPORTED_MODULE_35__views_maintain_Edit__["a" /* default */], hideMenu: true }]
}, {
  name: 'Setting',
  path: '/setting',
  meta: { title: 'menu.Setting' },
  redirect: '/setting/index',
  icon: 'ios-gear',
  component: __WEBPACK_IMPORTED_MODULE_6__views_layout_Layout__["a" /* default */],
  haveSubMenu: false,
  permission: 'setting',
  children: [{ name: 'SettingIndex', path: 'index', component: __WEBPACK_IMPORTED_MODULE_36__views_setting_Setting__["a" /* default */] }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: staticRouterMap
});

router.beforeEach(function (to, from, next) {
  if (to.path === '/login') {
    if (localStorage.bearer) {
      next({
        path: '/'
      });
    } else {
      next();
    }
  } else {
    if (!localStorage.bearer) {
      next({ path: '/login' });
    } else {
      if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.userInit) {
        __WEBPACK_IMPORTED_MODULE_42__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
          __WEBPACK_IMPORTED_MODULE_42__api__["b" /* Api */].account.get(res.user.id).then(function (res) {
            localStorage.language = res.account.language;
          });
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SetUser', res).then(function (premission) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('GenerateMenus', premission).then(function () {
              router.addRoutes(menueRouterMap);
              next(to);
            });
          });
        });
      } else {
        next();
      }
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yxbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintain-page"},[_c('Row',[_c('i-Col',{attrs:{"span":"3"}},[_c('Select',{attrs:{"value":_vm.search1,"filterable":"","placeholder":_vm.$t('Maintain.DeviceName')},model:{value:(_vm.search1),callback:function ($$v) {_vm.search1=$$v},expression:"search1"}},_vm._l((_vm.devices),function(item){return _c('Option',{key:item.id,attrs:{"value":item.name}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"3"}},[_c('Select',{attrs:{"value":_vm.search2,"filterable":"","placeholder":_vm.$t('Maintain.username')},model:{value:(_vm.search2),callback:function ($$v) {_vm.search2=$$v},expression:"search2"}},_vm._l((_vm.people),function(item){return _c('Option',{key:item.id,attrs:{"value":item.name}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}}),_vm._v(" "),_c('DatePicker',{staticClass:"info",attrs:{"type":"datetime","format":"yyyy-MM-dd HH:mm","value":_vm.selectTime1,"placeholder":_vm.$t('Maintain.please_enter_date1')},on:{"on-change":_vm.entryTimeChange1}}),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}}),_vm._v(" "),_c('DatePicker',{staticClass:"info",attrs:{"type":"datetime","format":"yyyy-MM-dd HH:mm","value":_vm.selectTime2,"placeholder":_vm.$t('Maintain.please_enter_date2')},on:{"on-change":_vm.entryTimeChange2}}),_vm._v(" "),_c('i-Col',{attrs:{"span":"3","align":"left"}}),_vm._v(" "),_c('Button',{attrs:{"icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}}}),_vm._v(" "),_c('Button',{attrs:{"icon":"refresh"},on:{"click":function($event){_vm.handleReset()}}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Table',{staticClass:"maintain-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas,"loading":_vm.loading}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YzBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var systemAuth = {
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/systemAuth/get');
  },
  update: function update(code) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/systemAuth/update', { code: code });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (systemAuth);

/***/ }),

/***/ "ZAz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Router',
  data: function data() {
    return {
      // columns: [
      //   { type: 'index', title: this.$t('device.router.index') },
      //   { title: this.$t('device.router.AnotherName'), key: 'AnotherName' },
      //   { title: this.$t('device.router.name'), key: 'name' },
      //   { title: this.$t('device.router.linkType'),
      //     key: 'linkType',
      //     render: (h, params) => {
      //       let b = params.row.linkType === 0 ? this.$t('device.router.Internet') : this.$t('device.router.Lan')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('device.router.channel'), key: 'channel' },
      //   { title: this.$t('device.router.remark'), key: 'remark' },
      //   {
      //     title: this.$t('device.router.action'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('device.router.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.setTm(params.index)
      //               }
      //             }
      //           }, this.$t('device.router.time'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('device.router.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('device.router.time'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      permissions: false
    };
  },

  methods: {
    edit: function edit(id) {
      // let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'RouterEdit', params: { id: id } });
    },

    // remove (index) {
    //   this.$api.router.delete(this.datas[index].id).then(() => {
    //     this.datas.splice(index, 1)
    //   })
    // },
    setTm: function setTm(id) {
      var _this = this;

      this.$api.router.collectorsTmSet(id).then(function () {
        _this.$Message.config({
          top: 80,
          duration: 2
        });
        _this.$Message.success(_this.$t('device.router.save_success'));
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'device' && res.user.permissions[i].value === 3) {
          _this2.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].router.list().then(function (res) {
      for (var i = 0; i < res.routers.length; i++) {
        var channel = res.routers[i].channel;
        if (channel < 10) {
          res.routers[i].channel = String.fromCharCode(channel + 48);
        } else {
          res.routers[i].channel = String.fromCharCode(channel + 55);
        }
      }
      next(function (vm) {
        vm.datas = res.routers;
      });
    });
  }
});

/***/ }),

/***/ "ZaMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("XAjJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d7eb1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("CynE");
function injectStyle (ssrContext) {
  __webpack_require__("sWHG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5d7eb1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d7eb1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zavm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US__ = __webpack_require__("hyJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en__);




var enUS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  menu: {
    home: 'Home',
    system: 'System setting',
    system_management: {
      Role: 'Role',
      Department: 'Department',
      Account: 'Account',
      WorkTime: 'Shift',
      WorkType: 'Worker type',
      RoleEdit: 'Role edit',
      DepartmentEdit: 'Department Edit',
      AccountEdit: 'Account Edit',
      WorkTimeEdit: 'Shift Edit',
      WorkTypeEdit: 'Worker type Edit',
      systeminfo: 'Information',
      SystemAuth: 'Authorization'
    },
    Device: 'Devices setting',
    Device_management: {
      RouterList: 'Router',
      RouterEdit: 'Router Edit',
      Collector: 'Machine',
      CollectorEdit: 'Machine Edit',
      CollectorGroup: 'Machine Group',
      CollectorGroupEdit: 'Machine group Edit'
    },
    Card: 'Card setting',
    CardEdit: 'Card Edit',
    People: 'Person setting',
    PeopleEdit: 'Person Edit',
    Product: 'Production setting',
    ProductEdit: 'Production Edit',
    Order: 'Order setting',
    OrderEdit: 'Order Edit',
    Plan: 'Production Planning',
    Plan_Management: {
      Production_plan: 'Order planning',
      Production_management: 'Order arrangement',
      Production_order: 'Order schedule'
    },
    Monitor: 'Monitoring',
    Monitor_Monitoring: {
      Collector: 'Machine state',
      Order: 'Order state'
    },
    Data: 'Report',
    Data_output: {
      Order: 'Order history',
      device: 'Machine history',
      Worker: 'Worker history',
      MaintainList: 'Maintain history',
      MaintainEdit: 'Maintain Edit'
    },
    Setting: 'User Setting'
  },
  system: {
    Account: {
      New_account: 'New account',
      edit_account: 'Account edit',
      please_enter: 'Please enter something',
      please_choose: 'Please choose something',
      Return_to_account_list: 'Retern to account list',
      User_name: 'User name',
      User_name_message: 'Please enter user name',
      Name: 'Name',
      Name_message: 'Please enter name',
      Role: 'Role',
      Role_message: 'Please choose role',
      Worker_number: 'Worker number',
      Department: 'Department',
      Department_message: 'Please choose department',
      Telephone: 'Telephone',
      Email: 'E-mail',
      QQ: 'QQ',
      Wechat: 'Wechat',
      telephone: 'Telephone:',
      email: 'E-mail:',
      qq: 'QQ:',
      wechat: 'Wechat:',
      save: 'Save',
      index: 'No.',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      reseat: 'Reset',
      error: 'Error',
      error_message1: '<p>Repeated account</p>',
      error_message2: '<p>Repeated account</p>',
      delete_message: 'Do you want to delete it?'
    },
    Department: {
      New_Department: 'New Department',
      edit_Department: 'Department edit',
      index: 'No.',
      Department: 'Department',
      Authorization: 'Authorization',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      Return_to_depatement_list: 'Retern to department list',
      name: 'Name',
      Move_left: 'Move to the left',
      Move_right: 'Move to the right',
      save: 'save',
      All_authorization: 'All authorization',
      Department_authorization: 'Department authorization'
    },
    Role: {
      New_Role: 'New role',
      edit_Role: 'Role edit',
      index: 'No.',
      Role: 'Role',
      Authorization: 'Authorization',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      Return_to_role_list: 'Return to role list',
      name: 'Name',
      Move_left: 'Move to the left',
      Move_right: 'Move to the right',
      save: 'Save',
      All_authorization: 'All authorization',
      Role_authorization: 'Role authorization'
    },
    workTime: {
      New_workTime: 'New shift',
      edit_workTime: 'Shift edit',
      index: 'No.',
      name: 'Name',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      please_choose: 'Please choose something',
      startTime: 'Start time',
      endTime: 'End time',
      Return_to_workTime_list: 'Retern to shift list',
      save: 'Save'
    },
    workType: {
      New_workType: 'New Worker type',
      edit_workType: 'Worker type edit',
      index: 'No.',
      name: 'Name',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      please_enter: 'Please enter something',
      Return_to_workType_list: 'Return to worker type list',
      save: 'Save',
      yes: 'Yes',
      no: 'No',
      outputValid: 'Effective production',
      monopoly: 'Occupy machine',
      maintain: 'Maintain mode',
      warn: 'Shutdown alarm',
      Sorting: 'Sorting',
      display: 'Dashboard',
      malfunction: 'Fault calculation',
      remark: 'Remark'
    },
    SystemAuth: {
      Information: 'Information',
      systemVersion: 'System version:',
      systemDealTime: 'Expiration date:',
      please_enter: 'Please enter something',
      save: 'Save',
      save_success: 'Save success',
      systemAuthCode: 'Authorization code'
    },
    SystemInfo: {
      Information: 'Information',
      Contect: 'Contect',
      systemName: 'System name:',
      please_enter: 'Please enter something',
      name: 'Company name:',
      contact: 'Contect name:',
      address: 'Company Address:',
      phone: 'Telephone:',
      fax: 'Fax:',
      eMail: 'E-mail:',
      save: 'Save',
      save_success: 'Save success',
      warnLimitTime: 'Shutdown alarm interval:'
    }
  },
  device: {
    collector: {
      New_collector: 'New machine',
      edit_collector: 'Machine edit',
      Return_to_collector_list: 'Return to machine list',
      name: 'Name',
      deviceNo: 'No.',
      routerID: 'Router',
      type: 'Machine type',
      computeType: 'Capacity method',
      roller: 'Roller',
      weft_density: 'Weft density',
      length: 'Roller circumference',
      count: 'Tapes number',
      width: 'Tape width',
      deviceCompany: 'Manufacturer',
      deviceModel: 'Machine model',
      buyTime: 'Purchase time',
      deviceLifeTime: 'Service life（year）',
      please_enter: 'Please enter something',
      please_enter_mm: 'Please enter something(Unit:mm)',
      save: 'Save',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      error: 'Error',
      error_message1: '<p>The information is not completed </p>',
      error_message2: 'must be Integer',
      remark: 'Remark',
      Message: {
        name: 'Please enter name',
        deviceNo: 'Please enter number',
        computeType: 'Please enter calculation method',
        routerID: 'Please enter router',
        length: 'Please enter Roller circumference',
        count: 'Please enter tapes',
        width: 'Please enter width'
      }
    },
    group: {
      New_group: 'New Machine group',
      edit_group: 'Machine group edit',
      Return_to_group_list: 'Return to machine group list',
      please_enter: 'Please enter something',
      save: 'Save',
      operating: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      index: 'No.',
      name: 'Name',
      chosen: 'Have chosen',
      devices: 'Machine',
      remark: 'Remark',
      width: 'Width',
      router: 'Router'
    },
    router: {
      New_router: 'New Router',
      edit_router: 'Router edit',
      Return_to_router_list: 'Retern to router list',
      please_enter: 'Please enter something',
      index: 'No.',
      name: 'Router code',
      AnotherName: 'Router Name',
      linkType: 'Network type',
      channel: 'Signal channel',
      remark: 'Remark',
      save: 'Save',
      action: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      delete_message: 'Do you want to delete it?',
      mod: 'Network Type',
      Lan: 'Local LAN',
      Internet: 'Internet',
      time: 'Rearrange',
      save_success: 'The system and collector already rearrange'
    }
  },
  Card: {
    New_Card: 'New card',
    edit_Card: 'Card edit',
    Return_to_Card_list: 'Return to card list',
    please_enter: 'Please enter something',
    index: 'No.',
    userName: 'Holder',
    cardNo: 'Card number',
    workTypeName: 'Work type',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    delete_message: 'Do you want to delete it?',
    save: 'Save',
    error: 'Error',
    error_message1: '<p>Repeated card</p>',
    error_message2: '<p>The information is not completed</p>'
  },
  Product: {
    New_Product: 'New production',
    edit_Product: 'Production edit',
    Return_to_Product_list: 'Return to production list',
    please_enter: 'Please enter something',
    index: 'No.',
    productNo: 'Production No.',
    name: 'Name',
    latDensity: 'Weft density',
    kaidu: 'Tension',
    width: 'Width',
    specifications: 'Specification',
    valid: 'Effectivity',
    yes: 'Yes',
    no: 'No',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    delete_message: 'Do you want to delete it?',
    save: 'Save',
    error: 'Error',
    error_message: '<p>The information is not completed</p>',
    please_enter_mm: 'Please enter something(Unit:mm)',
    please_enter_latDensity: 'Please enter something(Unit:weft/cm)',
    please_enter_kaidu: 'Please enter something(≧1)',
    Message: {
      productNo: 'Please enter production No.',
      name: 'Please enter name',
      latDensity: 'Please enter weft density',
      kaidu: 'Please enter tension',
      width: 'Please enter width'
    }
  },
  Order: {
    New_Order: 'New order',
    edit_Order: 'Order edit',
    Return_to_Order_list: 'Return to order list',
    please_enter: 'Please enter something',
    please_enter_date: 'Please enter date',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    error: 'Error',
    error_message1: '<p>No production is added to the order</p>',
    error_message2: '<p>The order information is not filled in </p>',
    error_message3: '<p>Quantity not completed</p>',
    error_message4: '<p>Unit not completed</p>',
    error_message5: '<p>Delivery date not completed</p>',
    error_message6: '<p>請先選擇左側產品</p>',
    delete_message: 'Do you want to delete it? ',
    change_message: 'Do you want to open case?',
    orderNo: 'Order number',
    customer: 'Customer',
    ordersTime: 'Order date',
    salesman: 'Sales',
    index: 'No.',
    productNo: 'Production No.',
    num: 'Quantity',
    unit: 'Unit',
    attritionRate: 'Loss rate(%)',
    deliveryTime: 'Delivery date',
    remark: 'Remark',
    add: 'Add to order',
    Product_list: 'Production list',
    search: 'Item/Name',
    No_scheduling: 'No scheduling',
    Not_production: 'Nonproduction',
    Producting: 'Production',
    Case_closed: 'Finish',
    name: 'Name',
    Meter: 'Meter',
    Yard: 'Yard',
    Gross: 'Gross',
    Status: 'Status',
    Message: {
      orderNo: 'Please enter production No.',
      ordersTime: 'Please enter order date',
      customer: 'Please enter Customer',
      salesman: 'Please enter Sales'
    }
  },
  Login: {
    username: 'Please enter user name',
    password: 'Please enter password',
    systemCode: 'Please enter system code',
    language: 'Please choose language',
    login: 'Login',
    system: 'System login',
    changePw: 'change password',
    logout: 'log out',
    Information: 'personal setting'
  },
  ChangePw: {
    oldPassword: 'Enter old password:',
    newPassword: 'Enter new password',
    comfirmPassword: 'Comfirm new password',
    save: 'Save',
    error: 'The two passwords are inconsistent',
    success: 'Modify successfully',
    ChangePw: 'Change the password'
  },
  monitor: {
    Collector: {
      index: 'No.',
      name: 'Name',
      group: 'Group',
      deviceNo: 'Item',
      rpm: 'Machine RPM',
      status: 'Machine status',
      status1: 'Devices status',
      error: 'Fault information',
      worker: 'Workers',
      workType: 'Card status',
      lastTime: 'Time',
      timeout: 'Offline',
      trial: 'Trial',
      standby: 'Standby',
      run: 'Running',
      orderNo: 'Order No.',
      producNo: 'Production No.',
      stop: 'Standby',
      warp: ' Warp ',
      weft: ' Weft ',
      thread: ' Thread ',
      roll: ' Roller '
    },
    Order: {
      index: 'No.',
      orderNo: 'Order No.',
      producNo: 'Production No.',
      salesman: 'Sales',
      ordersTime: 'Order date',
      output: 'Production',
      num: 'Order quantity',
      unit: 'Unit',
      countdata: 'Machine',
      name: 'Name',
      rpm: 'Machine RPM',
      worker: 'Worker',
      workType: 'Card Status',
      DailyOutput: 'Daily production',
      deliveryTime: 'Order Delivery date',
      today: 'Today production',
      completed: 'Completed production',
      fastestdelivery: 'Estimated delivery',
      please_enter_date1: 'Start date of order delivery',
      please_enter_date2: 'End date of order delivery',
      Meter: 'Meter',
      Yard: 'Yard',
      Gross: 'Gross'
    }
  },
  data: {
    Device: {
      name: 'Machine',
      date: 'Date',
      group: 'Group',
      output: 'Production',
      unit: 'Unit',
      runTotalTime: 'Run total time',
      stopTime: 'Stop times',
      stopTotalTime: 'Stop total time',
      error1Time: 'Warp fault times',
      error1TotalTime: 'Warp fault time',
      error2Time: 'Weft fault times',
      error2TotalTime: 'Weft fault time',
      error3Time: 'Catch thread fault times',
      error3TotalTime: 'Catch thread fault time',
      error4Time: 'Take up fault times',
      error4TotalTime: 'Take up fault time',
      S: 'Sec',
      M: 'Min',
      H: 'Hour',
      D: 'Day',
      Meter: 'Meter',
      output_report: 'Capacity report',
      run_report: 'Running status report',
      please_enter: 'Please choose',
      please_enter_date: 'Please choose date',
      start_date: 'Start time',
      end_date: 'End time',
      ok: 'OK',
      out: 'Output',
      status: 'Running status'
    },
    Order: {
      orderNo: 'Order No.',
      productNo: 'Production No.',
      collectorName: 'Machine',
      salesman: 'Sales',
      customer: 'Customer',
      ordersTime: 'Order date',
      productTime: 'Production time',
      output: 'Actual output',
      target: 'Target output',
      num: 'Order quantity',
      unit: 'Unit',
      deliveryTime: 'Delivery date',
      Meter: 'Meter',
      Yard: 'Yard',
      Gross: 'Gross',
      Order_report: 'Order report',
      ok: 'OK',
      out: 'Output',
      please_enter: 'Please choose something',
      please_enter_date: 'Please choose the date',
      start_date: 'Start date',
      end_date: 'End date',
      time_range: 'Time range',
      No_scheduling: 'No scheduling',
      Not_production: 'Nonproduction',
      Producting: 'Production',
      Case_closed: 'Finish',
      status: 'Status',
      history: 'Order history'
    }
  },
  setting: {
    Basic_Information: 'Basic information',
    company_information: 'Company information',
    Contact_information: 'Contact',
    save: 'Save',
    please_enter: 'Please enter something',
    username: 'User name:',
    name: 'Name:',
    company: 'Company:',
    workNo: 'Work No.',
    department: 'Department:',
    workPosition: 'Position:',
    role: 'Role:',
    phone: 'Telephone:',
    eMail: 'E-mail:',
    qq: 'QQ:',
    wechat: 'Wechat:',
    System_setting: 'System setting',
    language: 'language:',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: 'Machine name',
      name: 'Machine',
      one: 'Batch 1',
      two: 'Batch 2',
      three: 'Batch 3',
      four: 'Batch 4',
      fiv: 'Batch 5',
      six: 'Batch 6',
      orderNo: 'Order No.',
      productNo: 'Production No.',
      row: 'Tapes number',
      delete_message: 'Are you sure stop production?',
      yes: 'Start',
      no: 'Stop'
    },
    Order: {
      orderNo: 'Order No.',
      customer: 'Customer',
      ordersTime: 'Order date',
      salesman: 'Sales',
      index: 'No.',
      productNo: 'Production No.',
      num: 'Quantity',
      unit: 'Unit',
      attritionRate: 'Loss rate(%)',
      output: 'Quantity completion',
      deliveryTime: 'Delivery date',
      action: 'Operation',
      Meter: 'Meter',
      Yard: 'Yard',
      Gross: 'Gross',
      delete_message: 'Are you sure close the order?',
      case1: 'Close PO',
      case2: 'PO closed'
    },
    Production: {
      productNo: 'Production No.',
      productName: 'Production Name',
      deliveryTime: 'Delivery date',
      num: 'Quantity',
      name: 'Machine name',
      count: 'Type',
      width: 'Width',
      collectorName: 'Machine name',
      orderNo: 'Order No.',
      planIndex: 'Batch',
      row: 'Tapes',
      action: 'Operation',
      delete: 'Delete',
      error: 'Error',
      error_message: '<p>Unselected type</p>',
      planClick: 'List of planned production',
      please_enter: 'Please enter something',
      deviceNo: 'Item',
      save: 'Save',
      save1: 'Send order',
      save2: 'Insert order',
      save3: 'Parallel order',
      No_scheduling: 'No scheduling',
      Not_production: 'Nonproduction',
      Producting: 'Production',
      Case_closed: 'Finish',
      Status: 'Status',
      no: 'Stop',
      delete_message: 'Do you want to delete it?',
      searchCollector: 'Machine name',
      chooose_order: '1.Choose Order',
      choose_device: '2.Choose Machine',
      choose_plan: '3.Planned Production',
      list: 'List of planned production',
      message: 'This production has been closed'
    }
  },
  People: {
    index: 'No.',
    name: 'Name',
    workNo: 'Worker No.',
    sex: 'Sex',
    boy: 'Man',
    girl: 'Woman',
    phone: 'Telephone',
    entryTime: 'Entry time',
    wechat: 'Wechat',
    qq: 'QQ',
    working: 'On Job',
    working1: 'On Job',
    working2: 'Departure',
    yes: 'Yes',
    no: 'No',
    action: 'Operation',
    edit: 'Edit',
    edit_People: 'Edit staff',
    Return_to_People_list: 'Return to staff list',
    please_enter: 'Please enter',
    please_enter_date: 'Please selete the date',
    save: 'Save'
  },
  Maintain: {
    index: 'No.',
    DeviceName: 'Machine Name',
    username: 'Operator',
    startTime: 'Start Time',
    endTime: 'End Time',
    remark: 'Remark',
    action: 'Operation',
    edit: 'Edit',
    edit_Maintain: 'Edit Maintain Record',
    Return_to_Maintain_list: 'Return to Maintain List',
    save: 'Save',
    please_enter: 'Please enter',
    please_enter_date1: 'Start date of Start Time',
    please_enter_date2: 'End date of Start Time'
  },
  Permission: {
    super_admin: 'Super System setting',
    system: 'System setting',
    device: 'Devices setting',
    card: 'Card setting',
    people: 'Person setting',
    product: 'Production setting',
    order: 'Order setting',
    production_plan: 'Production Planning',
    monitor: 'Monitoring',
    report_export: 'Report',
    R: 'R',
    W: 'W',
    RW: 'RW'
  }
}, __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_en_US___default.a, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_en___default.a);

/* harmony default export */ __webpack_exports__["a"] = (enUS);

/***/ }),

/***/ "ZyKG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a0oE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-page"},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{staticClass:"data-pane",attrs:{"label":_vm.$t('data.Device.status')}},[_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"inline":""}},[_c('FormItem',{attrs:{"label":_vm.$t('data.Device.name')}},[_c('Select',{staticClass:"info collectorSelect",attrs:{"value":_vm.collectorID,"filterable":""},on:{"on-change":_vm.collectorSelectChange},model:{value:(_vm.collectorID),callback:function ($$v) {_vm.collectorID=$$v},expression:"collectorID"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t('data.Device.please_enter')))]),_vm._v(" "),_vm._l((_vm.collectorList),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Device.group')}},[_c('Select',{staticClass:"info collectorSelect",attrs:{"value":_vm.groupname,"filterable":""},on:{"on-change":_vm.collectorGroupSelectChange},model:{value:(_vm.groupname),callback:function ($$v) {_vm.groupname=$$v},expression:"groupname"}},[_c('Option',{key:Number(0),attrs:{"value":Number(0)}},[_vm._v(_vm._s(_vm.$t('data.Device.please_enter')))]),_vm._v(" "),_vm._l((_vm.grouplist),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Device.start_date')}},[_c('DatePicker',{attrs:{"value":_vm.selectTime1,"placeholder":_vm.$t('data.Device.please_enter_date')},on:{"on-change":_vm.entryTimeChange1}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('data.Device.end_date')}},[_c('DatePicker',{attrs:{"value":_vm.selectTime2,"placeholder":_vm.$t('data.Device.please_enter_date')},on:{"on-change":_vm.entryTimeChange2}})],1),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.getData(2)}}},[_vm._v(_vm._s(_vm.$t('data.Device.ok')))]),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.exportData(2)}}},[_c('Icon',{attrs:{"type":"ios-download-outline"}}),_vm._v(_vm._s(_vm.$t('data.Device.out')))],1)],1),_vm._v(" "),_c('Table',{ref:"table2",staticClass:"device-data-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.deviceColumns2,"data":_vm.datas2,"loading":_vm.loading}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a5/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Collector',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('monitor.Collector.index'), width: 65 }, {
        title: this.$t('monitor.Collector.status1'),
        key: 'status1',
        width: 100,
        render: function render(h, params) {
          return h('Tag', {
            props: {
              type: 'dot',
              color: _this.datas[params.index].status1
            }
          });
        }
      }, { title: this.$t('monitor.Collector.name'), key: 'name', sortable: true }, { title: this.$t('monitor.Collector.group'), key: 'group', sortable: true }, { title: this.$t('monitor.Collector.rpm'), key: 'rpm', width: 100 }, { title: this.$t('monitor.Collector.status'), key: 'status3', width: 100 }, { title: this.$t('monitor.Collector.error'), key: 'status2' }, { title: this.$t('monitor.Collector.worker'), key: 'worker' }, { title: this.$t('monitor.Collector.workType'), key: 'workType' }, { title: this.$t('monitor.Collector.orderNo'),
        key: 'orderProductdata',
        render: function render(h, params) {
          if (_this.datas[params.index].orderProductdata !== null) {
            var tag = '';
            if (_this.datas[params.index].orderProductdata.length > 0) {
              tag += _this.datas[params.index].orderProductdata[0].OrderNo + '  /  ';
            }
            if (_this.datas[params.index].orderProductdata.length > 0) {
              tag += _this.datas[params.index].orderProductdata[0].ProductNo;
            }
            return h('Poptip', {
              props: {
                trigger: 'hover',
                placement: 'left'
              }
            }, [h('Tag', tag), h('div', {
              slot: 'content'
            }, [h('table', [h('tbody', _this.datas[params.index].orderProductdata.map(function (item) {
              return h('tr', [h('td', item.OrderNo + '  /  ' + item.ProductNo)]);
            }))])])]);
          }
        }
      }],
      datas: [],
      timer: 0,
      Producting: [],
      group: [],
      SystemCode: '',
      groupname: '',
      search: '',
      temp: [],
      check: false,
      Productinglength: 0
      // orderProduct: [],
      // orderProductlength: 0
    };
  },

  methods: {
    loadData: function loadData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].system.get().then(function (res) {
        _this2.SystemCode = res.company.systemCode;
        // console.log(this.SystemCode)
      });
      var code = '{"systemcode":"' + this.SystemCode + '"}';
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].monitor.producting(code).then(function (res) {
        if (res.datas === null) {
          _this2.Productinglength = 0;
        } else {
          _this2.Productinglength = _this2.Producting.length;
          _this2.Producting = res.datas;
        }
      });
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorGroup.list().then(function (res) {
        _this2.group = res.collectorGroups;
      });
      // Api.order.list().then(res => {
      //   if (res.datas === null) {
      //     this.orderProductlength = 0
      //   } else {
      //     this.orderProduct = res.orderInfos
      //   }
      // })
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].monitor.collectors().then(function (res) {
        _this2.datas = res.collectors;
        for (var i = 0; i < _this2.datas.length; i++) {
          _this2.datas[i].group = '';
          // console.log(this.group)
          if (_this2.group !== undefined) {
            for (var j = 0; j < _this2.group.length; j++) {
              for (var k = 0; k < _this2.group[j].collectors.length; k++) {
                if (_this2.datas[i].id === _this2.group[j].collectors[k]) {
                  _this2.datas[i].group += _this2.group[j].name + '  ';
                }
              }
            }
          }
          _this2.datas[i].status2 = '';
          var status = _this2.datas[i].status;
          if (status.indexOf('正常') !== -1) {
            _this2.datas[i].status1 = 'green';
          } else if (status.indexOf('离线') !== -1) {
            _this2.datas[i].rpm = 0;
            _this2.datas[i].status1 = 'red';
          } else if (status.indexOf('未知') !== -1) {
            _this2.datas[i].rpm = 0;
            _this2.datas[i].status1 = 'yellow';
          }
          if (status.indexOf('经纱故障') !== -1) {
            _this2.datas[i].status2 += _this2.$t('monitor.Collector.warp');
          }
          if (status.indexOf('纬纱故障') !== -1) {
            _this2.datas[i].status2 += _this2.$t('monitor.Collector.weft');
          }
          if (status.indexOf('底线故障') !== -1) {
            _this2.datas[i].status2 += _this2.$t('monitor.Collector.thread');
          }
          if (status.indexOf('卷取故障') !== -1) {
            _this2.datas[i].status2 += _this2.$t('monitor.Collector.roll');
          }
          var d = [];
          // if (this.datas[i].status === this.$t('monitor.Collector.timeout')) {
          //   this.datas[i].rpm = 0
          //   this.datas[i].status = this.$t('monitor.Collector.timeout')
          // }
          if (_this2.Productinglength === 0) {
            if (_this2.datas[i].rpm > 0) {
              _this2.datas[i].status3 = _this2.$t('monitor.Collector.trial');
            } else {
              _this2.datas[i].status3 = _this2.$t('monitor.Collector.standby');
            }
          } else {
            for (var _j = 0; _j < _this2.Producting.length; _j++) {
              // if (this.Producting[j].deviceid === this.datas[i].id) {
              if (_this2.Producting[_j].deviceNo === _this2.datas[i].deviceNo) {
                d.push({
                  OrderNo: _this2.Producting[_j].orderNo,
                  ProductNo: _this2.Producting[_j].productNo
                });
                // console.log(d, '1')
                if (_this2.datas[i].rpm > 0) {
                  _this2.datas[i].status3 = _this2.$t('monitor.Collector.run');
                  break;
                } else {
                  _this2.datas[i].status3 = _this2.$t('monitor.Collector.stop');
                  break;
                }
              } else if (_j + 1 === _this2.Producting.length) {
                if (_this2.datas[i].rpm > 0) {
                  _this2.datas[i].status3 = _this2.$t('monitor.Collector.trial');
                } else {
                  _this2.datas[i].status3 = _this2.$t('monitor.Collector.standby');
                }
              }
            }
          }
          _this2.datas[i].orderProductdata = d;
          // console.log(this.datas[i], d, '2')
          if (_this2.datas[i].rpm === 9999) {
            _this2.datas[i].rpm = 0;
          }
        }
      });
      this.temp = [];
      if (this.check === true) {
        for (var i = 0; i < this.datas.length; i++) {
          var p = this.datas[i];
          if (this.groupname !== '' && this.search !== '') {
            if (p.group.toLowerCase().indexOf(this.groupname.toLowerCase()) !== -1 && p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
              this.temp.push(p);
            }
          } else {
            if (this.groupname !== '') {
              if (p.group.toLowerCase().indexOf(this.groupname.toLowerCase()) !== -1) {
                this.temp.push(p);
              }
            }
            if (this.search !== '') {
              if (p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
                this.temp.push(p);
              }
            }
          }
        }
      }
    },
    handleSearch: function handleSearch() {
      this.check = true;
      this.loadData();
    },
    handleReset: function handleReset() {
      this.check = false;
      this.groupname = '';
      this.search = '';
      this.loadData();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.timer = setInterval(function () {
      _this3.loadData();
    }, 2000);
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.loadData();
    });
  }
});

/***/ }),

/***/ "aegI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting-page"},[_c('Form',{attrs:{"label-width":100}},[_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t('setting.Basic_Information')))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.username')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.name')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('setting.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t('setting.company_information')))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.company')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.workNo')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.workNo),callback:function ($$v) {_vm.workNo=$$v},expression:"workNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.role')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t('setting.Contact_information')))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.phone')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('setting.please_enter')},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.eMail')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('setting.please_enter')},model:{value:(_vm.eMail),callback:function ($$v) {_vm.eMail=$$v},expression:"eMail"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.qq')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('setting.please_enter')},model:{value:(_vm.qq),callback:function ($$v) {_vm.qq=$$v},expression:"qq"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.wechat')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('setting.please_enter')},model:{value:(_vm.wechat),callback:function ($$v) {_vm.wechat=$$v},expression:"wechat"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t("setting.System_setting")))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('setting.language')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.language},on:{"on-change":_vm.Changelanguage},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}},[_c('Option',{key:"zh-cn",attrs:{"value":"zh-cn"}},[_vm._v(_vm._s(_vm.$t('setting.zhcn')))]),_vm._v(" "),_c('Option',{key:"en-US",attrs:{"value":"en-US"}},[_vm._v(_vm._s(_vm.$t('setting.enUS')))]),_vm._v(" "),_c('Option',{key:"zh-tw",attrs:{"value":"zh-tw"}},[_vm._v(_vm._s(_vm.$t('setting.zhtw')))]),_vm._v(" "),_c('Option',{key:"ja-JP",attrs:{"value":"ja-JP"}},[_vm._v(_vm._s(_vm.$t('setting.jaJP')))]),_vm._v(" "),_c('Option',{key:"vi-VN",attrs:{"value":"vi-VN"}},[_vm._v(_vm._s(_vm.$t('setting.viVN')))]),_vm._v(" "),_c('Option',{key:"th-TH",attrs:{"value":"th-TH"}},[_vm._v(_vm._s(_vm.$t('setting.thTH')))])],1)],1),_vm._v(" "),_c('FormItem',[_c('qriously',{attrs:{"value":_vm.qr,"size":200,"backgroundAlpha":1}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('setting.save')))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ahPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("SR88");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73aa7ca3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("ti4O");
function injectStyle (ssrContext) {
  __webpack_require__("5eCs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73aa7ca3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73aa7ca3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ajpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var productionPlan = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/productionPlan/list');
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/productionPlan/delete', { id: id });
  },
  save: function save(p) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/productionPlan/save', p);
    // return Promise.resolve({ id: r.id, name: 'admin', permissions: [{action: 'system', value: 1}, {action: 'people', value: 2}] })
  },
  close: function close(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collectorPlan/close', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (productionPlan);

/***/ }),

/***/ "aret":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_layout__ = __webpack_require__("YPbV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {};
  },

  components: {
    SideBar: __WEBPACK_IMPORTED_MODULE_1__views_layout__["a" /* SideBar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1__views_layout__["b" /* AppMain */],
    NavBar: __WEBPACK_IMPORTED_MODULE_1__views_layout__["c" /* NavBar */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['menus', 'menusOpened']))
});

/***/ }),

/***/ "asca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Collector',
  data: function data() {
    var _this = this;

    return {
      columns: [
      // { type: 'index', title: '序号', fixed: 'left' },
      {
        title: this.$t('device.collector.operating'),
        key: 'action',
        fixed: 'left',
        render: function render(h, params) {
          if (_this.permissions === true) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.edit(params.index);
                }
              }
            }, _this.$t('device.collector.edit'))
            // h('Button', {
            //   props: {
            //     type: 'error',
            //     size: 'small'
            //   },
            //   on: {
            //     click: () => {
            //       if (confirm(this.$t('device.collector.delete_message'))) {
            //         this.remove(params.index)
            //       }
            //     }
            //   }
            // }, this.$t('device.collector.delete'))
            ]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              }
            }, _this.$t('device.collector.edit'))
            // h('Button', {
            //   props: {
            //     type: 'error',
            //     size: 'small',
            //     disabled: true
            //   }
            // }, this.$t('device.collector.delete'))
            ]);
          }
        }
      }, { title: this.$t('device.collector.name'), key: 'name', sortable: true, fixed: 'left', sortType: 'asc', width: 120, ellipsis: true }, { title: this.$t('device.collector.deviceNo'), key: 'deviceNo', sortable: true, width: 95 }, {
        title: this.$t('device.collector.routerID'),
        key: 'routerID',
        render: function render(h, params) {
          var no = '';
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.routers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var r = _step.value;

              if (r.id === params.row.routerID) {
                no = r.AnotherName;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return h('span', no);
        }
      }, { title: this.$t('device.collector.type'), key: 'type', sortable: true }, {
        title: this.$t('device.collector.computeType'),
        key: 'computeType',
        render: function render(h, params) {
          var no = '';
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.computeTypes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var c = _step2.value;

              if (c.id === params.row.computeType) {
                no = c.name;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          return h('span', no);
        }
      }, { title: this.$t('device.collector.length'), key: 'length' }, { title: this.$t('device.collector.count'), key: 'count', sortable: true }, { title: this.$t('device.collector.width'), key: 'width', sortable: true }, { title: this.$t('device.collector.deviceCompany'), key: 'deviceCompany' }, { title: this.$t('device.collector.deviceModel'), key: 'deviceModel' }, { title: this.$t('device.collector.buyTime'), key: 'buyTime' }, { title: this.$t('device.collector.deviceLifeTime'), key: 'deviceLifeTime' }, { title: this.$t('device.collector.remark'), key: 'remark' }],
      datas: [],
      collectorList: [],
      search: '',
      computeTypes: [],
      routers: [],
      permissions: false
    };
  },

  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : this.datas[index].id;
      this.$router.push({ name: 'CollectorEdit', params: { id: id } });
    },
    remove: function remove(index) {
      var _this2 = this;

      this.$api.collector.delete(this.datas[index].id).then(function () {
        _this2.datas.splice(index, 1);
      });
    },
    handleSearch: function handleSearch() {
      this.datas = [];
      for (var i = 0; i < this.collectorList.length; i++) {
        var p = this.collectorList[i];
        if (p.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          this.datas.push(p);
        }
      }
    },
    handleReset: function handleReset() {
      this.datas = this.collectorList;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].computeType.list().then(function (res) {
      _this3.computeTypes = res;
      _this3.computeTypes[0].name = _this3.$t('device.collector.roller');
      _this3.computeTypes[1].name = _this3.$t('device.collector.weft_density');
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].router.list().then(function (res) {
      _this3.routers = res.routers;
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].collector.list().then(function (res) {
      _this3.collectorList = res.collectors;
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'device' && res.user.permissions[i].value === 3) {
          _this3.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].collector.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.collectors;
      });
    });
  }
});

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var user = {
  state: {
    inited: false,
    user: {},
    company: {},
    permissions: []
  },
  mutations: {
    SET_USER: function SET_USER(state, user) {
      state.user = user;
      state.inited = true;
    },
    SET_COMPANY: function SET_COMPANY(state, company) {
      state.company = company;
    },
    SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    SET_USERNAME: function SET_USERNAME(state, name) {
      state.user.username = name;
    },
    REMOVE_USER: function REMOVE_USER(state, name) {
      state.inited = false;
    }
  },
  actions: {
    SetUser: function SetUser(_ref, res) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('SET_USER', res.user);
        commit('SET_COMPANY', res.user.company);
        commit('SET_PERMISSIONS', res.user.permissions);
        resolve(res.user.permissions);
      });
    },
    RemoveUser: function RemoveUser(_ref2) {
      var commit = _ref2.commit;

      commit('REMOVE_USER');
    },
    SetUserName: function SetUserName(_ref3, name) {
      var commit = _ref3.commit;

      commit('SET_USERNAME', name);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "bSRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main",staticStyle:{"min-height":"100%"}},[_c('Breadcrumb',{staticClass:"breadcrumb"},_vm._l((_vm.levelList),function(item,index){return _c('BreadcrumbItem',{key:item.path,attrs:{"href":item.redirect||item.path}},[_vm._v(_vm._s(_vm.$t(item.meta.title)))])})),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bVxS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Order',
  data: function data() {
    var _this = this;

    return {
      columns: [{
        title: this.$t('Order.status'),
        key: 'status1',
        width: 100,
        render: function render(h, params) {
          if (params.row.valid === 0) {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.change(params.row.id);
                }
              }
            }, params.row.status2);
          } else if (params.row.PPValid === 1 && params.row.CPValid === 1) {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.$router.push({ 'name': 'OrderPlan' });
                }
              }
            }, params.row.status2);
          } else if (params.row.PPValid === 1) {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.$router.push({ 'name': 'CollectorPlan' });
                }
              }
            }, params.row.status2);
          } else {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.$router.push({ 'name': 'ProductionPlan' });
                }
              }
            }, params.row.status2);
          }
        }
      }, { title: this.$t('Order.productNo'), key: 'productNo' }, { title: this.$t('Order.num'), key: 'num' }, { title: this.$t('Order.unit'), key: 'unit' }, { title: this.$t('Order.attritionRate'), key: 'attritionRate' }, { title: this.$t('Order.deliveryTime'), key: 'deliveryTime' }, { title: this.$t('Order.remark'), key: 'remark' }],
      datas: [],
      datasList: [],
      totalList: [],
      temp1: [],
      temp2: [],
      temp3: [],
      search1: '',
      search2: '',
      search3: '',
      Valid: '',
      products: [],
      permissions: false
    };
  },

  computed: {},
  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : index;
      this.$router.push({ name: 'OrderEdit', params: { id: id } });
    },
    remove: function remove(index) {
      var _this2 = this;

      if (confirm(this.$t('Order.delete_message'))) {
        this.$api.order.delete(this.datas[index].orderID).then(function () {
          _this2.datas.splice(index, 1);
        });
      }
    },
    change: function change(id) {
      var _this3 = this;

      if (confirm(this.$t('Order.change_message'))) {
        this.$api.order.change(id).then(function () {
          for (var i = 0; i < _this3.datas.length; i++) {
            for (var j = 0; j < _this3.datas[i].orderProducts.length; j++) {
              if (id === _this3.datas[i].orderProducts[j].id) {
                _this3.datas[i].orderProducts[j].status1 = 'primary';
                _this3.datas[i].orderProducts[j].status2 = _this3.$t('Order.Producting');
                _this3.datas[i].orderProducts[j].valid = 1;
              }
            }
          }
        });
      }
    },
    handleSearch: function handleSearch() {
      this.datas = [];
      this.temp1 = [];
      this.temp2 = [];
      this.temp3 = [];
      if (this.Valid === '1') {
        for (var i = 0; i < this.datasList.length; i++) {
          var p = this.datasList[i];
          for (var j = 0; j < p.orderProducts.length; j++) {
            if (p.orderProducts[j].PPValid === 0 && p.orderProducts[j].CPValid === 0 && p.orderProducts[j].Closedtime === '') {
              this.temp3.push(p);
              break;
            }
          }
        }
      } else if (this.Valid === '2') {
        for (var _i = 0; _i < this.datasList.length; _i++) {
          var _p = this.datasList[_i];
          for (var _j = 0; _j < _p.orderProducts.length; _j++) {
            if (_p.orderProducts[_j].PPValid === 1 && _p.orderProducts[_j].CPValid === 0 && _p.orderProducts[_j].Closedtime === '') {
              this.temp3.push(_p);
              break;
            }
          }
        }
      } else if (this.Valid === '3') {
        for (var _i2 = 0; _i2 < this.datasList.length; _i2++) {
          var _p2 = this.datasList[_i2];
          for (var _j2 = 0; _j2 < _p2.orderProducts.length; _j2++) {
            if (_p2.orderProducts[_j2].PPValid === 1 && _p2.orderProducts[_j2].CPValid === 1 && _p2.orderProducts[_j2].Closedtime === '') {
              this.temp3.push(_p2);
              break;
            }
          }
        }
      } else if (this.Valid === '4') {
        for (var _i3 = 0; _i3 < this.totalList.length; _i3++) {
          var _p3 = this.totalList[_i3];
          for (var _j3 = 0; _j3 < _p3.orderProducts.length; _j3++) {
            if (_p3.orderProducts[_j3].Closedtime !== '') {
              this.temp3.push(_p3);
            }
          }
        }
      } else {
        this.temp3 = this.datasList;
      }
      for (var _i4 = 0; _i4 < this.temp3.length; _i4++) {
        var _p4 = this.temp3[_i4];
        if (this.search1 === '') {
          this.temp1 = this.temp3;
          break;
        } else if (_p4.orderNo.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
          this.temp1.push(_p4);
        }
      }
      for (var _i5 = 0; _i5 < this.temp1.length; _i5++) {
        var _p5 = this.temp1[_i5];
        if (this.search2 === '') {
          this.temp2 = this.temp1;
          break;
        } else if (_p5.customer.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
          this.temp2.push(_p5);
        }
      }
      for (var _i6 = 0; _i6 < this.temp2.length; _i6++) {
        var _p6 = this.temp2[_i6];
        if (this.search3 === '') {
          this.datas = this.temp2;
          break;
        } else if (_p6.salesman.toLowerCase().indexOf(this.search3.toLowerCase()) !== -1) {
          this.datas.push(_p6);
        }
      }
      if (this.Valid === '4') {
        for (var _i7 = 0; _i7 < this.datas.length; _i7++) {
          for (var _j4 = 0; _j4 < this.datas[_i7].orderProducts.length; _j4++) {
            if (this.datas[_i7].orderProducts[_j4].unit === 1) {
              this.datas[_i7].orderProducts[_j4].unit = this.$t('Order.Meter');
            } else if (this.datas[_i7].orderProducts[_j4].unit === 2) {
              this.datas[_i7].orderProducts[_j4].unit = this.$t('Order.Yard');
            } else if (this.datas[_i7].orderProducts[_j4].unit === 3) {
              this.datas[_i7].orderProducts[_j4].unit = this.$t('Order.Gross');
            }
            if (this.datas[_i7].orderProducts[_j4].valid === 0) {
              this.datas[_i7].orderProducts[_j4].status1 = 'success';
              this.datas[_i7].orderProducts[_j4].status2 = this.$t('Order.Case_closed');
              this.datas[_i7].check = 1;
            } else if (this.datas[_i7].orderProducts[_j4].PPValid === 1 && this.datas[_i7].orderProducts[_j4].CPValid === 1) {
              this.datas[_i7].orderProducts[_j4].status1 = 'primary';
              this.datas[_i7].orderProducts[_j4].status2 = this.$t('Order.Producting');
              this.datas[_i7].check = 1;
            } else if (this.datas[_i7].orderProducts[_j4].PPValid === 1) {
              this.datas[_i7].orderProducts[_j4].status1 = 'warning';
              this.datas[_i7].orderProducts[_j4].status2 = this.$t('Order.Not_production');
              this.datas[_i7].check = 1;
            } else {
              this.datas[_i7].orderProducts[_j4].status1 = 'error';
              this.datas[_i7].orderProducts[_j4].status2 = this.$t('Order.No_scheduling');
            }
          }
        }
      }
      // console.log(this.datas)
    },
    handleReset: function handleReset() {
      this.datas = this.datasList;
      this.Valid = '';
      this.search1 = '';
      this.search2 = '';
      this.search3 = '';
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].product.list().then(function (res) {
      _this4.products = res.products;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'order' && res.user.permissions[i].value === 3) {
          _this4.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // console.log(to.fullPath)
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].order.list().then(function (res) {
      next(function (vm) {
        var d = [];
        vm.datas = res.orderInfos;
        vm.datasList = res.orderInfos;
        vm.totalList = res.orderInfos;
        for (var i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].Ordervalid === 1) {
            vm.datas[i].check = 0;
            for (var j = 0; j < vm.datas[i].orderProducts.length; j++) {
              if (vm.datas[i].orderProducts[j].unit === 1) {
                vm.datas[i].orderProducts[j].unit = vm.$t('Order.Meter');
              } else if (vm.datas[i].orderProducts[j].unit === 2) {
                vm.datas[i].orderProducts[j].unit = vm.$t('Order.Yard');
              } else if (vm.datas[i].orderProducts[j].unit === 3) {
                vm.datas[i].orderProducts[j].unit = vm.$t('Order.Gross');
              }
              if (vm.datas[i].orderProducts[j].valid === 0) {
                vm.datas[i].orderProducts[j].status1 = 'success';
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.Case_closed');
                vm.datas[i].check = 1;
              } else if (vm.datas[i].orderProducts[j].PPValid === 1 && vm.datas[i].orderProducts[j].CPValid === 1) {
                vm.datas[i].orderProducts[j].status1 = 'primary';
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.Producting');
                vm.datas[i].check = 1;
              } else if (vm.datas[i].orderProducts[j].PPValid === 1) {
                vm.datas[i].orderProducts[j].status1 = 'warning';
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.Not_production');
                vm.datas[i].check = 1;
              } else {
                vm.datas[i].orderProducts[j].status1 = 'error';
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.No_scheduling');
              }
            }
            d.push(vm.datas[i]);
          }
        }
        vm.datas = d;
        vm.datasList = d;
      });
    });
  }
});

/***/ }),

/***/ "c3cp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Collector',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('monitor.Order.index'), width: 65 }, { title: this.$t('monitor.Order.orderNo'), key: 'orderNo' }, { title: this.$t('plan.Production.productName'), key: 'productName' }, { title: this.$t('monitor.Order.producNo'), key: 'producNo' }, { title: this.$t('monitor.Order.salesman'), key: 'salesman' }, { title: this.$t('monitor.Order.ordersTime'), key: 'ordersTime' }, { title: this.$t('monitor.Order.output'), key: 'output' }, { title: this.$t('monitor.Order.today'), key: 'today' }, { title: this.$t('monitor.Order.num'), key: 'num' }, { title: this.$t('monitor.Order.unit'), key: 'unit', width: 70 },
      // { title: '机台数', key: 'count' },
      { title: this.$t('monitor.Order.countdata'),
        key: 'countdata',
        width: 85,
        render: function render(h, params) {
          if (_this.datas[params.index].count === 0) {
            return h('a', _this.datas[params.index].count);
          } else {
            return h('Poptip', {
              props: {
                trigger: 'hover',
                placement: 'left'
              }
            }, [h('Tag', _this.datas[params.index].count), h('div', {
              slot: 'content'
            }, [h('table', [h('thead', [h('tr', [h('th', _this.$t('monitor.Order.name')), h('th', _this.$t('monitor.Order.rpm')), h('th', _this.$t('monitor.Order.workType')), h('th', _this.$t('monitor.Order.worker'))])]), h('tbody', _this.datas[params.index].countdata.map(function (item) {
              return h('tr', [h('td', item.deviceName), h('td', item.rpm), h('td', item.workType), h('td', item.worker)]);
            }))])])]);
          }
        }
      },
      // { title: this.$t('monitor.Order.DailyOutput'), key: 'DailyOutput' },
      // { title: 'm', key: 'deliveryTime' },
      { title: this.$t('monitor.Order.fastestdelivery'), key: 'fastestdelivery' }, { title: this.$t('monitor.Order.deliveryTime'), key: 'deliveryTime' }],
      datas: [],
      Producting: [],
      SystemCode: '',
      collectors: [],
      outputdata1: [],
      temp: [],
      selectTime1: '',
      selectTime2: '',
      search1: '',
      search2: '',
      check: false,
      DailyData: []
    };
  },

  methods: {
    loadData: function loadData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].system.get().then(function (res) {
        _this2.SystemCode = res.company.systemCode;
        // console.log(this.SystemCode)
      });
      var code = '{"systemcode":"' + this.SystemCode + '"}';
      // console.log(code)
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].monitor.producting(code).then(function (res) {
        _this2.Producting = res.datas;
        // console.log(res)
      });
      // console.log(this.Producting)
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].monitor.collectors().then(function (res) {
        _this2.collectors = res.collectors;
      });
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].data.DailyData().then(function (res) {
        for (var i = 0; i < res.datas.length; i++) {
          _this2.DailyData[res.datas[i].orderProductID] = {};
          _this2.DailyData[res.datas[i].orderProductID].output = res.datas[i].output;
          _this2.DailyData[res.datas[i].orderProductID].today = res.datas[i].today;
        }
        // console.log(this.DailyData)
      });
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].monitor.orders().then(function (res) {
        _this2.datas = res.datas;
        for (var i = 0; i < _this2.datas.length; i++) {
          var fastestdelivery = false;
          var output = 0;
          // let today = 0
          if (_this2.DailyData[_this2.datas[i].id] === undefined) {
            _this2.DailyData[_this2.datas[i].id] = {};
            _this2.DailyData[_this2.datas[i].id].today = 0;
            _this2.DailyData[_this2.datas[i].id].output = 0;
          }
          // console.log(this.DailyData[this.datas[i].id], 1)
          if (_this2.datas[i].unit === 1) {
            _this2.datas[i].today = _this2.DailyData[_this2.datas[i].id].today;
            _this2.datas[i].unit = _this2.$t('monitor.Order.Meter');
            _this2.datas[i].output = _this2.datas[i].output.toFixed(2);
            output = _this2.datas[i].output;
            var percentage = 0;
            if (_this2.datas[i].output !== 0) {
              percentage = _this2.datas[i].output / _this2.datas[i].num * 100;
            }
            _this2.datas[i].output += '(' + percentage.toFixed(0) + '%)';
            if (percentage >= 100) {
              fastestdelivery = true;
            }
          } else if (_this2.datas[i].unit === 2) {
            _this2.DailyData[_this2.datas[i].id].output = _this2.DailyData[_this2.datas[i].id].output * 1.0936;
            _this2.DailyData[_this2.datas[i].id].output = _this2.DailyData[_this2.datas[i].id].output.toFixed(2);
            _this2.datas[i].today = _this2.DailyData[_this2.datas[i].id].today * 1.0936;
            _this2.datas[i].today = _this2.datas[i].today.toFixed(0);
            _this2.datas[i].unit = _this2.$t('monitor.Order.Yard');
            _this2.datas[i].output = _this2.datas[i].output * 1.0936;
            _this2.datas[i].output = _this2.datas[i].output.toFixed(2);
            output = _this2.datas[i].output;
            var _percentage = 0;
            if (_this2.datas[i].output !== 0) {
              _percentage = _this2.datas[i].output / _this2.datas[i].num * 100;
            }
            _this2.datas[i].output += '(' + _percentage.toFixed(0) + '%)';
            if (_percentage >= 100) {
              fastestdelivery = true;
            }
          } else if (_this2.datas[i].unit === 3) {
            // console.log(this.DailyData[this.datas[i].id], this.datas[i].id, this.DailyData[this.datas[i].id].output)
            _this2.DailyData[_this2.datas[i].id].output = _this2.DailyData[_this2.datas[i].id].output / (144.0 * 0.9144);
            _this2.DailyData[_this2.datas[i].id].output = _this2.DailyData[_this2.datas[i].id].output.toFixed(2);
            // console.log(this.DailyData[this.datas[i].id], this.datas[i].id, this.DailyData[this.datas[i].id].output)
            _this2.datas[i].today = _this2.DailyData[_this2.datas[i].id].today / (144.0 * 0.9144);
            _this2.datas[i].today = _this2.datas[i].today.toFixed(0);
            _this2.datas[i].unit = _this2.$t('monitor.Order.Gross');
            _this2.datas[i].output = _this2.datas[i].output / (144.0 * 0.9144);
            _this2.datas[i].output = _this2.datas[i].output.toFixed(2);
            output = _this2.datas[i].output;
            var _percentage2 = 0;
            if (_this2.datas[i].output !== 0) {
              _percentage2 = _this2.datas[i].output / _this2.datas[i].num * 100;
            }
            _this2.datas[i].output += '(' + _percentage2.toFixed(0) + '%)';
            if (_percentage2 >= 100) {
              fastestdelivery = true;
            }
          }
          if (fastestdelivery === true) {
            _this2.datas[i].fastestdelivery = _this2.$t('monitor.Order.completed');
          } else {
            if (_this2.DailyData[_this2.datas[i].id] !== undefined && Number(_this2.DailyData[_this2.datas[i].id].output) !== 0) {
              var _sum = void 0;
              _sum = _this2.datas[i].num - output;
              _sum = Math.ceil(_sum / _this2.DailyData[_this2.datas[i].id].output);
              var Today = new Date();
              Today.setDate(Today.getDate() + _sum);
              _this2.datas[i].fastestdelivery = Today.getFullYear() + '-' + (Today.getMonth() + 1) + '-' + Today.getDate();
            } else {
              _this2.datas[i].fastestdelivery = _this2.datas[i].deliveryTime;
            }
          }
          var timestamp = new Date(_this2.datas[i].deliveryTime).getTime();
          _this2.datas[i].timestamp = timestamp;
          var d = [];
          var sum = 0;
          var count = 0;
          // let count = 0
          // console.log(this.Producting, 1)
          if (_this2.Producting !== null) {
            for (var j = 0; j < _this2.Producting.length; j++) {
              if (_this2.datas[i].id === _this2.Producting[j].id) {
                // for (let t = 0; t < this.outputdata1.length; t++) {
                //   if (this.Producting[j].deviceid === this.outputdata1[t].id) {
                //     sum += this.outputdata1[t].output
                //     // count++
                //     // console.log(sum, count)
                //   }
                // }
                var RPM = 0;
                var Type = '';
                var work = '';
                count++;
                for (var t = 0; t < _this2.collectors.length; t++) {
                  if (_this2.collectors[t].deviceNo === _this2.Producting[j].deviceNo) {
                    RPM = _this2.collectors[t].rpm;
                    Type = _this2.collectors[t].workType;
                    work = _this2.collectors[t].worker;
                  }
                }
                d.push({
                  deviceNo: _this2.Producting[j].deviceNo,
                  deviceName: _this2.Producting[j].deviceName,
                  rpm: RPM,
                  workType: Type,
                  worker: work
                });
              }
            }
          }
          _this2.datas[i].count = count;
          // console.log(sum, count)
          if (sum === 0) {
            _this2.datas[i].DailyOutput = 0;
          } else {
            _this2.datas[i].DailyOutput = sum;
            // console.log(this.datas[i].DailyOutput, '1')
          }
          _this2.datas[i].countdata = d;
          // console.log(this.datas[i].DailyOutput)
        }
        // console.log(this.datas)
        _this2.temp = [];
        if (_this2.check === true) {
          var d1 = [];
          var d2 = [];
          var d3 = [];
          if (_this2.search1 !== '') {
            for (var _i = 0; _i < _this2.datas.length; _i++) {
              if (_this2.datas[_i].orderNo.toLowerCase().indexOf(_this2.search1.toLowerCase()) !== -1) {
                d1.push(_this2.datas[_i]);
              }
            }
          } else {
            d1 = _this2.datas;
          }
          if (_this2.search2 !== '') {
            for (var _i2 = 0; _i2 < d1.length; _i2++) {
              if (_this2.datas[_i2].salesman.toLowerCase().indexOf(_this2.search2.toLowerCase()) !== -1) {
                d2.push(d1[_i2]);
              }
            }
          } else {
            d2 = d1;
          }
          if (_this2.selectTime1 !== '') {
            var _timestamp = new Date(_this2.selectTime1).getTime();
            for (var _i3 = 0; _i3 < d2.length; _i3++) {
              if (_timestamp <= d2[_i3].timestamp) {
                d3.push(d2[_i3]);
              }
            }
          } else {
            d3 = d2;
          }
          if (_this2.selectTime2 !== '') {
            var _timestamp2 = new Date(_this2.selectTime2).getTime();
            for (var _i4 = 0; _i4 < d3.length; _i4++) {
              if (_timestamp2 >= d3[_i4].timestamp) {
                _this2.temp.push(d3[_i4]);
              }
            }
          } else {
            _this2.temp = d3;
          }
        }
      });
    },
    handleSearch: function handleSearch() {
      this.check = true;
      this.loadData();
    },
    handleReset: function handleReset() {
      this.check = false;
      this.selectTime1 = '';
      this.selectTime2 = '';
      this.search1 = '';
      this.search2 = '';
      this.loadData();
    },
    entryTimeChange1: function entryTimeChange1(v) {
      this.selectTime1 = v;
    },
    entryTimeChange2: function entryTimeChange2(v) {
      this.selectTime2 = v;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.timer = setInterval(function () {
      _this3.loadData();
    }, 2000);
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.loadData();
    });
  }
});

/***/ }),

/***/ "cYIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-info-page"},[_c('Form',{attrs:{"label-width":100}},[_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t("system.SystemAuth.Information")))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemAuth.systemVersion')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.systemVersion),callback:function ($$v) {_vm.systemVersion=$$v},expression:"systemVersion"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemAuth.systemDealTime')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.systemDealTime),callback:function ($$v) {_vm.systemDealTime=$$v},expression:"systemDealTime"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemAuth.systemAuthCode')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemAuth.please_enter')},model:{value:(_vm.systemAuthCode),callback:function ($$v) {_vm.systemAuthCode=$$v},expression:"systemAuthCode"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.SystemAuth.save")))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","disabled":""},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.SystemAuth.save")))]):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dAdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("gyMJ");

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CollectorGroup',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('device.group.index') }, { title: this.$t('device.group.name'), key: 'name' }, {
        title: this.$t('device.group.devices'),
        key: 'devices',
        render: function render(h, params) {
          if (params.row.collectors === null) {
            return h('');
          }
          var cls = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(params.row.collectors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var v = _step.value;

              var cl = _this.collectors[v];
              if (cl !== undefined) {
                cls.push(cl);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return h('span', cls.join());
        }
      }, { title: this.$t('device.group.remark'), key: 'remark' }, {
        title: this.$t('device.group.operating'),
        key: 'action',
        render: function render(h, params) {
          if (_this.permissions === true) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.edit(params.index);
                }
              }
            }, _this.$t('device.group.edit')), h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              on: {
                click: function click() {
                  if (confirm(_this.$t('device.group.delete_message'))) {
                    _this.remove(params.index);
                  }
                }
              }
            }, _this.$t('device.group.delete'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              }
            }, _this.$t('device.group.edit')), h('Button', {
              props: {
                type: 'error',
                size: 'small',
                disabled: true
              }
            }, _this.$t('device.group.delete'))]);
          }
        }
      }],
      datas: [],
      collectors: {},
      permissions: false
    };
  },

  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : this.datas[index].id;
      this.$router.push({ name: 'CollectorGroupEdit', params: { id: id } });
    },
    remove: function remove(index) {
      var _this2 = this;

      this.$api.collectorGroup.delete(this.datas[index].id).then(function () {
        _this2.datas.splice(index, 1);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].collector.list().then(function (res) {
      var cls = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.collectors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var cl = _step2.value;

          cls[cl.id] = cl.name;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      _this3.collectors = cls;
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'device' && res.user.permissions[i].value === 3) {
          _this3.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__api__["b" /* Api */].collectorGroup.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.collectorGroups;
      });
    });
  }
});

/***/ }),

/***/ "dDHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__ = __webpack_require__("vWCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b421b778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__ = __webpack_require__("XiYI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b421b778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dG/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-info-page"},[_c('Form',{attrs:{"label-width":100}},[_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t('ChangePw.ChangePw')))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('ChangePw.oldPassword')}},[_c('Input',{staticClass:"info",model:{value:(_vm.oldPassword),callback:function ($$v) {_vm.oldPassword=$$v},expression:"oldPassword"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('ChangePw.newPassword')}},[_c('Input',{staticClass:"info",model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('ChangePw.comfirmPassword')}},[_c('Input',{staticClass:"info",model:{value:(_vm.comfirmPassword),callback:function ($$v) {_vm.comfirmPassword=$$v},expression:"comfirmPassword"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('ChangePw.save')))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dZU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MaintainEdit',
  data: function data() {
    return {
      id: 0,
      device: '',
      operator: '',
      startTime: '',
      endTime: '',
      remark: '',
      deviceList: []
    };
  },

  computed: {
    title: function title() {
      return this.$t('Maintain.Return_to_Maintain_list');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var m = {
        id: this.id,
        DeviceName: this.device,
        username: this.operator,
        startTime: this.startTime,
        endTime: this.endTime,
        remark: this.remark
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].maintain.save(m).then(function () {
        _this.$router.push({ 'name': 'MaintainList' });
      });
    }
  },
  mounted: function mounted() {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].maintain.get(id).then(function (res) {
        var m = res.maintain;
        next(function (vm) {
          vm.id = m.id;
          vm.device = m.DeviceName;
          vm.operator = m.username;
          vm.startTime = m.startTime;
          vm.endTime = m.endTime;
          vm.remark = m.remark;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "dqCe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eLmY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "egBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");



var menu = {
  state: {
    menus: [],
    opened: true,
    created: false
  },
  mutations: {
    SET_MENUS: function SET_MENUS(state, routers) {
      state.menus = routers;
    },
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      state.opened = !state.opened;
    },
    MENU_CREATED: function MENU_CREATED(state) {
      state.created = true;
    }
  },
  actions: {
    GenerateMenus: function GenerateMenus(_ref, permission) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var pjson = {};
        for (var i = 0; i < permission.length; i++) {
          pjson[permission[i].action] = permission[i].value;
        }
        var menuAdd = [];
        for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_1__router__["b" /* menueRouterMap */].length; _i++) {
          var m = __WEBPACK_IMPORTED_MODULE_1__router__["b" /* menueRouterMap */][_i];
          if (m.permission === 'setting') {
            menuAdd.push(m);
          }
          if (pjson[m.permission]) {
            menuAdd.push(m);
          }
        }
        commit('SET_MENUS', menuAdd);
        resolve();
      });
    },
    ToggleSideBar: function ToggleSideBar(_ref2) {
      var commit = _ref2.commit;

      commit('TOGGLE_SIDEBAR');
    },
    MenuCreated: function MenuCreated(_ref3) {
      var commit = _ref3.commit;

      commit('MENU_CREATED');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (menu);

/***/ }),

/***/ "fJPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PeopleEdit',
  data: function data() {
    return {
      id: 0,
      username: '',
      role: '',
      workNo: '',
      name: '',
      sex: 0,
      workType: [],
      phone: '',
      qq: '',
      wechat: '',
      entryTime: '',
      working: 1,
      workTypeList: []
    };
  },

  computed: {
    title: function title() {
      return this.$t('People.edit_People');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var people = {
        id: this.id,
        username: this.username,
        workNo: this.workNo,
        name: this.name,
        sex: this.sex,
        workType: this.workType,
        phone: this.phone,
        qq: this.qq,
        role: Number(this.role),
        wechat: this.wechat,
        entryTime: this.entryTime,
        working: this.working
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].people.save(people).then(function () {
        _this.$router.push({ 'name': 'PeopleList' });
      });
    },
    entryTimeChange: function entryTimeChange(v) {
      this.entryTime = v;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workType.list().then(function (res) {
      _this2.workTypeList = res.workTypes;
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].people.get(id).then(function (res) {
        var p = res.account;
        next(function (vm) {
          vm.id = p.id;
          vm.workNo = p.workNo;
          vm.name = p.name;
          vm.sex = p.sex;
          if (p.workType !== null) {
            vm.workType = p.workType;
          }
          vm.role = p.role;
          vm.username = p.username;
          vm.phone = p.phone;
          vm.qq = p.qq;
          vm.wechat = p.wechat;
          vm.entryTime = p.entryTime;
          vm.working = p.working;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "fLcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderEdit',
  data: function data() {
    return {
      id: 0,
      cardNo: '',
      workType: 0,
      userID: 0,
      workTypeList: [],
      userList: [],
      list: [],
      check: false
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('Card.New_Card') : this.$t('Card.edit_Card');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var card = void 0;
      this.check = false;
      console.log(this.list);
      if (this.list !== undefined) {
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].cardNo === this.cardNo && this.list[i].id !== this.id) {
            this.check = true;
            break;
          }
        }
      }
      if (this.check === true) {
        var title = this.$t('Card.error');
        var content = this.$t('Card.error_message1');
        this.$Modal.error({
          title: title,
          content: content
        });
      } else if (this.cardNo !== '' && this.workType !== '' && this.userID !== '') {
        card = {
          id: this.id,
          cardNo: this.cardNo,
          workType: this.workType,
          userID: this.userID
        };
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].card.save(card).then(function () {
          _this.$router.push({ 'name': 'CardList' });
        });
      } else {
        var _title = this.$t('Card.error');
        var _content = this.$t('Card.error_message2');
        this.$Modal.error({
          title: _title,
          content: _content
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workType.list().then(function (res) {
      _this2.workTypeList = res.workTypes;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].people.list().then(function (res) {
      _this2.userList = res.accounts;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].card.list().then(function (res) {
      _this2.list = res.cards;
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].card.get(id).then(function (res) {
        var o = res.card;
        next(function (vm) {
          vm.id = o.id;
          vm.cardNo = o.cardNo;
          vm.workType = o.workType;
          vm.userID = o.userID;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "ftBh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Product',
  data: function data() {
    var _this = this;

    return {
      showheader: false,
      searchOrder: '',
      searchCollector: '',
      // countrow: '',
      Radioselection: 0,
      orderColumns: [{
        title: this.$t('plan.Production.status'),
        key: 'status1',
        width: 100,
        render: function render(h, params) {
          if (params.row.valid === 0) {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.change(params.row.id);
                }
              }
            }, params.row.status2);
          } else if (params.row.PPValid === 1 && params.row.CPValid === 1) {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.$router.push({ 'name': 'OrderPlan' });
                }
              }
            }, params.row.status2);
          } else if (params.row.PPValid === 1) {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.$router.push({ 'name': 'CollectorPlan' });
                }
              }
            }, params.row.status2);
          } else {
            return h('Button', {
              props: {
                size: 'small',
                type: params.row.status1
              },
              on: {
                click: function click() {
                  _this.$router.push({ 'name': 'ProductionPlan' });
                }
              }
            }, params.row.status2);
          }
        }
      }, { title: this.$t('plan.Production.productNo'), key: 'productNo' }, { title: this.$t('plan.Production.productNo'), key: 'name' }, { title: this.$t('plan.Production.num'), key: 'num' }, { title: this.$t('plan.Production.num'), key: 'deliveryTime', width: 99 }],
      collectorColumns: [{ title: this.$t('plan.Production.name'), key: 'name', sortable: true, sortType: 'asc' }, { title: this.$t('plan.Production.count'), key: 'count' }, { title: this.$t('plan.Production.width'), key: 'width' }],
      planColumns: [{ title: this.$t('plan.Production.collectorName'), key: 'collectorName', sortable: true, sortType: 'asc' }, { title: this.$t('plan.Production.orderNo'), key: 'orderNo', sortable: true }, { title: this.$t('plan.Production.productNo'), key: 'productNo', sortable: true }, { title: this.$t('plan.Production.productName'), key: 'productName', sortable: true }, { title: this.$t('plan.Production.planIndex'), key: 'planIndex', width: 71, sortable: true }, { title: this.$t('plan.Production.row'), key: 'row', width: 71 }, {
        title: this.$t('plan.Production.action'),
        key: 'action',
        width: 94,
        render: function render(h, params) {
          if (_this.permissions === false) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              }
            }, _this.$t('plan.Production.delete'))]);
          } else if (_this.permissions === true && params.row.CPValid === 1) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.productionStop(params.index, params.row.id);
                }
              }
            }, _this.$t('plan.Production.no'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.remove(params.index);
                }
              }
            }, _this.$t('plan.Production.delete'))]);
          }
        }
      }],
      orderDatas: [],
      collectorDatas: [],
      planDatas: [],
      currentOrder: {},
      currentCollector: {},
      row: 0,
      check: false,
      Valid: '',
      Steps: '1',
      search1: '',
      search2: '',
      search3: '',
      temp1: [],
      planIndex: 1,
      totalPlanDatas: [],
      totalCollectorDatas: [],
      totalOrderDatas: [],
      permissions: false
    };
  },

  computed: {
    restRow: function restRow() {
      var c = this.currentCollector.count;
      // console.log(this.Radioselection)
      if (this.Radioselection === 3) {
        for (var i = 0; i < this.planDatas.length; i++) {
          var p = this.planDatas[i];
          if (p.collectorID === this.currentCollector.id && this.planIndex === p.planIndex) {
            // console.log(this.Radioselection, this.planIndex)
            if (this.Radioselection === 2 && this.planIndex === 1) {} else {
              c -= p.row;
            }
          }
        }
      }
      return c;
    }
  },
  methods: {
    save: function save(tp) {
      var _this2 = this;

      if (this.Radioselection === 1) {
        for (var i = 0; i < this.planDatas.length; i++) {
          var p = this.planDatas[i];
          if (p.collectorID === this.currentCollector.id && p.planIndex > this.planIndex) {
            this.planIndex = p.planIndex;
          }
        }
        this.planIndex++;
      }
      if (Number(this.row) > 0) {
        var plan = {
          collectorID: this.currentCollector.id,
          orderProductID: this.currentOrder.id,
          row: Number(this.row),
          planIndex: this.planIndex,
          tp: tp
        };
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].productionPlan.save(plan).then(function () {
          // this.$router.push({'name': 'OrderPlan'})
          var info = {
            collectorID: _this2.currentCollector.id,
            orderProductID: _this2.currentOrder.id,
            collectorName: _this2.currentCollector.name,
            orderNo: _this2.currentOrder.orderNo,
            productNo: _this2.currentOrder.productNo,
            planIndex: _this2.planIndex,
            row: _this2.row,
            productName: _this2.currentOrder.name
          };
          _this2.totalPlanDatas.push(info);
          // this.planDatas.push(info)
        });
        this.Steps = '1';
        this.planDatas = this.totalPlanDatas;
        this.Radioselection = 0;
        // console.log(this.currentOrder, this.planDatas)
      } else {
        var title = this.$t('plan.Production.error');
        var content = this.$t('plan.Production.error_message');
        this.$Modal.error({
          title: title,
          content: content
        });
      }
    },
    remove: function remove(index) {
      var _this3 = this;

      if (confirm(this.$t('plan.Production.delete_message'))) {
        var id = this.planDatas[index].id;
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].productionPlan.delete(id).then(function () {
          _this3.planDatas.splice(index, 1);
          for (var i = 0; i < _this3.totalPlanDatas.length; i++) {
            if (_this3.totalPlanDatas[i].id === id) {
              _this3.totalPlanDatas.splice(i, 1);
            }
          }
        });
      }
    },
    TabRest: function TabRest() {
      this.planDatas = this.totalPlanDatas;
      this.Radioselection = 0;
      this.Steps = '1';
    },
    productionStop: function productionStop(index, ID) {
      var _this4 = this;

      if (confirm(this.$t('plan.Collector.delete_message'))) {
        var id = this.planDatas[index].id;
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].productionPlan.close(ID).then(function () {
          _this4.planDatas.splice(index, 1);
          for (var i = 0; i < _this4.totalPlanDatas.length; i++) {
            if (_this4.totalPlanDatas[i].id === id) {
              _this4.totalPlanDatas.splice(i, 1);
            }
          }
        });
      }
    },
    orderSelect: function orderSelect(current, old) {
      var pds = [];
      if (current.valid === 0) {
        alert(this.$t('plan.Production.message'));
      } else {
        this.currentOrder = current;
        for (var i = 0; i < this.totalPlanDatas.length; i++) {
          if (current.id === this.totalPlanDatas[i].orderProductID) {
            pds.push(this.totalPlanDatas[i]);
          }
        }
        this.Steps = '2';
        this.planDatas = pds;
      }
    },
    collectorSelect: function collectorSelect(current, old) {
      this.check = false;
      this.currentCollector = current;
      var pds = [];
      for (var i = 0; i < this.totalPlanDatas.length; i++) {
        if (current.id === this.totalPlanDatas[i].collectorID) {
          pds.push(this.totalPlanDatas[i]);
          if (this.totalPlanDatas[i].CPValid === 1) {
            this.check = true;
          }
        }
      }
      this.Steps = '3';
      this.planDatas = pds;
    },
    planReset: function planReset() {
      this.planDatas = this.totalPlanDatas;
      this.Steps = '1';
    },
    planSearch: function planSearch() {
      var temp1 = [];
      var temp2 = [];
      if (this.search1 !== '') {
        for (var i = 0; i < this.planDatas.length; i++) {
          if (this.planDatas[i].collectorName.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
            temp1.push(this.planDatas[i]);
          }
        }
      } else {
        temp1 = this.planDatas;
      }
      if (this.search2 !== '') {
        for (var _i = 0; _i < temp1.length; _i++) {
          if (temp1[_i].orderNo.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
            temp2.push(temp1[_i]);
          }
        }
      } else {
        temp2 = temp1;
      }
      this.planDatas = temp2;
      // this.Steps = '1'
    },
    handleSearch: function handleSearch(tp) {
      if (tp === 1) {
        this.orderDatas = [];
        this.temp1 = [];
        if (this.Valid === '1') {
          for (var i = 0; i < this.totalOrderDatas.length; i++) {
            var p = this.totalOrderDatas[i];
            for (var j = 0; j < p.orderProducts.length; j++) {
              if (p.orderProducts[j].PPValid === 0 && p.orderProducts[j].CPValid === 0 && p.orderProducts[j].Closedtime === '') {
                this.temp1.push(p);
                break;
              }
            }
          }
        } else if (this.Valid === '2') {
          for (var _i2 = 0; _i2 < this.totalOrderDatas.length; _i2++) {
            var _p = this.totalOrderDatas[_i2];
            for (var _j = 0; _j < _p.orderProducts.length; _j++) {
              if (_p.orderProducts[_j].PPValid === 1 && _p.orderProducts[_j].CPValid === 0 && _p.orderProducts[_j].Closedtime === '') {
                this.temp1.push(_p);
                break;
              }
            }
          }
        } else if (this.Valid === '3') {
          for (var _i3 = 0; _i3 < this.totalOrderDatas.length; _i3++) {
            var _p2 = this.totalOrderDatas[_i3];
            for (var _j2 = 0; _j2 < _p2.orderProducts.length; _j2++) {
              if (_p2.orderProducts[_j2].PPValid === 1 && _p2.orderProducts[_j2].CPValid === 1 && _p2.orderProducts[_j2].Closedtime === '') {
                this.temp1.push(_p2);
                break;
              }
            }
          }
        } else {
          this.temp1 = this.totalOrderDatas;
        }
        for (var _i4 = 0; _i4 < this.temp1.length; _i4++) {
          var o = this.temp1[_i4];
          if (o.orderNo.toLowerCase().indexOf(this.searchOrder.toLowerCase()) !== -1) {
            this.orderDatas.push(o);
          }
        }
      } else if (tp === 2) {
        this.collectorDatas = [];
        for (var _i5 = 0; _i5 < this.totalCollectorDatas.length; _i5++) {
          var c = this.totalCollectorDatas[_i5];
          if (c.name.toLowerCase().indexOf(this.searchCollector.toLowerCase()) !== -1 || c.deviceNo.toLowerCase().indexOf(this.searchCollector.toLowerCase()) !== -1) {
            this.collectorDatas.push(c);
          }
        }
      }
    },
    handleReset: function handleReset(tp) {
      if (tp === 1) {
        this.orderDatas = this.totalOrderDatas;
      } else if (tp === 2) {
        this.collectorDatas = this.totalCollectorDatas;
      }
    },
    ProductionSelect: function ProductionSelect(s) {
      console.log('sss:', s);
      if (s === 1) {
        this.Radioselection = 1;
      } else if (s === 2) {
        this.Radioselection = 2;
      } else if (s === 3) {
        this.Radioselection = 3;
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].order.list().then(function (res) {
      var d = [];
      _this5.totalOrderDatas = res.orderInfos;
      _this5.orderDatas = _this5.totalOrderDatas;
      for (var i = 0; i < _this5.orderDatas.length; i++) {
        if (_this5.orderDatas[i].Ordervalid === 1) {
          for (var j = 0; j < _this5.orderDatas[i].orderProducts.length; j++) {
            if (_this5.orderDatas[i].orderProducts[j].valid === 0) {
              _this5.orderDatas[i].orderProducts[j].status1 = 'success';
              _this5.orderDatas[i].orderProducts[j].status2 = _this5.$t('plan.Production.Case_closed');
            } else if (_this5.orderDatas[i].orderProducts[j].PPValid === 1 && _this5.orderDatas[i].orderProducts[j].CPValid === 1) {
              _this5.orderDatas[i].orderProducts[j].status1 = 'primary';
              _this5.orderDatas[i].orderProducts[j].status2 = _this5.$t('plan.Production.Producting');
            } else if (_this5.orderDatas[i].orderProducts[j].PPValid === 1) {
              _this5.orderDatas[i].orderProducts[j].status1 = 'warning';
              _this5.orderDatas[i].orderProducts[j].status2 = _this5.$t('plan.Production.Not_production');
            } else {
              _this5.orderDatas[i].orderProducts[j].status1 = 'error';
              _this5.orderDatas[i].orderProducts[j].status2 = _this5.$t('plan.Production.No_scheduling');
            }
          }
          d.push(_this5.orderDatas[i]);
        }
      }
      _this5.totalOrderDatas = d;
      _this5.orderDatas = d;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collector.list().then(function (res) {
      _this5.totalCollectorDatas = res.collectors;
      _this5.collectorDatas = _this5.totalCollectorDatas;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'production_plan' && res.user.permissions[i].value === 3) {
          _this5.permissions = true;
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].productionPlan.list().then(function (res) {
      if (res.productionPlanInfos !== undefined) {
        _this5.totalPlanDatas = res.productionPlanInfos;
        _this5.planDatas = _this5.totalPlanDatas;
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // Api.product.list().then(res => {
    //   next(vm => { vm.datas = res.products })
    // })
    next();
  }
});

/***/ }),

/***/ "gPbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("rKaM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c8ee46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("Svqc");
function injectStyle (ssrContext) {
  __webpack_require__("4lUq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c8ee46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_user__ = __webpack_require__("vMJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_role__ = __webpack_require__("STSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_permission__ = __webpack_require__("vZz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_department__ = __webpack_require__("5ybE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_account__ = __webpack_require__("nv77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_workTime__ = __webpack_require__("SBHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_workType__ = __webpack_require__("5XvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_system__ = __webpack_require__("V/8j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_router__ = __webpack_require__("SVcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_collector__ = __webpack_require__("/Sng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_collectorGroup__ = __webpack_require__("4v4A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_people__ = __webpack_require__("6pD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_product__ = __webpack_require__("UgCr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_order__ = __webpack_require__("FWz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_maintain__ = __webpack_require__("QB53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_collectorPlan__ = __webpack_require__("z64l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_monitor__ = __webpack_require__("5XFP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_card__ = __webpack_require__("GKtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_computeType__ = __webpack_require__("RKnq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_productionPlan__ = __webpack_require__("ajpr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_systemAuth__ = __webpack_require__("YzBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_orderPlan__ = __webpack_require__("NjDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_data__ = __webpack_require__("Foau");
























var Api = {
  user: __WEBPACK_IMPORTED_MODULE_0__api_user__["a" /* default */],
  role: __WEBPACK_IMPORTED_MODULE_1__api_role__["a" /* default */],
  permission: __WEBPACK_IMPORTED_MODULE_2__api_permission__["a" /* default */],
  department: __WEBPACK_IMPORTED_MODULE_3__api_department__["a" /* default */],
  account: __WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */],
  workTime: __WEBPACK_IMPORTED_MODULE_5__api_workTime__["a" /* default */],
  workType: __WEBPACK_IMPORTED_MODULE_6__api_workType__["a" /* default */],
  system: __WEBPACK_IMPORTED_MODULE_7__api_system__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_8__api_router__["a" /* default */],
  collector: __WEBPACK_IMPORTED_MODULE_9__api_collector__["a" /* default */],
  people: __WEBPACK_IMPORTED_MODULE_11__api_people__["a" /* default */],
  product: __WEBPACK_IMPORTED_MODULE_12__api_product__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_13__api_order__["a" /* default */],
  maintain: __WEBPACK_IMPORTED_MODULE_14__api_maintain__["a" /* default */],
  collectorPlan: __WEBPACK_IMPORTED_MODULE_15__api_collectorPlan__["a" /* default */],
  collectorGroup: __WEBPACK_IMPORTED_MODULE_10__api_collectorGroup__["a" /* default */],
  monitor: __WEBPACK_IMPORTED_MODULE_16__api_monitor__["a" /* default */],
  card: __WEBPACK_IMPORTED_MODULE_17__api_card__["a" /* default */],
  computeType: __WEBPACK_IMPORTED_MODULE_18__api_computeType__["a" /* default */],
  productionPlan: __WEBPACK_IMPORTED_MODULE_19__api_productionPlan__["a" /* default */],
  orderPlan: __WEBPACK_IMPORTED_MODULE_21__api_orderPlan__["a" /* default */],
  systemAuth: __WEBPACK_IMPORTED_MODULE_20__api_systemAuth__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_22__api_data__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Object.defineProperty(Vue.prototype, '$api', { value: Api });
  }
});

/***/ }),

/***/ "hYqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__("c3cp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24aa5397_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__("8T0R");
function injectStyle (ssrContext) {
  __webpack_require__("qYCq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24aa5397"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24aa5397_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hmAM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-page"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('Card.New_Card')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('Card.New_Card')))]):_vm._e(),_vm._v(" "),_c('Table',{staticClass:"card-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iQTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Plan',
  data: function data() {
    return {
      orderID: 0,
      collectorList: [],
      collectorID: 0,
      // selectTime: [],
      selectTime1: '',
      selectTime2: '',
      deviceColumns1: [{ title: this.$t('data.Device.name'), key: 'name', sortable: true, sortType: 'asc' }, { title: this.$t('data.Device.date'), key: 'date', sortable: true }, { title: this.$t('data.Device.group'), key: 'group', sortable: true }, { title: this.$t('data.Device.output'), key: 'output' }, { title: this.$t('data.Device.unit'), key: 'unit' }],
      deviceColumns2: [{ title: this.$t('data.Device.name'), key: 'name', sortable: true, sortType: 'asc' }, { title: this.$t('data.Device.group'), key: 'group', sortable: true }, { title: this.$t('data.Device.date'), key: 'date' },
      // { title: '货号', key: 'deviceType' },
      { title: this.$t('data.Device.runTotalTime'), key: 'runTotalTime' }, { title: this.$t('data.Device.stopTime'), key: 'stopTime' }, { title: this.$t('data.Device.stopTotalTime'), key: 'stopTotalTime' }, { title: this.$t('data.Device.error1Time'), key: 'error1Time' }, { title: this.$t('data.Device.error1TotalTime'), key: 'error1TotalTime' }, { title: this.$t('data.Device.error2Time'), key: 'error2Time' }, { title: this.$t('data.Device.error2TotalTime'), key: 'error2TotalTime' }, { title: this.$t('data.Device.error3Time'), key: 'error3Time' }, { title: this.$t('data.Device.error3TotalTime'), key: 'error3TotalTime' }, { title: this.$t('data.Device.error4Time'), key: 'error4Time' }, { title: this.$t('data.Device.error4TotalTime'), key: 'error4TotalTime' }],
      orderDatas: [],
      datas1: [],
      datas2: [],
      group: [],
      grouplist: [],
      orderList: [],
      groupname: 0,
      worktime: '',
      loading: false
    };
  },

  methods: {
    getData: function getData(tp) {
      var _this = this;

      var time2 = this.selectTime2;
      var time1 = this.selectTime1;
      if (time1 === '' || time2 === '') {
        var title = this.$t('Order.error');
        var content = this.$t('data.Device.please_enter_date');
        this.$Modal.error({
          title: title,
          content: content
        });
        return;
      }
      this.selectTime2 = new Date(new Date(this.selectTime2).getTime() + 1 * 24 * 60 * 60 * 1000);
      this.selectTime2 = this.selectTime2.getFullYear() + '-' + (this.selectTime2.getMonth() + 1) + '-' + this.selectTime2.getDate();
      this.selectTime1 = this.selectTime1 + ' ' + this.worktime;
      this.selectTime2 = this.selectTime2 + ' ';
      var collectors = [];
      if (this.groupname !== 0) {
        for (var i = 0; i < this.grouplist.length; i++) {
          if (this.groupname === this.grouplist[i].id) {
            collectors = this.grouplist[i].collectors;
          }
        }
      } else if (this.collectorID !== 0) {
        collectors.push(this.collectorID);
      }
      var req = { collectorID: collectors, startTime: this.selectTime1, endTime: this.selectTime2
        // console.log(req)
      };this.selectTime2 = time2;
      this.selectTime1 = time1;
      var ss = this.$t('data.Device.S');
      var mm = this.$t('data.Device.M');
      var hh = this.$t('data.Device.H');
      var dd = this.$t('data.Device.D');
      function formatSeconds(value) {
        var theTime = parseInt(value); // 需要转换的时间秒
        var theTime1 = 0; // 分
        var theTime2 = 0; // 小时
        var theTime3 = 0; // 天
        if (theTime > 60) {
          theTime1 = parseInt(theTime / 60);
          theTime = parseInt(theTime % 60);
          if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
            if (theTime2 > 24) {
              // 大于24小时
              theTime3 = parseInt(theTime2 / 24);
              theTime2 = parseInt(theTime2 % 24);
            }
          }
        }
        var result = '';
        if (theTime >= 0) {
          result = '' + parseInt(theTime) + ss;
        }
        if (theTime1 > 0) {
          result = '' + parseInt(theTime1) + mm + result;
        }
        if (theTime2 > 0) {
          result = '' + parseInt(theTime2) + hh + result;
        }
        if (theTime3 > 0) {
          result = '' + parseInt(theTime3) + dd + result;
        }
        return result;
      }
      var datalist = {};
      var Sumhead = ['error1Time', 'error2Time', 'error3Time', 'error4Time', 'stopTime'];
      var Timehead = ['error1TotalTime', 'error2TotalTime', 'error3TotalTime', 'error4TotalTime', 'runTotalTime', 'stopTotalTime'];
      var Temp = ['error1', 'error2', 'error3', 'error4', 'run', 'stop'];
      var name = [];
      this.datas2 = [];
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].data.collectorData(tp, req).then(function (res) {
        _this.loading = false;
        if (!res.datas) {
          return;
        }
        for (var _i = 0; _i < res.datas.length; _i++) {
          if (datalist[res.datas[_i].collectorID] === undefined) {
            datalist[res.datas[_i].collectorID] = {};
            name[res.datas[_i].collectorID] = res.datas[_i].name;
          }
          var d = datalist[res.datas[_i].collectorID];
          if (d[res.datas[_i].Date] === undefined) {
            d[res.datas[_i].Date] = {};
            for (var j = 0; j < Sumhead.length; j++) {
              d[res.datas[_i].Date][Sumhead[j]] = 0;
            }
            for (var _j = 0; _j < Timehead.length; _j++) {
              d[res.datas[_i].Date][Timehead[_j]] = 0;
            }
            d[res.datas[_i].Date].Temp = {};
            for (var _j2 = 0; _j2 < Temp.length; _j2++) {
              d[res.datas[_i].Date].Temp[Temp[_j2]] = 0;
            }
          }
          if (res.datas[_i].type === 2 || res.datas[_i].type === 7) {
            if (res.datas[_i].type === 2) {
              d[res.datas[_i].Date].stopTime++;
            }
            if (d[res.datas[_i].Date].Temp['stop'] === 0) {
              d[res.datas[_i].Date].Temp['stop'] = res.datas[_i].record;
            }
            if (d[res.datas[_i].Date].Temp['run'] !== 0) {
              d[res.datas[_i].Date]['runTotalTime'] += res.datas[_i].record - d[res.datas[_i].Date].Temp['run'];
              d[res.datas[_i].Date].Temp['run'] = 0;
            }
          }
          if (res.datas[_i].type === 1 || res.datas[_i].type === 8) {
            if (d[res.datas[_i].Date].Temp['run'] === 0) {
              d[res.datas[_i].Date].Temp['run'] = res.datas[_i].record;
            }
            if (d[res.datas[_i].Date].Temp['stop'] !== 0) {
              d[res.datas[_i].Date]['stopTotalTime'] += res.datas[_i].record - d[res.datas[_i].Date].Temp['stop'];
              d[res.datas[_i].Date].Temp['stop'] = 0;
            }
          }
          // console.log(res.datas[i])
          for (var _j3 = 0; _j3 < 4; _j3++) {
            if (res.datas[_i].type === 3 && (res.datas[_i].code & 1 << _j3) !== 0) {
              d[res.datas[_i].Date][Sumhead[_j3]]++;
            }
            if ((res.datas[_i].type === 3 || res.datas[_i].type === 5) && (res.datas[_i].code & 1 << _j3) !== 0) {
              if (d[res.datas[_i].Date].Temp[Temp[_j3]] === 0) {
                d[res.datas[_i].Date].Temp[Temp[_j3]] = res.datas[_i].record;
              }
            }
            if ((res.datas[_i].type === 4 || res.datas[_i].type === 6) && (res.datas[_i].code & 1 << _j3) !== 0) {
              if (d[res.datas[_i].Date].Temp[Temp[_j3]] !== 0) {
                d[res.datas[_i].Date][Timehead[_j3]] += res.datas[_i].record - d[res.datas[_i].Date].Temp[Temp[_j3]];
                // console.log(res.datas[i].record, Temp[j], res.datas[i].code)
                d[res.datas[_i].Date].Temp[Temp[_j3]] = 0;
              }
            }
          }
          // console.log(d, res.datas[i].collectorID)
        }
        // console.log(datalist)
        var startTime = new Date(_this.selectTime1 + ' 0:0:0').getTime();
        // let gname = ''
        for (var key in datalist) {
          for (var day in datalist[key]) {
            if (_this.groupname !== 0) {
              for (var _i2 = 0; _i2 < _this.grouplist.length; _i2++) {
                if (_this.groupname === _this.grouplist[_i2].id) {
                  // gname = this.grouplist[i].name
                }
              }
            }
            // console.log(gname, this.groupname, this.grouplist, this.group[key].indexOf(gname), this.group[key])
            // if (this.group[key].indexOf(gname) !== -1) {
            var thisTime = new Date(day).getTime();
            if (thisTime < startTime) {
              continue;
            }
            var groupname = _this.group[key] === undefined ? '' : _this.group[key];
            if (datalist[key][day]['runTotalTime'] === 300 && datalist[key][day]['stopTotalTime'] === 0) {
              datalist[key][day]['runTotalTime'] = 0;
              datalist[key][day]['stopTotalTime'] = 86400;
            }
            _this.datas2.push({
              name: name[key],
              group: groupname,
              date: day,
              runTotalTime: formatSeconds(datalist[key][day]['runTotalTime']),
              stopTime: datalist[key][day]['stopTime'],
              stopTotalTime: formatSeconds(datalist[key][day]['stopTotalTime']),
              error1Time: datalist[key][day]['error1Time'],
              error1TotalTime: formatSeconds(datalist[key][day]['error1TotalTime']),
              error2Time: datalist[key][day]['error2Time'],
              error2TotalTime: formatSeconds(datalist[key][day]['error2TotalTime']),
              error3Time: datalist[key][day]['error3Time'],
              error3TotalTime: formatSeconds(datalist[key][day]['error3TotalTime']),
              error4Time: datalist[key][day]['error4Time'],
              error4TotalTime: formatSeconds(datalist[key][day]['error4TotalTime'])
            });
            // }
          }
        }
      });
      // console.log(this.datas2)
    },

    // dateChange (t) {
    //   this.selectTime = t
    // },
    exportData: function exportData(type) {
      if (type === 1) {
        this.$refs.table1.exportCsv({
          filename: this.$t('data.Device.output_report'),
          original: false
        });
      } else if (type === 2) {
        this.$refs.table2.exportCsv({
          filename: this.$t('data.Device.run_report'),
          original: false
        });
      }
    },
    collectorSelectChange: function collectorSelectChange(v) {
      console.log(v);
      if (v !== 0) {
        this.groupname = 0;
      }
    },
    collectorGroupSelectChange: function collectorGroupSelectChange(v) {
      if (v !== 0) {
        this.collectorID = 0;
      }
    },
    entryTimeChange1: function entryTimeChange1(v) {
      this.selectTime1 = v;
    },
    entryTimeChange2: function entryTimeChange2(v) {
      this.selectTime2 = v;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collector.list().then(function (res) {
      _this2.collectorList = res.collectors;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].collectorGroup.list().then(function (res) {
      _this2.grouplist = res.collectorGroups;
      for (var i = 0; i < res.collectorGroups.length; i++) {
        for (var j = 0; j < res.collectorGroups[i].collectors.length; j++) {
          if (_this2.group[res.collectorGroups[i].collectors[j]] === undefined) {
            _this2.group[res.collectorGroups[i].collectors[j]] = res.collectorGroups[i].name;
          } else {
            _this2.group[res.collectorGroups[i].collectors[j]] = _this2.group[res.collectorGroups[i].collectors[j]] + ',' + res.collectorGroups[i].name;
          }
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workTime.list().then(function (res) {
      _this2.worktime = res.workTimes[0].startTime;
      // console.log(this.worktime)
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].order.list().then(function (res) {
      _this2.orderList = res.orderInfos;
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next();
  }
});

/***/ }),

/***/ "ib24":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j7a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("dAdn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d46839f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("L/Dm");
function injectStyle (ssrContext) {
  __webpack_require__("yCZ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d46839f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d46839f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jApH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_CN__ = __webpack_require__("jIWC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__("Vi3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN__);




var zhCn = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  menu: {
    home: '首页',
    system: '系统管理',
    system_management: {
      Role: '角色',
      Department: '部门',
      Account: '账号',
      WorkTime: '班次',
      WorkType: '工种',
      RoleEdit: '角色管理',
      DepartmentEdit: '部门编辑',
      AccountEdit: '账号编辑',
      WorkTimeEdit: '班次编辑',
      WorkTypeEdit: '工种编辑',
      systeminfo: '系统信息',
      SystemAuth: '授权管理'
    },
    Device: '设备管理',
    Device_management: {
      RouterList: '路由器',
      RouterEdit: '路由器编辑',
      Collector: '机台',
      CollectorEdit: '机台编辑',
      CollectorGroup: '机台分組',
      CollectorGroupEdit: '机台分组编辑'
    },
    Card: '卡片管理',
    CardEdit: '卡片编辑',
    People: '人员管理',
    PeopleEdit: '人员编辑',
    Product: '产品管理',
    ProductEdit: '产品编辑',
    Order: '订单管理',
    OrderEdit: '订单编辑',
    Plan: '排产管理',
    Plan_Management: {
      Production_plan: '订单计划安排',
      Production_management: '投(停)产管理',
      Production_order: '已排产订单'
    },
    Monitor: '实时监控',
    Monitor_Monitoring: {
      Collector: '机台监控',
      Order: '订单监控'
    },
    Data: '历史报表',
    Data_output: {
      Order: '订单统计',
      device: '设备统计',
      Worker: '人员统计',
      MaintainList: '维修管理',
      MaintainEdit: '维修编辑'
    },
    Setting: '个人设置'
  },
  system: {
    Account: {
      New_account: '新建账号',
      edit_account: '编辑账号',
      please_enter: '请输入',
      please_choose: '请选择',
      Return_to_account_list: '返回账号列表',
      User_name: '用户名',
      User_name_message: '请输入用户名',
      Name: '姓名',
      Name_message: '请输入姓名',
      Role: '角色',
      Role_message: '请选择角色',
      Worker_number: '工号',
      Department: '部门',
      Department_message: '请选择部门',
      Telephone: '电话',
      Email: '电子邮箱',
      QQ: 'QQ',
      Wechat: '微信',
      telephone: '电话：',
      email: '电邮：',
      qq: 'ＱＱ账号：',
      wechat: '微信账号：',
      save: '保存',
      index: '序号',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      reseat: '重設',
      error: '错误',
      error_message1: '<p>帳號重複</p>',
      error_message2: '<p>帳號重複</p>',
      delete_message: '确实要删除吗?'
    },
    Department: {
      New_Department: '新建部门',
      edit_Department: '编辑部门',
      index: '序号',
      Department: '部门',
      Authorization: '权限',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      please_enter: '请输入',
      Return_to_depatement_list: '返回部门列表',
      name: '名称',
      Move_left: '向左移动',
      Move_right: '向右移动',
      save: '保存',
      All_authorization: '全部权限',
      Department_authorization: '部门权限'
    },
    Role: {
      New_Role: '新建角色',
      edit_Role: '编辑角色',
      index: '序号',
      Role: '角色',
      Authorization: '权限',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      please_enter: '请输入',
      Return_to_role_list: '返回角色列表',
      name: '名称',
      Move_left: '向左移动',
      Move_right: '向右移动',
      save: '保存',
      All_authorization: '全部权限',
      Role_authorization: '角色权限'
    },
    workTime: {
      New_workTime: '新建班次',
      edit_workTime: '编辑班次',
      index: '序号',
      name: '名称',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      please_enter: '请输入',
      please_choose: '选择时间',
      startTime: '开始时间',
      endTime: '结束时间',
      Return_to_workTime_list: '返回班次列表',
      save: '保存'
    },
    workType: {
      New_workType: '新建工种',
      edit_workType: '编辑工种',
      index: '序号',
      name: '名称',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确实要删除吗?',
      please_enter: '请输入',
      Return_to_workType_list: '返回工种列表',
      save: '保存',
      yes: '是',
      no: '否',
      outputValid: '计算产量',
      monopoly: '独占机台',
      maintain: '维修模式',
      warn: '停机报警',
      Sorting: '排序',
      display: '显示看板',
      malfunction: '故障计算',
      remark: '备注'
    },
    SystemAuth: {
      Information: '基本信息',
      systemVersion: '系统版本:',
      systemDealTime: '到期日期:',
      please_enter: '请输入',
      save: '保存',
      save_success: '保存成功',
      systemAuthCode: '授权码:'
    },
    SystemInfo: {
      Information: '基本信息',
      Contect: '联系方式',
      systemName: '系统名称:',
      please_enter: '请输入',
      name: '企业名称:',
      contact: '联系人:',
      address: '企业地址',
      phone: '联络电话:',
      fax: '传真号码:',
      eMail: '电子邮箱:',
      save: '保存',
      save_success: '保存成功',
      warnLimitTime: '停机报警间隔:'
    }
  },
  device: {
    collector: {
      New_collector: '新建机台',
      edit_collector: '编辑机台',
      Return_to_collector_list: '返回机台列表',
      name: '名称',
      deviceNo: '编号',
      routerID: '路由器',
      type: '机器类型',
      computeType: '产能计算方式',
      roller: '滚筒',
      weft_density: '纬密',
      length: '滚筒周长',
      count: '条数',
      width: '出带宽度',
      deviceCompany: '机器制造商',
      deviceModel: '机器型号',
      buyTime: '机器购买时间',
      deviceLifeTime: '预估使用年限',
      please_enter: '请输入',
      please_enter_mm: '请输入(單位:mm)',
      save: '保存',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      error: '錯誤',
      error_message1: '<p>有資料未填寫</p>',
      error_message2: '必须整数',
      remark: '备注',
      Message: {
        name: '請輸入名稱',
        deviceNo: '請輸入編號',
        computeType: '請选择計算方式',
        routerID: '請选择所屬路由器',
        length: '請輸入滾筒周長',
        count: '請輸入條數',
        width: '請輸入出帶寬度'
      }
    },
    group: {
      New_group: '新建机器群组',
      edit_group: '编辑机器群组',
      Return_to_group_list: '返回机器群组列表',
      please_enter: '请输入',
      save: '保存',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      index: '序号',
      name: '名称',
      chosen: '已选择',
      devices: '机器',
      remark: '备注',
      width: '寬度',
      router: '路由器'
    },
    router: {
      New_router: '新建路由器',
      edit_router: '编辑路由器',
      Return_to_router_list: '返回路由器列表',
      please_enter: '请输入',
      index: '序号',
      name: '路由器代号',
      AnotherName: '路由器名称',
      linkType: '联网模式',
      channel: '讯号频道',
      remark: '备注',
      save: '保存',
      action: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      mod: '联网模式',
      Lan: '局域网',
      Internet: '互联网',
      time: '重整',
      save_success: '系统与收集器重整完毕'
    }
  },
  Card: {
    New_Card: '新建卡片',
    edit_Card: '编辑卡片',
    Return_to_Card_list: '返回卡片列表',
    please_enter: '请输入',
    index: '序号',
    userName: '持有人',
    cardNo: '卡片编号',
    workTypeName: '工种',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    delete_message: '确定要删除吗?',
    save: '保存',
    error: '錯誤',
    error_message1: '<p>卡號重複</p>',
    error_message2: '<p>有資料未填寫</p>'
  },
  Product: {
    New_Product: '新建产品',
    edit_Product: '编辑产品',
    Return_to_Product_list: '返回产品列表',
    please_enter: '请输入',
    index: '序号',
    productNo: '编号',
    name: '名称',
    latDensity: '纬密',
    kaidu: '开度',
    width: '宽度',
    specifications: '规格',
    valid: '有效',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    delete_message: '确实要删除吗?',
    save: '保存',
    error: '錯誤',
    error_message: '<p>有資料未填寫</p>',
    please_enter_mm: '请输入（单位：mm）',
    please_enter_kaidu: '请输入（≧1）',
    please_enter_latDensity: '请输入（单位：纬/cm）',
    Message: {
      productNo: '请输入产品编号',
      name: '请输入名称',
      latDensity: '请输入纬密',
      kaidu: '请输入开度',
      width: '请输入宽度'
    }
  },
  Order: {
    New_Order: '新建订单',
    edit_Order: '编辑订单',
    Return_to_Order_list: '返回订单列表',
    please_enter: '请输入',
    please_enter_date: '请输入日期',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    error: '错误',
    error_message1: '<p>未添加產品至訂單</p>',
    error_message2: '<p>訂單資訊未填</p>',
    error_message3: '<p>數量未填</p>',
    error_message4: '<p>單位未填</p>',
    error_message5: '<p>交付未填</p>',
    error_message6: '<p>请先选择左侧产品</p>',
    delete_message: '确定要删除吗?',
    change_message: '确定要反結案吗?',
    orderNo: '订单編号',
    customer: '客户',
    ordersTime: '接单日期',
    salesman: '接单业务',
    index: '序号',
    productNo: '产品编号',
    num: '数量',
    unit: '单位',
    attritionRate: '耗损率(%)',
    deliveryTime: '订单交付日期',
    remark: '备注',
    add: '添加到订单',
    Product_list: '产品列表',
    search: '编号/名称',
    No_scheduling: '未排产',
    Not_production: '未投产',
    Producting: '已投产',
    Case_closed: '已结案',
    name: '名称',
    Meter: '米',
    Yard: '码',
    Gross: '箩',
    status: '状态',
    Message: {
      orderNo: '請輸入產品編號',
      ordersTime: '請輸入接单日期',
      customer: '請輸入客户名',
      salesman: '請輸入业务员'
    }
  },
  Login: {
    username: '请输入用户名',
    password: '请输入密码',
    systemCode: '请输入系统号',
    language: '請选择语言',
    login: '登录',
    system: '系统登录',
    changePw: '修改密码',
    logout: '退出登录',
    Information: '个人信息'
  },
  ChangePw: {
    oldPassword: '输入旧密码:',
    newPassword: '输入新密码:',
    comfirmPassword: '确认新密码:',
    save: '保存',
    error: '两次密码输入不一致',
    success: '修改成功',
    ChangePw: '修改密码'
  },
  monitor: {
    Collector: {
      index: '序号',
      name: '名称',
      group: '群组',
      deviceNo: '编号',
      rpm: '机器转速',
      status: '机器状态',
      status1: '设备状态',
      error: '故障讯息',
      worker: '刷卡人员',
      workType: '刷卡状态',
      lastTime: '时间',
      timeout: '离线',
      trial: '试运行',
      standby: '待排产',
      run: '生产中',
      orderNo: '订单',
      producNo: '货号',
      stop: ' 待机',
      warp: ' 经纱 ',
      weft: ' 纬纱 ',
      thread: ' 底线 ',
      roll: ' 卷取 '
    },
    Order: {
      index: '序号',
      orderNo: '订单',
      producNo: '货号',
      salesman: '业务',
      ordersTime: '接单时间',
      output: '产量',
      num: '订单量',
      unit: '单位',
      countdata: '机台数',
      name: '名称',
      rpm: '机器转速',
      worker: '刷卡人员',
      workType: '刷卡状态',
      DailyOutput: '今日產量',
      deliveryTime: '订单交期',
      today: '今日产量',
      completed: '已生产完成',
      fastestdelivery: '预估交期',
      please_enter_date1: '订单交期起始日期',
      please_enter_date2: '订单交期结束日期',
      Meter: '米',
      Yard: '码',
      Gross: '箩'
    }
  },
  data: {
    Device: {
      name: '机台',
      date: '日期',
      group: '群組',
      output: '产量',
      unit: '单位',
      runTotalTime: '运行时间',
      stopTime: '停机次数',
      stopTotalTime: '停机时间',
      error1Time: '经纱次数',
      error1TotalTime: '经纱时间',
      error2Time: '纬纱次数',
      error2TotalTime: '纬纱时间',
      error3Time: '底纱次数',
      error3TotalTime: '底纱时间',
      error4Time: '卷曲次数',
      error4TotalTime: '卷曲时间',
      S: '秒',
      M: '分',
      H: '时',
      D: '天',
      Meter: '米',
      output_report: '产能报表',
      run_report: '运行状况报表',
      please_enter: '请选择',
      please_enter_date: '请选择日期',
      start_date: '起始日期',
      end_date: '結束日期',
      ok: '确定',
      out: '輸出',
      status: '运行状况'
    },
    Order: {
      orderNo: '订单编号',
      productNo: '货号',
      collectorName: '机台名称',
      salesman: '接单业务',
      customer: '客户',
      ordersTime: '接单时间',
      productTime: '投产时间',
      output: '实际产量',
      target: '目標产量',
      num: '订单量',
      unit: '单位',
      deliveryTime: '客户交期',
      Meter: '米',
      Yard: '码',
      Gross: '箩',
      Order_report: '订单报表',
      ok: '确定',
      out: '輸出',
      please_enter: '请选择',
      please_enter_date: '请选择日期',
      start_date: '起始日期',
      end_date: '結束日期',
      time_range: '时间段',
      No_scheduling: '未排产',
      Not_production: '未投产',
      Producting: '已投产',
      Case_closed: '已结案',
      status: '状态',
      history: '历史订单'
    }
  },
  setting: {
    Basic_Information: '基本信息',
    company_information: '公司信息',
    Contact_information: '联系方式',
    save: '保存',
    please_enter: '请输入',
    username: '用户名:',
    name: '姓名:',
    company: '公司:',
    workNo: '工号:',
    department: '部门:',
    workPosition: '职位:',
    role: '角色:',
    phone: '电话:',
    eMail: '邮箱:',
    qq: 'QQ号码:',
    wechat: '微信:',
    System_setting: '系统配置',
    language: '语言:',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: '机台筛选',
      name: '机台',
      one: '第一批',
      two: '第二批',
      three: '第三批',
      four: '第四批',
      fiv: '第五批',
      six: '第六批',
      orderNo: '订单号:',
      productNo: '产品号:',
      row: '条数:',
      delete_message: '确定是否停产?',
      yes: '投产',
      no: '停产'
    },
    Order: {
      orderNo: '订单号',
      customer: '客户',
      ordersTime: '接单日期',
      salesman: '业务员',
      index: '序号',
      productNo: '产品编号',
      num: '数量',
      unit: '单位',
      attritionRate: '耗损率(%)',
      output: '完成数',
      deliveryTime: '交付日期',
      action: '操作',
      Meter: '米',
      Yard: '码',
      Gross: '箩',
      delete_message: '确实是否结案?',
      case1: '结案',
      case2: '已结案'
    },
    Production: {
      productNo: '产品号',
      productName: '产品名称',
      deliveryTime: '客户交期',
      num: '数量',
      name: '机台名称',
      count: '条数',
      width: '宽度',
      collectorName: '机台名称',
      orderNo: '订单号',
      planIndex: '批次',
      row: '条数',
      action: '操作',
      delete: '删除',
      error: '錯誤',
      error_message: '<p>條數未选择</p>',
      planClick: '已排产计划列表',
      please_enter: '请输入',
      deviceNo: '编号',
      save: '确定',
      save1: '派单',
      save2: '插单',
      save3: '并产',
      No_scheduling: '未排产',
      Not_production: '未投产',
      Producting: '已投产',
      Case_closed: '已结案',
      status: '状态',
      no: '停产',
      delete_message: '确实要删除吗?',
      searchCollector: '机台名称',
      chooose_order: '1.选择订单',
      choose_device: '2.选择机台',
      choose_plan: '3.排产计划',
      list: '已排产计划列表',
      message: '此產品已經結案'
    }
  },
  People: {
    index: '序号',
    name: '姓名',
    workNo: '工号',
    sex: '性别',
    boy: '男',
    girl: '女',
    phone: '电话',
    entryTime: '入职时间',
    wechat: '微信号',
    qq: 'QQ号',
    working: '在职',
    working1: '在職',
    working2: '離職',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '编辑',
    edit_People: '编辑人员',
    Return_to_People_list: '返回人员列表',
    please_enter: '请输入',
    please_enter_date: '选择日期',
    save: '保存'
  },
  Maintain: {
    index: '序号',
    DeviceName: '机器名称',
    username: '操作人员',
    startTime: '开始时间',
    endTime: '结束时间',
    remark: '备注',
    action: '操作',
    edit: '编辑',
    edit_Maintain: '编辑维修记录',
    Return_to_Maintain_list: '返回维修列表',
    save: '保存',
    please_enter: '请输入',
    please_enter_date1: '开始时间起始日期',
    please_enter_date2: '开始时间结束日期'
  },
  Permission: {
    super_admin: '超级系统管理',
    system: '系统管理',
    device: '设备管理',
    card: '卡片管理',
    people: '人员管理',
    product: '产品管理',
    order: '订单管理',
    production_plan: '排产管理',
    monitor: '实时监控',
    report_export: '历史报表',
    R: '读',
    W: '写',
    RW: '读写'
  }
}, __WEBPACK_IMPORTED_MODULE_1_iview_dist_locale_zh_CN___default.a, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN___default.a);

/* harmony default export */ __webpack_exports__["a"] = (zhCn);

/***/ }),

/***/ "jUdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    row: Object
  }
});

/***/ }),

/***/ "k9Lw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kOsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleEdit_vue__ = __webpack_require__("D/GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e8b52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RoleEdit_vue__ = __webpack_require__("YJCh");
function injectStyle (ssrContext) {
  __webpack_require__("QwKs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e8b52a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e8b52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RoleEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kP8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kxng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("mjgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d2203e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("Ox8h");
function injectStyle (ssrContext) {
  __webpack_require__("k9Lw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16d2203e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d2203e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l7W0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__("SEUa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a32b1da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__("25Pp");
function injectStyle (ssrContext) {
  __webpack_require__("/a//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a32b1da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l9Z+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("HqU5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da78580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("WvoC");
function injectStyle (ssrContext) {
  __webpack_require__("PzfE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3da78580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da78580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b1a7ab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("zTZM");
function injectStyle (ssrContext) {
  __webpack_require__("NYpG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b1a7ab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workTime',
  data: function data() {
    return {
      // columns: [
      //   { type: 'index', title: this.$t('system.workTime.index') },
      //   { title: this.$t('system.workTime.name'), key: 'name' },
      //   { title: this.$t('system.workTime.startTime'), key: 'startTime' },
      //   { title: this.$t('system.workTime.endTime'), key: 'endTime' },
      //   {
      //     title: this.$t('system.workTime.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.workTime.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.workTime.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.workTime.delete'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.workTime.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small',
      //               disabled: true
      //             }
      //           }, this.$t('system.workTime.delete'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      check: true,
      permissions: false
    };
  },

  methods: {
    edit: function edit(id) {
      // id === -1 ? 0 : id
      this.$router.push({ name: 'WorkTimeEdit', params: { id: id } });
    },
    remove: function remove(id, index) {
      var _this = this;

      if (confirm(this.$t('system.workTime.delete_message'))) {
        this.$api.workTime.delete(id).then(function () {
          _this.datas.splice(index, 1);
          if (_this.datas.length < 3) {
            console.log('check');
            _this.check = true;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          _this2.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workTime.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.workTimes;
        if (vm.datas.length >= 3) {
          vm.check = false;
        }
      });
    });
  }
});

/***/ }),

/***/ "n9nU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "njEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('device.router.Return_to_router_list')))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('FormItem',{attrs:{"label":_vm.$t('device.router.AnotherName')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.router.please_enter')},model:{value:(_vm.AnotherName),callback:function ($$v) {_vm.AnotherName=$$v},expression:"AnotherName"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.router.name')}},[_c('Input',{staticClass:"info",attrs:{"disabled":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.router.channel')}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.channel},model:{value:(_vm.channel),callback:function ($$v) {_vm.channel=$$v},expression:"channel"}},_vm._l((['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']),function(i){return _c('Option',{key:i,attrs:{"value":i}},[_vm._v(_vm._s(i))])}))],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.router.remark')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.router.please_enter')},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('device.router.save')))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nv77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var account = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/account/list');
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, username: 'admin', name: 'DaviaLi', workNo: '123456', department: '人事部', workPosition: '职位', role: 'admin', phone: '12345678901', eMail: '123@qq.com', qq: '12345678', wechat: 'xxxxx'}
    //   ]
    //   resolve(data)
    // })
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/account/delete', { id: id });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/account/get', { id: id });
    // return Promise.resolve({id: 1, username: 'admin', name: 'DaviaLi', workNo: '123456', department: 1, workPosition: 2, role: 3, phone: '12345678901', eMail: '123@qq.com', qq: '12345678', wechat: 'xxxxx'})
  },
  reset: function reset(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/account/reset', { id: id });
    // return Promise.resolve({id: 1, username: 'admin', name: 'DaviaLi', workNo: '123456', department: 1, workPosition: 2, role: 3, phone: '12345678901', eMail: '123@qq.com', qq: '12345678', wechat: 'xxxxx'})
  },
  save: function save(account) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/account/save', account);
    // return Promise.resolve()
  }
};

/* harmony default export */ __webpack_exports__["a"] = (account);

/***/ }),

/***/ "o8SI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pHN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("WsRs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1d8ec8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("/4Zz");
function injectStyle (ssrContext) {
  __webpack_require__("Nnqw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1d8ec8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qC4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SideBar',
  data: function data() {
    return {};
  },

  props: ['menus', 'opened'],
  methods: {
    toggleClick: function toggleClick() {
      this.$store.dispatch('ToggleSideBar');
    }
  }
});

/***/ }),

/***/ "qYCq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "quIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_production_vue__ = __webpack_require__("ftBh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_684f8786_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_production_vue__ = __webpack_require__("7HmM");
function injectStyle (ssrContext) {
  __webpack_require__("bVxS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-684f8786"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_production_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_684f8786_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_production_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rKaM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExtraRow_vue__ = __webpack_require__("MqqH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  components: { ExtraRow: __WEBPACK_IMPORTED_MODULE_1__ExtraRow_vue__["a" /* default */] },
  data: function data() {
    return {
      // columns: [
      //   {
      //     type: 'expand',
      //     width: 50,
      //     render: (h, params) => {
      //       return h(ExtraRow, {
      //         props: {
      //           row: params.row
      //         }
      //       })
      //     }
      //   },
      //   { type: 'index', title: '序号' },
      //   { title: this.$t('system.Account.User_name'), key: 'username' },
      //   { title: this.$t('system.Account.Name'), key: 'name' },
      //   { title: this.$t('system.Account.Worker_number'), key: 'workNo' },
      //   {
      //     title: this.$t('system.Account.Department'),
      //     key: 'department',
      //     render: (h, params) => {
      //       let department = ''
      //       for (let d of this.departments) {
      //         if (d.id === params.row.department) {
      //           department = d.name
      //         }
      //       }
      //       return h('span', department)
      //     }
      //   },
      //   {
      //     title: this.$t('system.Account.Role'),
      //     key: 'role',
      //     render: (h, params) => {
      //       let role = ''
      //       for (let r of this.roles) {
      //         if (r.id === params.row.role) {
      //           role = r.name
      //           // console.log('hh')
      //         }
      //       }
      //       return h('span', role)
      //     }
      //   },
      //   {
      //     title: this.$t('system.Account.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.Account.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.reset(params.index)
      //               }
      //             }
      //           }, this.$t('system.Account.reseat')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.Account.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.Account.delete'))
      //         ])
      //       // } else if (this.permissions === true) {
      //       //   return h('div', [
      //       //     h('Button', {
      //       //       props: {
      //       //         type: 'primary',
      //       //         size: 'small'
      //       //       },
      //       //       style: {
      //       //         marginRight: '5px'
      //       //       },
      //       //       on: {
      //       //         click: () => {
      //       //           this.edit(params.index)
      //       //         }
      //       //       }
      //       //     }, this.$t('system.Account.edit')),
      //       //     h('Button', {
      //       //       props: {
      //       //         type: 'primary',
      //       //         size: 'small'
      //       //       },
      //       //       style: {
      //       //         marginRight: '5px'
      //       //       },
      //       //       on: {
      //       //         click: () => {
      //       //           this.reset(params.index)
      //       //         }
      //       //       }
      //       //     }, this.$t('system.Account.reseat'))
      //       //   ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.Account.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.Account.reseat'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      roles: [],
      departments: [],
      permissions: false
    };
  },

  methods: {
    edit: function edit(id) {
      // id === -1 ? 0 : id
      this.$router.push({ name: 'AccountEdit', params: { id: id } });
    },
    remove: function remove(id, index) {
      var _this = this;

      // console.log(index, id)
      if (confirm(this.$t('system.Account.delete_message'))) {
        this.$api.account.delete(id).then(function () {
          _this.datas.splice(index, 1);
        });
      }
    },
    reset: function reset(id) {
      // console.log(index)
      this.$api.account.reset(id).then(function () {});
    }
    // tableRowClassName (row, index) {
    //   // 把每一行的索引放进row
    //   row.index = index
    // }

  },
  mounted: function mounted() {
    var _this2 = this;

    // Api.department.list().then(res => {
    //   this.departments = res.departments
    //   for (let i = 0; i < this.datas.length; i++) {
    //     for (let j = 0; j < this.departments.length; j++) {
    //       if (this.departments[j].id === this.datas[i].department) {
    //         this.datas[i].DepartmentName = this.departments[j].name
    //       }
    //     }
    //   }
    // })
    // Api.role.list().then(res => {
    //   this.roles = res.roles
    //   for (let i = 0; i < this.datas.length; i++) {
    //     for (let j = 0; j < this.roles.length; j++) {
    //       if (this.roles[j].id === this.datas[i].role) {
    //         this.datas[i].RoleName = this.roles[j].name
    //       }
    //     }
    //   }
    // })
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          _this2.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].account.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.accounts;
        var d = [];
        for (var i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].username !== 'admin') {
            d.push(vm.datas[i]);
          }
        }
        vm.datas = d;
      });
    });
  }
});

/***/ }),

/***/ "rbi1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu-toggle"},[_c('Button',{staticClass:"toggleBtn",attrs:{"type":"text"},on:{"click":_vm.toggleClick}},[_c('Icon',{attrs:{"type":"navicon","size":"32"}})],1)],1),_vm._v(" "),_c('el-menu',{attrs:{"mode":"vertical","theme":"dark","unique-opened":"","default-active":_vm.$route.path,"collapse":!_vm.opened}},[_vm._l((_vm.menus),function(item){return [(!item.haveSubMenu)?_c('router-link',{key:item.path+'/'+item.children[0].path,attrs:{"to":item.path+'/'+item.children[0].path}},[_c('el-menu-item',{staticClass:"submenu-title-noDropdown",attrs:{"index":item.path+'/'+item.children[0].path}},[_c('Icon',{attrs:{"type":item.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.meta.title)))])],1)],1):_c('el-submenu',{key:item.path,attrs:{"index":item.path}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('Icon',{attrs:{"type":item.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.meta.title)))])],1),_vm._v(" "),_vm._l((item.children),function(child){return [(!child.hideMenu)?_c('router-link',{key:item.path+'/'+child.path,attrs:{"to":item.path+'/'+child.path}},[_c('el-menu-item',{attrs:{"index":item.path+'/'+child.path}},[_vm._v(_vm._s(_vm.$t(child.meta.title)))])],1):_vm._e()]})],2)]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rnhk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sOdG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sWHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sbs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_device_vue__ = __webpack_require__("iQTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83614b8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_device_vue__ = __webpack_require__("a0oE");
function injectStyle (ssrContext) {
  __webpack_require__("3m27")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_device_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83614b8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_device_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sk5f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sqA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("dZU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28da5f0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("9oWL");
function injectStyle (ssrContext) {
  __webpack_require__("JTfD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28da5f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28da5f0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t6H/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemInfo_vue__ = __webpack_require__("KmGw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ef8784a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SystemInfo_vue__ = __webpack_require__("xeUd");
function injectStyle (ssrContext) {
  __webpack_require__("B1Fd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ef8784a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ef8784a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SystemInfo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tNSG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tVhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WorkTimeEdit',
  data: function data() {
    return {
      id: 0,
      name: '',
      startTime: '',
      endTime: ''
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('system.workTime.New_workTime') : this.$t('system.workTime.edit_workTime');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var workTime = {
        id: this.id,
        name: this.name,
        startTime: this.startTime,
        endTime: this.endTime
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workTime.save(workTime).then(function () {
        _this.$router.push({ 'name': 'WorkTime' });
      });
    },
    startTimeChange: function startTimeChange(v) {
      this.startTime = v;
    },
    endTimeChange: function endTimeChange(v) {
      this.endTime = v;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].workTime.get(id).then(function (res) {
        next(function (vm) {
          var wt = res.workTime;
          vm.id = wt.id;
          vm.name = wt.name;
          vm.startTime = wt.startTime;
          vm.endTime = wt.endTime;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "ti4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collector-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("device.collector.Return_to_collector_list")))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"model":_vm.formValidate,"rules":_vm.ruleValidate}},[_c('FormItem',{attrs:{"label":_vm.$t('device.collector.deviceNo'),"prop":"deviceNo"}},[(_vm.formValidate.id == 0)?_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.deviceNo),callback:function ($$v) {_vm.$set(_vm.formValidate, "deviceNo", $$v)},expression:"formValidate.deviceNo"}}):_vm._e(),_vm._v(" "),(_vm.formValidate.id != 0 && _vm.check == true)?_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.deviceNo),callback:function ($$v) {_vm.$set(_vm.formValidate, "deviceNo", $$v)},expression:"formValidate.deviceNo"}}):_vm._e(),_vm._v(" "),(_vm.formValidate.id != 0 && _vm.check == false)?_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter'),"disabled":""},model:{value:(_vm.formValidate.deviceNo),callback:function ($$v) {_vm.$set(_vm.formValidate, "deviceNo", $$v)},expression:"formValidate.deviceNo"}}):_vm._e()],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.name'),"prop":"name"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.name),callback:function ($$v) {_vm.$set(_vm.formValidate, "name", $$v)},expression:"formValidate.name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.type')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.type),callback:function ($$v) {_vm.$set(_vm.formValidate, "type", $$v)},expression:"formValidate.type"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.routerID'),"prop":"routerID"}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.formValidate.routerID},on:{"on-change":_vm.routerChange},model:{value:(_vm.formValidate.routerID),callback:function ($$v) {_vm.$set(_vm.formValidate, "routerID", $$v)},expression:"formValidate.routerID"}},_vm._l((_vm.formValidate.routerList),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.AnotherName))])}))],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.computeType'),"prop":"computeType"}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.formValidate.computeType},model:{value:(_vm.formValidate.computeType),callback:function ($$v) {_vm.$set(_vm.formValidate, "computeType", $$v)},expression:"formValidate.computeType"}},_vm._l((_vm.formValidate.computeTypes),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.length'),"prop":"length"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter_mm')},model:{value:(_vm.formValidate.length),callback:function ($$v) {_vm.$set(_vm.formValidate, "length", $$v)},expression:"formValidate.length"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.count'),"prop":"count"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.count),callback:function ($$v) {_vm.$set(_vm.formValidate, "count", $$v)},expression:"formValidate.count"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.width'),"prop":"width"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter_mm')},model:{value:(_vm.formValidate.width),callback:function ($$v) {_vm.$set(_vm.formValidate, "width", $$v)},expression:"formValidate.width"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.deviceCompany')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.deviceCompany),callback:function ($$v) {_vm.$set(_vm.formValidate, "deviceCompany", $$v)},expression:"formValidate.deviceCompany"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.deviceModel')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.deviceModel),callback:function ($$v) {_vm.$set(_vm.formValidate, "deviceModel", $$v)},expression:"formValidate.deviceModel"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.buyTime')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.buyTime),callback:function ($$v) {_vm.$set(_vm.formValidate, "buyTime", $$v)},expression:"formValidate.buyTime"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.deviceLifeTime')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.deviceLifeTime),callback:function ($$v) {_vm.$set(_vm.formValidate, "deviceLifeTime", $$v)},expression:"formValidate.deviceLifeTime"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('device.collector.remark')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.please_enter')},model:{value:(_vm.formValidate.remark),callback:function ($$v) {_vm.$set(_vm.formValidate, "remark", $$v)},expression:"formValidate.remark"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("device.collector.save")))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uCnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("EJaP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5f5e14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("QDL3");
function injectStyle (ssrContext) {
  __webpack_require__("9ICA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e5f5e14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5f5e14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uJSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderEdit',
  data: function data() {
    var _this = this;

    return {
      id: 0,
      formValidate: {
        orderNo: '',
        ordersTime: '',
        customer: '',
        salesman: ''
      },
      ruleValidate: {
        orderNo: [{ required: true, message: this.$t('Order.Message.orderNo'), trigger: 'blur' }],
        ordersTime: [{ required: true, message: this.$t('Order.Message.ordersTime'), pattern: /.+/, trigger: 'blur' }],
        customer: [{ required: true, message: this.$t('Order.Message.customer'), trigger: 'change' }],
        salesman: [{ required: true, message: this.$t('Order.Message.salesman'), trigger: 'blur' }]
      },
      valid: 0,
      search: '',
      columns: [{ title: this.$t('Order.productNo'), key: 'productNo' }, { title: this.$t('Order.name'), key: 'name'
        // { title: '纬密', key: 'latDensity' },
        // { title: '宽度', key: 'width' }
      }],
      orderProductColumns: [{ title: this.$t('Order.productNo'), key: 'productNo' }, { title: this.$t('Order.name'), key: 'name' }, { title: this.$t('Order.num'), key: 'num' }, { title: this.$t('Order.unit'), key: 'unit_show' }, { title: this.$t('Order.attritionRate'), key: 'attritionRate' }, { title: this.$t('Order.deliveryTime'), key: 'deliveryTime' }, { title: this.$t('Order.remark'), key: 'remark' }, {
        title: this.$t('Order.action'),
        key: 'action',
        render: function render(h, params) {
          // console.log(params, params.row)
          if (params.row.CPValid === 1 && params.row.PPValid === 1) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {}
              }
            }, _this.$t('Order.Scheduling'))]);
          } else if (params.row.PPValid === 1) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {}
              }
            }, _this.$t('Order.Producting'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.remove(params.index);
                }
              }
            }, _this.$t('Order.delete'))]);
          }
        }
      }],
      orderProduct: [],
      products: [],
      productList: [],
      currentSelect: {},
      currentDeliveryTime: '',
      currentUnit: '',
      removeIDs: []
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('Order.New_Order') : this.$t('Order.edit_Order');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    remove: function remove(index) {
      if (this.id !== 0) {
        this.removeIDs.push(this.orderProduct[index].id);
      }
      this.orderProduct.splice(index, 1);
    },
    save: function save() {
      var _this2 = this;

      var order = void 0;
      // console.log(this.formValidate.orderNo, this.formValidate.ordersTime, this.formValidate.customer, this.formValidate.salesman, this.orderProduct.length)
      // if (this.formValidate.orderNo !== '' && this.formValidate.ordersTime !== '' && this.formValidate.customer !== '' && this.formValidate.salesman !== '' && this.orderProduct.length !== 0) {
      if (this.formValidate.orderNo !== '' && this.formValidate.ordersTime !== '' && this.orderProduct.length !== 0) {
        order = {
          OrderID: this.id,
          orderNo: this.formValidate.orderNo,
          ordersTime: this.formValidate.ordersTime,
          customer: this.formValidate.customer,
          salesman: this.formValidate.salesman,
          orderProducts: this.orderProduct,
          valid: this.valid,
          removeIDs: this.removeIDs
        };
      } else if (this.orderProduct.length === 0) {
        var title = this.$t('Order.error');
        var content = this.$t('Order.error_message1');
        this.$Modal.error({
          title: title,
          content: content
        });
      } else {
        var _title = this.$t('Order.error');
        var _content = this.$t('Order.error_message2');
        this.$Modal.error({
          title: _title,
          content: _content
        });
      }
      // console.log(order)
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].order.save(order).then(function () {
        _this2.$router.push({ 'name': 'OrderList' });
      });
    },
    ordersTimeChange: function ordersTimeChange(v) {
      this.formValidate.ordersTime = v;
    },
    deliveryTimeChange: function deliveryTimeChange(v) {
      this.currentDeliveryTime = v;
    },
    productSelect: function productSelect(current, old) {
      this.currentSelect = current;
    },
    handleSearch: function handleSearch() {
      this.products = [];
      for (var i = 0; i < this.productList.length; i++) {
        var p = this.productList[i];
        if (p.productNo.indexOf(this.search) !== -1 || p.name.indexOf(this.search) !== -1) {
          this.products.push(p);
        }
      }
    },
    handleReset: function handleReset() {
      this.products = this.productList;
    },
    add: function add() {
      if (this.currentSelect.productNo === undefined || this.currentSelect.name === undefined) {
        var title = this.$t('Order.error');
        var content = this.$t('Order.error_message6');
        this.$Modal.error({
          title: title,
          content: content
        });
        return;
      }
      if (this.currentSelect.num === undefined) {
        var _title2 = this.$t('Order.error');
        var _content2 = this.$t('Order.error_message3');
        this.$Modal.error({
          title: _title2,
          content: _content2
        });
      } else if (this.currentSelect.currentUnit === undefined) {
        var _title3 = this.$t('Order.error');
        var _content3 = this.$t('Order.error_message4');
        this.$Modal.error({
          title: _title3,
          content: _content3
        });
      } else if (this.currentDeliveryTime === '') {
        var _title4 = this.$t('Order.error');
        var _content4 = this.$t('Order.error_message5');
        this.$Modal.error({
          title: _title4,
          content: _content4
        });
      } else {
        var u = '';
        if (this.currentSelect.currentUnit === '1') {
          u = this.$t('Order.Meter');
        } else if (this.currentSelect.currentUnit === '2') {
          u = this.$t('Order.Yard');
        } else if (this.currentSelect.currentUnit === '3') {
          u = this.$t('Order.Gross');
        }
        // console.log(this.currentSelect.currentUnit, u)
        var ar = Number(this.currentSelect.attritionRate);
        var num = Number(this.currentSelect.num);
        if (ar > 0) {
          num = parseInt(num * (1 + ar / 100));
        }
        this.orderProduct.push({
          productID: this.currentSelect.id,
          productNo: this.currentSelect.productNo,
          name: this.currentSelect.name,
          unit: Number(this.currentSelect.currentUnit),
          unit_show: u,
          attritionRate: ar,
          num: num,
          color: this.currentSelect.color,
          deliveryTime: this.currentDeliveryTime,
          remark: this.currentSelect.remark
        });
      }
      // console.log(this.orderProduct)
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].product.list().then(function (res) {
      _this3.productList = res.products;
      _this3.products = res.products;
      for (var i = 0; i < _this3.products.length; i++) {
        if (_this3.products[i].valid === 0 || _this3.products[i].valid === 3) {
          _this3.products.splice(i, 1);
          i--;
        }
      }
      _this3.productList = _this3.products;
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].order.get(id).then(function (res) {
        var o = res.orderInfo;
        next(function (vm) {
          vm.id = o.orderID;
          vm.formValidate.orderNo = o.orderNo;
          vm.formValidate.ordersTime = o.ordersTime;
          vm.deliveryTime = o.deliveryTime;
          vm.formValidate.customer = o.customer;
          vm.formValidate.salesman = o.salesman;
          vm.orderProduct = o.orderProducts;
          for (var i = 0; i < vm.orderProduct.length; i++) {
            if (vm.orderProduct[i].unit === 1) {
              vm.orderProduct[i].unit_show = vm.$t('Order.Meter');
            } else if (vm.orderProduct[i].unit === 2) {
              vm.orderProduct[i].unit_show = vm.$t('Order.Yard');
            } else if (vm.orderProduct[i].unit === 3) {
              vm.orderProduct[i].unit_show = vm.$t('Order.Gross');
            }
          }
          // console.log(vm.orderProduct)
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "uoYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("system.Account.Return_to_account_list")))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100,"model":_vm.formValidate,"rules":_vm.ruleValidate}},[_c('FormItem',{attrs:{"label":_vm.$t('system.Account.User_name'),"prop":"username"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.username),callback:function ($$v) {_vm.$set(_vm.formValidate, "username", $$v)},expression:"formValidate.username"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.Name'),"prop":"name"}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.name),callback:function ($$v) {_vm.$set(_vm.formValidate, "name", $$v)},expression:"formValidate.name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.Worker_number')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.workNo),callback:function ($$v) {_vm.$set(_vm.formValidate, "workNo", $$v)},expression:"formValidate.workNo"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.Role'),"prop":"roleID"}},[_c('Select',{staticClass:"info",attrs:{"value":_vm.formValidate.roleID},model:{value:(_vm.formValidate.roleID),callback:function ($$v) {_vm.$set(_vm.formValidate, "roleID", $$v)},expression:"formValidate.roleID"}},_vm._l((_vm.formValidate.role),function(item){return _c('Option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}))],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.Telephone')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.phone),callback:function ($$v) {_vm.$set(_vm.formValidate, "phone", $$v)},expression:"formValidate.phone"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.Email')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.eMail),callback:function ($$v) {_vm.$set(_vm.formValidate, "eMail", $$v)},expression:"formValidate.eMail"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.QQ')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.qq),callback:function ($$v) {_vm.$set(_vm.formValidate, "qq", $$v)},expression:"formValidate.qq"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.Account.Wechat')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.Account.please_enter')},model:{value:(_vm.formValidate.wechat),callback:function ($$v) {_vm.$set(_vm.formValidate, "wechat", $$v)},expression:"formValidate.wechat"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.Account.save")))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uxe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RouterEdit',
  data: function data() {
    return {
      id: 0,
      name: '',
      linkType: 0,
      channel: 0,
      serverAddr: '',
      remark: '',
      AnotherName: ''
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('device.router.New_router') : this.$t('device.router.edit_router');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var channel = this.channel.charCodeAt(0);
      if (channel < 58) {
        channel = Number(channel - 48);
      } else {
        channel = Number(channel - 55);
      }
      var router = {
        id: this.id,
        name: this.name,
        linkType: this.linkType,
        channel: channel,
        serverAddr: this.serverAddr,
        remark: this.remark,
        AnotherName: this.AnotherName
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].router.save(router).then(function () {
        _this.$router.push({ 'name': 'RouterList' });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = to.params.id;
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].router.get(id).then(function (res) {
        var r = res.router;
        next(function (vm) {
          vm.id = r.id;
          vm.name = r.name;
          vm.linkType = r.linkType;
          if (r.channel < 10) {
            vm.channel = String.fromCharCode(r.channel + 48);
          } else {
            vm.channel = String.fromCharCode(r.channel + 55);
          }
          vm.serverAddr = r.serverAddr;
          vm.remark = r.remark;
          vm.AnotherName = r.AnotherName;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "vMJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var user = {
  login: function login(username, password, systemCode) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/login', { username: username, password: password, systemCode: systemCode });
  },
  fetchUserInfo: function fetchUserInfo() {
    // return Promise.resolve({
    //   user: {
    //     username: 'admin',
    //     name: 'DaviaLi',
    //     workNo: '7713',
    //     department: '研发部',
    //     workPosition: '工程师',
    //     role: '管理员',
    //     phone: '13800138000',
    //     eMail: '11111@qq.com',
    //     qq: '11111',
    //     wechat: 'wechat1111'
    //   },
    //   company: { name: '心恬电子', lang: 'zh' },
    //   permissions: []
    // })

    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/fetchUserInfo');
  },
  changePw: function changePw(oldPassword, newPassword) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/changePw', { oldPassword: oldPassword, newPassword: newPassword });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "vP06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChangePw',
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      comfirmPassword: ''
    };
  },
  mounted: function mounted() {
    this.$Message.config({
      top: 80,
      duration: 2
    });
  },

  methods: {
    save: function save() {
      var _this = this;

      if (this.newPassword !== this.comfirmPassword) {
        this.$Message.error(this.$t('ChangePw.error'));
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.changePw(this.oldPassword, this.newPassword).then(function (res) {
        _this.$Message.success(_this.$t('ChangePw.success'));
      });
    }
  }
});

/***/ }),

/***/ "vWCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log('test');
    setTimeout(function () {
      next();
    }, 300);
  }
});

/***/ }),

/***/ "vZz+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var permission = {
  permissionList: function permissionList() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = {
        super_admin: '超级系统管理',
        system: '系统管理',
        device: '设备管理',
        card: '卡片管理',
        people: '人员管理',
        product: '产品管理',
        order: '订单管理',
        production_plan: '生产计划管理',
        monitor: '实时监控',
        report_export: '报表输出'
      };
      resolve(data);
    });
  },
  permissionValue: function permissionValue(value) {
    if (value === 1) {
      return '读';
    } else if (value === 2) {
      return '写';
    } else {
      return '读写';
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ "vuLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppMain',
  created: function created() {
    this.getBreadcrumb();
  },
  data: function data() {
    return {
      levelList: null
    };
  },

  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var matched = this.$route.matched.filter(function (item) {
        return item.meta.title;
      });
      var first = matched[0];
      if (first && (first.meta.title !== 'menu.home' || first.path !== '')) {
        matched = [{ meta: { title: 'menu.home' }, path: '/' }].concat(matched);
      }
      this.levelList = matched;
    }
  },
  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  }
});

/***/ }),

/***/ "w0sC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-time-edit-page"},[_c('Button',{attrs:{"type":"primary","icon":"ios-arrow-back"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("system.workTime.Return_to_workTime_list")))]),_vm._v(" "),_c('Card',{staticClass:"edit-card"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Form',{staticClass:"edit-form",attrs:{"label-width":100}},[_c('FormItem',{attrs:{"label":_vm.$t('system.workTime.name')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.workTime.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workTime.startTime')}},[_c('TimePicker',{staticClass:"info",attrs:{"value":_vm.startTime,"format":"HH:mm","placeholder":_vm.$t('system.workTime.please_choose')},on:{"on-change":_vm.startTimeChange}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.workTime.endTime')}},[_c('TimePicker',{staticClass:"info",attrs:{"value":_vm.endTime,"format":"HH:mm","placeholder":_vm.$t('system.workTime.please_choose')},on:{"on-change":_vm.endTimeChange}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.workTime.save")))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w61F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-page"},[_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t('Order.New_Order')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('i-Col',{attrs:{"span":"5"}},[_c('Select',{staticClass:"text",attrs:{"value":_vm.Valid},model:{value:(_vm.Valid),callback:function ($$v) {_vm.Valid=$$v},expression:"Valid"}},[_c('Option',{key:"1",attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('Order.No_scheduling')))]),_vm._v(" "),_c('Option',{key:"2",attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('Order.Not_production')))]),_vm._v(" "),_c('Option',{key:"3",attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('Order.Producting')))]),_vm._v(" "),_c('Option',{key:"4",attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.$t('Order.Case_closed')))])],1)],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"5"}},[_c('Input',{staticClass:"search",attrs:{"placeholder":_vm.$t('Order.orderNo')},model:{value:(_vm.search1),callback:function ($$v) {_vm.search1=$$v},expression:"search1"}})],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"5"}},[_c('Input',{staticClass:"search",attrs:{"placeholder":_vm.$t('Order.customer')},model:{value:(_vm.search2),callback:function ($$v) {_vm.search2=$$v},expression:"search2"}})],1),_vm._v(" "),_c('i-Col',{attrs:{"span":"6"}},[_c('Input',{staticClass:"search",attrs:{"placeholder":_vm.$t('Order.salesman')},model:{value:(_vm.search3),callback:function ($$v) {_vm.search3=$$v},expression:"search3"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),(_vm.datas.length === 0)?_c('br'):_vm._e(),_vm._v(" "),_vm._l((_vm.datas),function(order,index){return _c('Card',{key:order.orderID,staticClass:"order-card"},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_c('Row',[_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('Order.orderNo'))+":"+_vm._s(order.orderNo))]),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('Order.customer'))+":"+_vm._s(order.customer))]),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('Order.ordersTime'))+":"+_vm._s(order.ordersTime))]),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.$t('Order.salesman'))+":"+_vm._s(order.salesman))]),_vm._v(" "),_c('Col',{attrs:{"span":"4"}},[(_vm.permissions === true && order.Ordervalid === 1)?_c('Button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.edit(order.orderID)}}},[_vm._v(_vm._s(_vm.$t('Order.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true || order.Ordervalid === 0)?_c('Button',{attrs:{"size":"small","type":"primary","disabled":""},on:{"click":function($event){_vm.edit(order.orderID)}}},[_vm._v(_vm._s(_vm.$t('Order.edit')))]):_vm._e(),_vm._v(" "),(_vm.permissions === true && order.check === 0 && order.Ordervalid === 1)?_c('Button',{attrs:{"size":"small","type":"error"},on:{"click":function($event){_vm.remove(index)}}},[_vm._v(_vm._s(_vm.$t('Order.delete')))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true || order.check === 1)?_c('Button',{attrs:{"size":"small","type":"error","disabled":""},on:{"click":function($event){_vm.remove(index)}}},[_vm._v(_vm._s(_vm.$t('Order.delete')))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('Table',{staticClass:"order-table",attrs:{"size":"small","highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":order.orderProducts}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wvGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Card',
  data: function data() {
    var _this = this;

    return {
      columns: [{ type: 'index', title: this.$t('Card.index'), width: 65 }, { title: this.$t('Card.userName'), key: 'userName', sortable: true, sortType: 'asc' }, { title: this.$t('Card.cardNo'), key: 'cardNo', sortable: true }, { title: this.$t('Card.workTypeName'), key: 'workTypeName', sortable: true }, {
        title: this.$t('Card.action'),
        key: 'action',
        width: 125,
        render: function render(h, params) {
          if (_this.permissions) {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this.edit(params.index);
                }
              }
            }, _this.$t('Card.edit')), h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              on: {
                click: function click() {
                  if (confirm(_this.$t('Card.delete_message'))) {
                    _this.remove(params.index);
                  }
                }
              }
            }, _this.$t('Card.delete'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: true
              },
              style: {
                marginRight: '5px'
              }
            }, _this.$t('Card.edit')), h('Button', {
              props: {
                type: 'error',
                size: 'small',
                disabled: true
              }
            }, _this.$t('Card.delete'))]);
          }
        }
      }],
      datas: [],
      permissions: false
    };
  },

  computed: {},
  methods: {
    edit: function edit(index) {
      var id = index === -1 ? 0 : this.datas[index].id;
      this.$router.push({ name: 'CardEdit', params: { id: id } });
    },
    remove: function remove(index) {
      var _this2 = this;

      this.$api.card.delete(this.datas[index].id).then(function () {
        _this2.datas.splice(index, 1);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].user.fetchUserInfo().then(function (res) {
      for (var i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'card' && res.user.permissions[i].value === 3) {
          _this3.permissions = true;
        }
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].card.list().then(function (res) {
      next(function (vm) {
        vm.datas = res.cards;
      });
    });
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xeUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-info-page"},[_c('Form',{attrs:{"label-width":100}},[_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t("system.SystemInfo.Information")))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.systemName')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.systemName),callback:function ($$v) {_vm.systemName=$$v},expression:"systemName"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.name')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"fielset"},[_c('h3',[_vm._v(_vm._s(_vm.$t("system.SystemInfo.Contect")))]),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.contact')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.address')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.phone')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.fax')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.fax),callback:function ($$v) {_vm.fax=$$v},expression:"fax"}})],1),_vm._v(" "),_c('FormItem',{attrs:{"label":_vm.$t('system.SystemInfo.eMail')}},[_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('system.SystemInfo.please_enter')},model:{value:(_vm.eMail),callback:function ($$v) {_vm.eMail=$$v},expression:"eMail"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"save-btn"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.SystemInfo.save")))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","disabled":""},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("system.SystemInfo.save")))]):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xelB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collector-page"},[(_vm.permissions === true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round"},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t("device.collector.New_collector")))]):_vm._e(),_vm._v(" "),(_vm.permissions !== true)?_c('Button',{attrs:{"type":"primary","icon":"plus-round","disabled":""},on:{"click":function($event){_vm.edit(-1)}}},[_vm._v(_vm._s(_vm.$t("device.collector.New_collector")))]):_vm._e(),_vm._v(" "),_c('Input',{staticClass:"info",attrs:{"placeholder":_vm.$t('device.collector.name')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('Button',{attrs:{"slot":"append","icon":"ios-search"},on:{"click":function($event){_vm.handleSearch()}},slot:"append"}),_vm._v(" "),_c('Button',{attrs:{"slot":"append","icon":"refresh"},on:{"click":function($event){_vm.handleReset()}},slot:"append"})],1),_vm._v(" "),_c('Table',{staticClass:"collector-table",attrs:{"highlight-row":"","stripe":"","border":"","columns":_vm.columns,"data":_vm.datas}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xzhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("Euhe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43bac170_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("3BQY");
function injectStyle (ssrContext) {
  __webpack_require__("WLYZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43bac170_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y13K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductEdit',
  data: function data() {
    return {
      formValidate: {
        id: 0,
        productNo: '',
        name: '',
        latDensity: '',
        // density: '',
        kaidu: '',
        width: '',
        currentUnit: '',
        attritionRate: '',
        specifications: '',
        image: '',
        valid: 1,
        sum: ''
      },
      ruleValidate: {
        productNo: [{ required: true, message: this.$t('Product.Message.productNo'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('Product.Message.name'), trigger: 'blur' }],
        latDensity: [{ required: true, message: this.$t('Product.Message.latDensity'), trigger: 'blur' }],
        kaidu: [{ required: true, message: this.$t('Product.Message.kaidu'), trigger: 'blur' }],
        width: [{ required: true, message: this.$t('Product.Message.width'), trigger: 'blur' }]
        // sum: [
        //   { required: true, message: '請輸入產量', trigger: 'blur' }
        // ],
        // unit: [
        //   { required: true, message: '選擇單位', pattern: /.+/, trigger: 'change' }
        // ]
      }
    };
  },

  computed: {
    title: function title() {
      return this.id === 0 ? this.$t('Product.New_Product') : this.$t('Product.edit_Product');
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    save: function save() {
      var _this = this;

      var product = void 0;
      if (this.formValidate.productNo !== '' && this.formValidate.name !== '' && this.formValidate.latDensity !== '' && this.formValidate.kaidu !== '' && this.formValidate.width !== '') {
        product = {
          id: this.formValidate.id,
          productNo: this.formValidate.productNo,
          name: this.formValidate.name,
          // unit: this.formValidate.currentUnit,
          // attritionRate: Number(this.formValidate.attritionRate),
          latDensity: Number(this.formValidate.latDensity),
          // density: Number(this.formValidate.density),
          kaidu: Number(this.formValidate.kaidu),
          width: Number(this.formValidate.width),
          specifications: this.formValidate.specifications,
          // image: this.image,
          valid: Number(this.formValidate.valid)
        };
        __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].product.save(product).then(function () {
          _this.$router.push({ 'name': 'ProductList' });
        });
      } else {
        var title = this.$t('Product.error');
        var content = this.$t('Product.error_message');
        this.$Modal.error({
          title: title,
          content: content
        });
      }
    },
    uploadSuccess: function uploadSuccess(res, file) {
      this.image = res.url;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var id = Number(to.params.id);
    if (id !== 0) {
      __WEBPACK_IMPORTED_MODULE_0__api__["b" /* Api */].product.get(id).then(function (res) {
        var p = res.product;
        next(function (vm) {
          vm.formValidate.id = p.id;
          vm.formValidate.productNo = p.productNo;
          vm.formValidate.name = p.name;
          vm.formValidate.latDensity = p.latDensity;
          // vm.formValidate.density = p.density
          vm.formValidate.kaidu = p.kaidu;
          vm.formValidate.width = p.width;
          // vm.formValidate.unit = p.unit
          // vm.formValidate.attritionRate = p.attritionRate
          vm.formValidate.specifications = p.specifications;
          // vm.formValidate.image = p.image
          vm.formValidate.valid = p.valid;
        });
      });
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "yCZ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z64l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__ = __webpack_require__("4dEq");


var collectorPlan = {
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].get('/collectorPlan/list');
  },
  production: function production(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collectorPlan/production', { id: id });
  },
  productionStop: function productionStop(id) {
    return __WEBPACK_IMPORTED_MODULE_0__libs_AxiosPlugin__["a" /* default */].post('/collectorPlan/productionStop', { id: id });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (collectorPlan);

/***/ }),

/***/ "zBR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('p',[_c('img',{attrs:{"width":"150","src":__webpack_require__("7Otq")}})]),_vm._v(" "),_c('h2',{staticClass:"is-title is-bold"},[_c('strong',[_vm._v("E-Weaving 管理平台")])]),_vm._v(" "),_c('p',[_vm._v("E-WEAVING Operations Management Platform")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('Form',{ref:"formCustom",staticClass:"login-form",attrs:{"model":_vm.loginForm}},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Login.system')))]),_vm._v(" "),_c('FormItem',{attrs:{"prop":"passwd"}},[_c('Input',{attrs:{"type":"text","placeholder":_vm.$t('Login.username')},model:{value:(_vm.loginForm.username),callback:function ($$v) {_vm.$set(_vm.loginForm, "username", $$v)},expression:"loginForm.username"}},[_c('Icon',{attrs:{"slot":"prepend","type":"android-person"},slot:"prepend"})],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"prop":"passwdCheck"}},[_c('Input',{attrs:{"type":"password","placeholder":_vm.$t('Login.password')},model:{value:(_vm.loginForm.password),callback:function ($$v) {_vm.$set(_vm.loginForm, "password", $$v)},expression:"loginForm.password"}},[_c('Icon',{attrs:{"slot":"prepend","type":"android-lock"},slot:"prepend"})],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"prop":"passwdCheck"}},[_c('Input',{attrs:{"type":"text","placeholder":_vm.$t('Login.systemCode')},model:{value:(_vm.loginForm.systemCode),callback:function ($$v) {_vm.$set(_vm.loginForm, "systemCode", $$v)},expression:"loginForm.systemCode"}},[_c('Icon',{attrs:{"slot":"prepend","type":"ios-world"},slot:"prepend"})],1)],1),_vm._v(" "),_c('FormItem',[_c('Select',{attrs:{"type":"text","placeholder":_vm.$t('Login.language')},on:{"on-change":_vm.Changelanguage}},[_c('Option',{key:"zh-cn",attrs:{"value":"zh-cn"}},[_vm._v(_vm._s(_vm.$t('setting.zhcn')))]),_vm._v(" "),_c('Option',{key:"en-US",attrs:{"value":"en-US"}},[_vm._v(_vm._s(_vm.$t('setting.enUS')))]),_vm._v(" "),_c('Option',{key:"zh-tw",attrs:{"value":"zh-tw"}},[_vm._v(_vm._s(_vm.$t('setting.zhtw')))]),_vm._v(" "),_c('Option',{key:"ja-JP",attrs:{"value":"ja-JP"}},[_vm._v(_vm._s(_vm.$t('setting.jaJP')))]),_vm._v(" "),_c('Option',{key:"vi-VN",attrs:{"value":"vi-VN"}},[_vm._v(_vm._s(_vm.$t('setting.viVN')))]),_vm._v(" "),_c('Option',{key:"th-TH",attrs:{"value":"th-TH"}},[_vm._v(_vm._s(_vm.$t('setting.thTH')))])],1)],1),_vm._v(" "),_c('FormItem',[_c('Button',{attrs:{"type":"primary","long":""},nativeOn:{"click":function($event){$event.preventDefault();_vm.handleLogin($event)}}},[_vm._v(_vm._s(_vm.$t('Login.login')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zszO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.048c0eb23907de30d78a.js